
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1b2a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1b2a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jFoOd", function(module, exports) {

$parcel$export(module.exports, "initGrainClipping", () => $a076ce05121bbdbc$export$c6925676860fcd28);
/** Matches $grain-tile-size in vars.scss (256px asset × 1.5). */ const $a076ce05121bbdbc$var$GRAIN_TILE_SIZE = 384;
let $a076ce05121bbdbc$var$grainClipBound = false;
let $a076ce05121bbdbc$var$grainClipSettleScheduled = false;
let $a076ce05121bbdbc$var$grainClipResizeObserver = null;
function $a076ce05121bbdbc$var$qs(selector) {
    return document.querySelector(selector);
}
function $a076ce05121bbdbc$var$throttle(fn, delay) {
    let last = 0;
    let timeout;
    return ()=>{
        const now = Date.now();
        const sinceLast = now - last;
        clearTimeout(timeout);
        if (sinceLast > delay) {
            last = now;
            fn();
        } else timeout = setTimeout(()=>{
            last = Date.now();
            fn();
        }, delay - sinceLast);
    };
}
function $a076ce05121bbdbc$export$c6925676860fcd28() {
    $a076ce05121bbdbc$export$9d895f3c9e4e9772();
    $a076ce05121bbdbc$var$scheduleGrainClipSettle();
    if (!$a076ce05121bbdbc$var$grainClipBound) {
        $a076ce05121bbdbc$var$grainClipBound = true;
        $a076ce05121bbdbc$var$bindGrainClipListeners();
    }
}
function $a076ce05121bbdbc$var$bindGrainClipListeners() {
    const reclip = $a076ce05121bbdbc$var$throttle($a076ce05121bbdbc$export$9d895f3c9e4e9772, 100);
    window.addEventListener("resize", reclip);
    $a076ce05121bbdbc$var$grainClipResizeObserver = new ResizeObserver(reclip);
    const grain = $a076ce05121bbdbc$var$qs(".grain-layer");
    if (grain) $a076ce05121bbdbc$var$grainClipResizeObserver.observe(grain);
    document.querySelectorAll("section.splitter").forEach((splitter)=>{
        $a076ce05121bbdbc$var$grainClipResizeObserver.observe(splitter);
    });
}
/** One follow-up pass after fonts/layout settle (avoids triple init reclipping). */ function $a076ce05121bbdbc$var$scheduleGrainClipSettle() {
    if ($a076ce05121bbdbc$var$grainClipSettleScheduled) return;
    $a076ce05121bbdbc$var$grainClipSettleScheduled = true;
    const settle = ()=>{
        $a076ce05121bbdbc$var$grainClipSettleScheduled = false;
        requestAnimationFrame($a076ce05121bbdbc$export$9d895f3c9e4e9772);
    };
    if (document.fonts?.ready) document.fonts.ready.then(settle).catch(settle);
    else window.addEventListener("load", settle, {
        once: true
    });
}
function $a076ce05121bbdbc$export$9d895f3c9e4e9772() {
    const grain = $a076ce05121bbdbc$var$qs(".grain-layer");
    const splitters = Array.from(document.querySelectorAll("section.splitter"));
    if (!grain) return;
    if (splitters.length === 0) {
        grain.style.clipPath = "none";
        return;
    }
    const grainRect = grain.getBoundingClientRect();
    const w = $a076ce05121bbdbc$var$grainPathCoord(grainRect.width);
    const h = $a076ce05121bbdbc$var$grainPathCoord(grainRect.height);
    let path = `M 0 0 H ${w} V ${h} H 0 Z`;
    for (const splitter of splitters){
        const el = splitter;
        const band = $a076ce05121bbdbc$var$splitterGrainBand(el, grainRect);
        const bandTop = $a076ce05121bbdbc$var$grainPathCoord(band.top);
        const bandBottom = $a076ce05121bbdbc$var$grainPathCoord(band.bottom);
        path += ` M 0 ${bandTop} H ${w} V ${bandBottom} H 0 Z`;
        el.style.setProperty("--grain-bg-y", `${$a076ce05121bbdbc$var$grainPhaseOffset(bandTop)}px`);
    }
    grain.style.clipPath = `path(evenodd, '${path}')`;
}
/** Top/bottom of splitter ::after grain (border box) in .grain-layer coordinates. */ function $a076ce05121bbdbc$var$splitterGrainBand(splitter, grainRect) {
    const rect = splitter.getBoundingClientRect();
    return {
        top: rect.top - grainRect.top,
        bottom: rect.bottom - grainRect.top
    };
}
/** Stable subpixel coords for SVG clip paths (avoids floor/ceil seam gaps). */ function $a076ce05121bbdbc$var$grainPathCoord(value) {
    return Math.round(value * 100) / 100;
}
/** Aligns a splitter ::after tile phase with the page-wide grain layer. */ function $a076ce05121bbdbc$var$grainPhaseOffset(docY) {
    const mod = (docY % $a076ce05121bbdbc$var$GRAIN_TILE_SIZE + $a076ce05121bbdbc$var$GRAIN_TILE_SIZE) % $a076ce05121bbdbc$var$GRAIN_TILE_SIZE;
    return -mod;
}

});

var $3662ed097e2b5ad0$exports = {};
/**
 * chroma.js - JavaScript library for color conversions
 *
 * Copyright (c) 2011-2019, Gregor Aisch
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 * list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * 3. The name Gregor Aisch may not be used to endorse or promote products
 * derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL GREGOR AISCH OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 * INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
 * OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 * EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * -------------------------------------------------------
 *
 * chroma.js includes colors from colorbrewer2.org, which are released under
 * the following license:
 *
 * Copyright (c) 2002 Cynthia Brewer, Mark Harrower,
 * and The Pennsylvania State University.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND,
 * either express or implied. See the License for the specific
 * language governing permissions and limitations under the License.
 *
 * ------------------------------------------------------
 *
 * Named colors are taken from X11 Color Names.
 * http://www.w3.org/TR/css3-color/#svg-color
 *
 * @preserve
 */ (function(global, factory) {
    $3662ed097e2b5ad0$exports = factory();
})($3662ed097e2b5ad0$exports, function() {
    "use strict";
    var limit$2 = function(x, min, max) {
        if (min === void 0) min = 0;
        if (max === void 0) max = 1;
        return x < min ? min : x > max ? max : x;
    };
    var limit$1 = limit$2;
    var clip_rgb$3 = function(rgb) {
        rgb._clipped = false;
        rgb._unclipped = rgb.slice(0);
        for(var i = 0; i <= 3; i++){
            if (i < 3) {
                if (rgb[i] < 0 || rgb[i] > 255) rgb._clipped = true;
                rgb[i] = limit$1(rgb[i], 0, 255);
            } else if (i === 3) rgb[i] = limit$1(rgb[i], 0, 1);
        }
        return rgb;
    };
    // ported from jQuery's $.type
    var classToType = {};
    for(var i$1 = 0, list$1 = [
        "Boolean",
        "Number",
        "String",
        "Function",
        "Array",
        "Date",
        "RegExp",
        "Undefined",
        "Null"
    ]; i$1 < list$1.length; i$1 += 1){
        var name = list$1[i$1];
        classToType["[object " + name + "]"] = name.toLowerCase();
    }
    var type$p = function(obj) {
        return classToType[Object.prototype.toString.call(obj)] || "object";
    };
    var type$o = type$p;
    var unpack$B = function(args, keyOrder) {
        if (keyOrder === void 0) keyOrder = null;
        // if called with more than 3 arguments, we return the arguments
        if (args.length >= 3) return Array.prototype.slice.call(args);
        // with less than 3 args we check if first arg is object
        // and use the keyOrder string to extract and sort properties
        if (type$o(args[0]) == "object" && keyOrder) return keyOrder.split("").filter(function(k) {
            return args[0][k] !== undefined;
        }).map(function(k) {
            return args[0][k];
        });
        // otherwise we just return the first argument
        // (which we suppose is an array of args)
        return args[0];
    };
    var type$n = type$p;
    var last$4 = function(args) {
        if (args.length < 2) return null;
        var l = args.length - 1;
        if (type$n(args[l]) == "string") return args[l].toLowerCase();
        return null;
    };
    var PI$2 = Math.PI;
    var utils = {
        clip_rgb: clip_rgb$3,
        limit: limit$2,
        type: type$p,
        unpack: unpack$B,
        last: last$4,
        PI: PI$2,
        TWOPI: PI$2 * 2,
        PITHIRD: PI$2 / 3,
        DEG2RAD: PI$2 / 180,
        RAD2DEG: 180 / PI$2
    };
    var input$h = {
        format: {},
        autodetect: []
    };
    var last$3 = utils.last;
    var clip_rgb$2 = utils.clip_rgb;
    var type$m = utils.type;
    var _input = input$h;
    var Color$D = function Color() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var me = this;
        if (type$m(args[0]) === "object" && args[0].constructor && args[0].constructor === this.constructor) // the argument is already a Color instance
        return args[0];
        // last argument could be the mode
        var mode = last$3(args);
        var autodetect = false;
        if (!mode) {
            autodetect = true;
            if (!_input.sorted) {
                _input.autodetect = _input.autodetect.sort(function(a, b) {
                    return b.p - a.p;
                });
                _input.sorted = true;
            }
            // auto-detect format
            for(var i = 0, list = _input.autodetect; i < list.length; i += 1){
                var chk = list[i];
                mode = chk.test.apply(chk, args);
                if (mode) break;
            }
        }
        if (_input.format[mode]) {
            var rgb = _input.format[mode].apply(null, autodetect ? args : args.slice(0, -1));
            me._rgb = clip_rgb$2(rgb);
        } else throw new Error("unknown format: " + args);
        // add alpha channel
        if (me._rgb.length === 3) me._rgb.push(1);
    };
    Color$D.prototype.toString = function toString() {
        if (type$m(this.hex) == "function") return this.hex();
        return "[" + this._rgb.join(",") + "]";
    };
    var Color_1 = Color$D;
    var chroma$k = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(chroma$k.Color, [
            null
        ].concat(args)));
    };
    chroma$k.Color = Color_1;
    chroma$k.version = "2.4.2";
    var chroma_1 = chroma$k;
    var unpack$A = utils.unpack;
    var max$2 = Math.max;
    var rgb2cmyk$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$A(args, "rgb");
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        r = r / 255;
        g = g / 255;
        b = b / 255;
        var k = 1 - max$2(r, max$2(g, b));
        var f = k < 1 ? 1 / (1 - k) : 0;
        var c = (1 - r - k) * f;
        var m = (1 - g - k) * f;
        var y = (1 - b - k) * f;
        return [
            c,
            m,
            y,
            k
        ];
    };
    var rgb2cmyk_1 = rgb2cmyk$1;
    var unpack$z = utils.unpack;
    var cmyk2rgb = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$z(args, "cmyk");
        var c = args[0];
        var m = args[1];
        var y = args[2];
        var k = args[3];
        var alpha = args.length > 4 ? args[4] : 1;
        if (k === 1) return [
            0,
            0,
            0,
            alpha
        ];
        return [
            c >= 1 ? 0 : 255 * (1 - c) * (1 - k),
            m >= 1 ? 0 : 255 * (1 - m) * (1 - k),
            y >= 1 ? 0 : 255 * (1 - y) * (1 - k),
            alpha
        ];
    };
    var cmyk2rgb_1 = cmyk2rgb;
    var chroma$j = chroma_1;
    var Color$C = Color_1;
    var input$g = input$h;
    var unpack$y = utils.unpack;
    var type$l = utils.type;
    var rgb2cmyk = rgb2cmyk_1;
    Color$C.prototype.cmyk = function() {
        return rgb2cmyk(this._rgb);
    };
    chroma$j.cmyk = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$C, [
            null
        ].concat(args, [
            "cmyk"
        ])));
    };
    input$g.format.cmyk = cmyk2rgb_1;
    input$g.autodetect.push({
        p: 2,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$y(args, "cmyk");
            if (type$l(args) === "array" && args.length === 4) return "cmyk";
        }
    });
    var unpack$x = utils.unpack;
    var last$2 = utils.last;
    var rnd = function(a) {
        return Math.round(a * 100) / 100;
    };
    /*
     * supported arguments:
     * - hsl2css(h,s,l)
     * - hsl2css(h,s,l,a)
     * - hsl2css([h,s,l], mode)
     * - hsl2css([h,s,l,a], mode)
     * - hsl2css({h,s,l,a}, mode)
     */ var hsl2css$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var hsla = unpack$x(args, "hsla");
        var mode = last$2(args) || "lsa";
        hsla[0] = rnd(hsla[0] || 0);
        hsla[1] = rnd(hsla[1] * 100) + "%";
        hsla[2] = rnd(hsla[2] * 100) + "%";
        if (mode === "hsla" || hsla.length > 3 && hsla[3] < 1) {
            hsla[3] = hsla.length > 3 ? hsla[3] : 1;
            mode = "hsla";
        } else hsla.length = 3;
        return mode + "(" + hsla.join(",") + ")";
    };
    var hsl2css_1 = hsl2css$1;
    var unpack$w = utils.unpack;
    /*
     * supported arguments:
     * - rgb2hsl(r,g,b)
     * - rgb2hsl(r,g,b,a)
     * - rgb2hsl([r,g,b])
     * - rgb2hsl([r,g,b,a])
     * - rgb2hsl({r,g,b,a})
     */ var rgb2hsl$3 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$w(args, "rgba");
        var r = args[0];
        var g = args[1];
        var b = args[2];
        r /= 255;
        g /= 255;
        b /= 255;
        var min = Math.min(r, g, b);
        var max = Math.max(r, g, b);
        var l = (max + min) / 2;
        var s, h;
        if (max === min) {
            s = 0;
            h = Number.NaN;
        } else s = l < 0.5 ? (max - min) / (max + min) : (max - min) / (2 - max - min);
        if (r == max) h = (g - b) / (max - min);
        else if (g == max) h = 2 + (b - r) / (max - min);
        else if (b == max) h = 4 + (r - g) / (max - min);
        h *= 60;
        if (h < 0) h += 360;
        if (args.length > 3 && args[3] !== undefined) return [
            h,
            s,
            l,
            args[3]
        ];
        return [
            h,
            s,
            l
        ];
    };
    var rgb2hsl_1 = rgb2hsl$3;
    var unpack$v = utils.unpack;
    var last$1 = utils.last;
    var hsl2css = hsl2css_1;
    var rgb2hsl$2 = rgb2hsl_1;
    var round$6 = Math.round;
    /*
     * supported arguments:
     * - rgb2css(r,g,b)
     * - rgb2css(r,g,b,a)
     * - rgb2css([r,g,b], mode)
     * - rgb2css([r,g,b,a], mode)
     * - rgb2css({r,g,b,a}, mode)
     */ var rgb2css$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var rgba = unpack$v(args, "rgba");
        var mode = last$1(args) || "rgb";
        if (mode.substr(0, 3) == "hsl") return hsl2css(rgb2hsl$2(rgba), mode);
        rgba[0] = round$6(rgba[0]);
        rgba[1] = round$6(rgba[1]);
        rgba[2] = round$6(rgba[2]);
        if (mode === "rgba" || rgba.length > 3 && rgba[3] < 1) {
            rgba[3] = rgba.length > 3 ? rgba[3] : 1;
            mode = "rgba";
        }
        return mode + "(" + rgba.slice(0, mode === "rgb" ? 3 : 4).join(",") + ")";
    };
    var rgb2css_1 = rgb2css$1;
    var unpack$u = utils.unpack;
    var round$5 = Math.round;
    var hsl2rgb$1 = function() {
        var assign;
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$u(args, "hsl");
        var h = args[0];
        var s = args[1];
        var l = args[2];
        var r, g, b;
        if (s === 0) r = g = b = l * 255;
        else {
            var t3 = [
                0,
                0,
                0
            ];
            var c = [
                0,
                0,
                0
            ];
            var t2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var t1 = 2 * l - t2;
            var h_ = h / 360;
            t3[0] = h_ + 1 / 3;
            t3[1] = h_;
            t3[2] = h_ - 1 / 3;
            for(var i = 0; i < 3; i++){
                if (t3[i] < 0) t3[i] += 1;
                if (t3[i] > 1) t3[i] -= 1;
                if (6 * t3[i] < 1) c[i] = t1 + (t2 - t1) * 6 * t3[i];
                else if (2 * t3[i] < 1) c[i] = t2;
                else if (3 * t3[i] < 2) c[i] = t1 + (t2 - t1) * (2 / 3 - t3[i]) * 6;
                else c[i] = t1;
            }
            assign = [
                round$5(c[0] * 255),
                round$5(c[1] * 255),
                round$5(c[2] * 255)
            ], r = assign[0], g = assign[1], b = assign[2];
        }
        if (args.length > 3) // keep alpha channel
        return [
            r,
            g,
            b,
            args[3]
        ];
        return [
            r,
            g,
            b,
            1
        ];
    };
    var hsl2rgb_1 = hsl2rgb$1;
    var hsl2rgb = hsl2rgb_1;
    var input$f = input$h;
    var RE_RGB = /^rgb\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*\)$/;
    var RE_RGBA = /^rgba\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*,\s*([01]|[01]?\.\d+)\)$/;
    var RE_RGB_PCT = /^rgb\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/;
    var RE_RGBA_PCT = /^rgba\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;
    var RE_HSL = /^hsl\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/;
    var RE_HSLA = /^hsla\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;
    var round$4 = Math.round;
    var css2rgb$1 = function(css) {
        css = css.toLowerCase().trim();
        var m;
        if (input$f.format.named) try {
            return input$f.format.named(css);
        } catch (e) {
        // eslint-disable-next-line
        }
        // rgb(250,20,0)
        if (m = css.match(RE_RGB)) {
            var rgb = m.slice(1, 4);
            for(var i = 0; i < 3; i++)rgb[i] = +rgb[i];
            rgb[3] = 1; // default alpha
            return rgb;
        }
        // rgba(250,20,0,0.4)
        if (m = css.match(RE_RGBA)) {
            var rgb$1 = m.slice(1, 5);
            for(var i$1 = 0; i$1 < 4; i$1++)rgb$1[i$1] = +rgb$1[i$1];
            return rgb$1;
        }
        // rgb(100%,0%,0%)
        if (m = css.match(RE_RGB_PCT)) {
            var rgb$2 = m.slice(1, 4);
            for(var i$2 = 0; i$2 < 3; i$2++)rgb$2[i$2] = round$4(rgb$2[i$2] * 2.55);
            rgb$2[3] = 1; // default alpha
            return rgb$2;
        }
        // rgba(100%,0%,0%,0.4)
        if (m = css.match(RE_RGBA_PCT)) {
            var rgb$3 = m.slice(1, 5);
            for(var i$3 = 0; i$3 < 3; i$3++)rgb$3[i$3] = round$4(rgb$3[i$3] * 2.55);
            rgb$3[3] = +rgb$3[3];
            return rgb$3;
        }
        // hsl(0,100%,50%)
        if (m = css.match(RE_HSL)) {
            var hsl = m.slice(1, 4);
            hsl[1] *= 0.01;
            hsl[2] *= 0.01;
            var rgb$4 = hsl2rgb(hsl);
            rgb$4[3] = 1;
            return rgb$4;
        }
        // hsla(0,100%,50%,0.5)
        if (m = css.match(RE_HSLA)) {
            var hsl$1 = m.slice(1, 4);
            hsl$1[1] *= 0.01;
            hsl$1[2] *= 0.01;
            var rgb$5 = hsl2rgb(hsl$1);
            rgb$5[3] = +m[4]; // default alpha = 1
            return rgb$5;
        }
    };
    css2rgb$1.test = function(s) {
        return RE_RGB.test(s) || RE_RGBA.test(s) || RE_RGB_PCT.test(s) || RE_RGBA_PCT.test(s) || RE_HSL.test(s) || RE_HSLA.test(s);
    };
    var css2rgb_1 = css2rgb$1;
    var chroma$i = chroma_1;
    var Color$B = Color_1;
    var input$e = input$h;
    var type$k = utils.type;
    var rgb2css = rgb2css_1;
    var css2rgb = css2rgb_1;
    Color$B.prototype.css = function(mode) {
        return rgb2css(this._rgb, mode);
    };
    chroma$i.css = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$B, [
            null
        ].concat(args, [
            "css"
        ])));
    };
    input$e.format.css = css2rgb;
    input$e.autodetect.push({
        p: 5,
        test: function(h) {
            var rest = [], len = arguments.length - 1;
            while(len-- > 0)rest[len] = arguments[len + 1];
            if (!rest.length && type$k(h) === "string" && css2rgb.test(h)) return "css";
        }
    });
    var Color$A = Color_1;
    var chroma$h = chroma_1;
    var input$d = input$h;
    var unpack$t = utils.unpack;
    input$d.format.gl = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var rgb = unpack$t(args, "rgba");
        rgb[0] *= 255;
        rgb[1] *= 255;
        rgb[2] *= 255;
        return rgb;
    };
    chroma$h.gl = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$A, [
            null
        ].concat(args, [
            "gl"
        ])));
    };
    Color$A.prototype.gl = function() {
        var rgb = this._rgb;
        return [
            rgb[0] / 255,
            rgb[1] / 255,
            rgb[2] / 255,
            rgb[3]
        ];
    };
    var unpack$s = utils.unpack;
    var rgb2hcg$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$s(args, "rgb");
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var min = Math.min(r, g, b);
        var max = Math.max(r, g, b);
        var delta = max - min;
        var c = delta * 100 / 255;
        var _g = min / (255 - delta) * 100;
        var h;
        if (delta === 0) h = Number.NaN;
        else {
            if (r === max) h = (g - b) / delta;
            if (g === max) h = 2 + (b - r) / delta;
            if (b === max) h = 4 + (r - g) / delta;
            h *= 60;
            if (h < 0) h += 360;
        }
        return [
            h,
            c,
            _g
        ];
    };
    var rgb2hcg_1 = rgb2hcg$1;
    var unpack$r = utils.unpack;
    var floor$3 = Math.floor;
    /*
     * this is basically just HSV with some minor tweaks
     *
     * hue.. [0..360]
     * chroma .. [0..1]
     * grayness .. [0..1]
     */ var hcg2rgb = function() {
        var assign, assign$1, assign$2, assign$3, assign$4, assign$5;
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$r(args, "hcg");
        var h = args[0];
        var c = args[1];
        var _g = args[2];
        var r, g, b;
        _g = _g * 255;
        var _c = c * 255;
        if (c === 0) r = g = b = _g;
        else {
            if (h === 360) h = 0;
            if (h > 360) h -= 360;
            if (h < 0) h += 360;
            h /= 60;
            var i = floor$3(h);
            var f = h - i;
            var p = _g * (1 - c);
            var q = p + _c * (1 - f);
            var t = p + _c * f;
            var v = p + _c;
            switch(i){
                case 0:
                    assign = [
                        v,
                        t,
                        p
                    ], r = assign[0], g = assign[1], b = assign[2];
                    break;
                case 1:
                    assign$1 = [
                        q,
                        v,
                        p
                    ], r = assign$1[0], g = assign$1[1], b = assign$1[2];
                    break;
                case 2:
                    assign$2 = [
                        p,
                        v,
                        t
                    ], r = assign$2[0], g = assign$2[1], b = assign$2[2];
                    break;
                case 3:
                    assign$3 = [
                        p,
                        q,
                        v
                    ], r = assign$3[0], g = assign$3[1], b = assign$3[2];
                    break;
                case 4:
                    assign$4 = [
                        t,
                        p,
                        v
                    ], r = assign$4[0], g = assign$4[1], b = assign$4[2];
                    break;
                case 5:
                    assign$5 = [
                        v,
                        p,
                        q
                    ], r = assign$5[0], g = assign$5[1], b = assign$5[2];
                    break;
            }
        }
        return [
            r,
            g,
            b,
            args.length > 3 ? args[3] : 1
        ];
    };
    var hcg2rgb_1 = hcg2rgb;
    var unpack$q = utils.unpack;
    var type$j = utils.type;
    var chroma$g = chroma_1;
    var Color$z = Color_1;
    var input$c = input$h;
    var rgb2hcg = rgb2hcg_1;
    Color$z.prototype.hcg = function() {
        return rgb2hcg(this._rgb);
    };
    chroma$g.hcg = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$z, [
            null
        ].concat(args, [
            "hcg"
        ])));
    };
    input$c.format.hcg = hcg2rgb_1;
    input$c.autodetect.push({
        p: 1,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$q(args, "hcg");
            if (type$j(args) === "array" && args.length === 3) return "hcg";
        }
    });
    var unpack$p = utils.unpack;
    var last = utils.last;
    var round$3 = Math.round;
    var rgb2hex$2 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$p(args, "rgba");
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var a = ref[3];
        var mode = last(args) || "auto";
        if (a === undefined) a = 1;
        if (mode === "auto") mode = a < 1 ? "rgba" : "rgb";
        r = round$3(r);
        g = round$3(g);
        b = round$3(b);
        var u = r << 16 | g << 8 | b;
        var str = "000000" + u.toString(16); //#.toUpperCase();
        str = str.substr(str.length - 6);
        var hxa = "0" + round$3(a * 255).toString(16);
        hxa = hxa.substr(hxa.length - 2);
        switch(mode.toLowerCase()){
            case "rgba":
                return "#" + str + hxa;
            case "argb":
                return "#" + hxa + str;
            default:
                return "#" + str;
        }
    };
    var rgb2hex_1 = rgb2hex$2;
    var RE_HEX = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
    var RE_HEXA = /^#?([A-Fa-f0-9]{8}|[A-Fa-f0-9]{4})$/;
    var hex2rgb$1 = function(hex) {
        if (hex.match(RE_HEX)) {
            // remove optional leading #
            if (hex.length === 4 || hex.length === 7) hex = hex.substr(1);
            // expand short-notation to full six-digit
            if (hex.length === 3) {
                hex = hex.split("");
                hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
            }
            var u = parseInt(hex, 16);
            var r = u >> 16;
            var g = u >> 8 & 0xFF;
            var b = u & 0xFF;
            return [
                r,
                g,
                b,
                1
            ];
        }
        // match rgba hex format, eg #FF000077
        if (hex.match(RE_HEXA)) {
            if (hex.length === 5 || hex.length === 9) // remove optional leading #
            hex = hex.substr(1);
            // expand short-notation to full eight-digit
            if (hex.length === 4) {
                hex = hex.split("");
                hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
            }
            var u$1 = parseInt(hex, 16);
            var r$1 = u$1 >> 24 & 0xFF;
            var g$1 = u$1 >> 16 & 0xFF;
            var b$1 = u$1 >> 8 & 0xFF;
            var a = Math.round((u$1 & 0xFF) / 0xFF * 100) / 100;
            return [
                r$1,
                g$1,
                b$1,
                a
            ];
        }
        // we used to check for css colors here
        // if _input.css? and rgb = _input.css hex
        //     return rgb
        throw new Error("unknown hex color: " + hex);
    };
    var hex2rgb_1 = hex2rgb$1;
    var chroma$f = chroma_1;
    var Color$y = Color_1;
    var type$i = utils.type;
    var input$b = input$h;
    var rgb2hex$1 = rgb2hex_1;
    Color$y.prototype.hex = function(mode) {
        return rgb2hex$1(this._rgb, mode);
    };
    chroma$f.hex = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$y, [
            null
        ].concat(args, [
            "hex"
        ])));
    };
    input$b.format.hex = hex2rgb_1;
    input$b.autodetect.push({
        p: 4,
        test: function(h) {
            var rest = [], len = arguments.length - 1;
            while(len-- > 0)rest[len] = arguments[len + 1];
            if (!rest.length && type$i(h) === "string" && [
                3,
                4,
                5,
                6,
                7,
                8,
                9
            ].indexOf(h.length) >= 0) return "hex";
        }
    });
    var unpack$o = utils.unpack;
    var TWOPI$2 = utils.TWOPI;
    var min$2 = Math.min;
    var sqrt$4 = Math.sqrt;
    var acos = Math.acos;
    var rgb2hsi$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        /*
        borrowed from here:
        http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/rgb2hsi.cpp
        */ var ref = unpack$o(args, "rgb");
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        r /= 255;
        g /= 255;
        b /= 255;
        var h;
        var min_ = min$2(r, g, b);
        var i = (r + g + b) / 3;
        var s = i > 0 ? 1 - min_ / i : 0;
        if (s === 0) h = NaN;
        else {
            h = (r - g + (r - b)) / 2;
            h /= sqrt$4((r - g) * (r - g) + (r - b) * (g - b));
            h = acos(h);
            if (b > g) h = TWOPI$2 - h;
            h /= TWOPI$2;
        }
        return [
            h * 360,
            s,
            i
        ];
    };
    var rgb2hsi_1 = rgb2hsi$1;
    var unpack$n = utils.unpack;
    var limit = utils.limit;
    var TWOPI$1 = utils.TWOPI;
    var PITHIRD = utils.PITHIRD;
    var cos$4 = Math.cos;
    /*
     * hue [0..360]
     * saturation [0..1]
     * intensity [0..1]
     */ var hsi2rgb = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        /*
        borrowed from here:
        http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/hsi2rgb.cpp
        */ args = unpack$n(args, "hsi");
        var h = args[0];
        var s = args[1];
        var i = args[2];
        var r, g, b;
        if (isNaN(h)) h = 0;
        if (isNaN(s)) s = 0;
        // normalize hue
        if (h > 360) h -= 360;
        if (h < 0) h += 360;
        h /= 360;
        if (h < 1 / 3) {
            b = (1 - s) / 3;
            r = (1 + s * cos$4(TWOPI$1 * h) / cos$4(PITHIRD - TWOPI$1 * h)) / 3;
            g = 1 - (b + r);
        } else if (h < 2 / 3) {
            h -= 1 / 3;
            r = (1 - s) / 3;
            g = (1 + s * cos$4(TWOPI$1 * h) / cos$4(PITHIRD - TWOPI$1 * h)) / 3;
            b = 1 - (r + g);
        } else {
            h -= 2 / 3;
            g = (1 - s) / 3;
            b = (1 + s * cos$4(TWOPI$1 * h) / cos$4(PITHIRD - TWOPI$1 * h)) / 3;
            r = 1 - (g + b);
        }
        r = limit(i * r * 3);
        g = limit(i * g * 3);
        b = limit(i * b * 3);
        return [
            r * 255,
            g * 255,
            b * 255,
            args.length > 3 ? args[3] : 1
        ];
    };
    var hsi2rgb_1 = hsi2rgb;
    var unpack$m = utils.unpack;
    var type$h = utils.type;
    var chroma$e = chroma_1;
    var Color$x = Color_1;
    var input$a = input$h;
    var rgb2hsi = rgb2hsi_1;
    Color$x.prototype.hsi = function() {
        return rgb2hsi(this._rgb);
    };
    chroma$e.hsi = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$x, [
            null
        ].concat(args, [
            "hsi"
        ])));
    };
    input$a.format.hsi = hsi2rgb_1;
    input$a.autodetect.push({
        p: 2,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$m(args, "hsi");
            if (type$h(args) === "array" && args.length === 3) return "hsi";
        }
    });
    var unpack$l = utils.unpack;
    var type$g = utils.type;
    var chroma$d = chroma_1;
    var Color$w = Color_1;
    var input$9 = input$h;
    var rgb2hsl$1 = rgb2hsl_1;
    Color$w.prototype.hsl = function() {
        return rgb2hsl$1(this._rgb);
    };
    chroma$d.hsl = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$w, [
            null
        ].concat(args, [
            "hsl"
        ])));
    };
    input$9.format.hsl = hsl2rgb_1;
    input$9.autodetect.push({
        p: 2,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$l(args, "hsl");
            if (type$g(args) === "array" && args.length === 3) return "hsl";
        }
    });
    var unpack$k = utils.unpack;
    var min$1 = Math.min;
    var max$1 = Math.max;
    /*
     * supported arguments:
     * - rgb2hsv(r,g,b)
     * - rgb2hsv([r,g,b])
     * - rgb2hsv({r,g,b})
     */ var rgb2hsl = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$k(args, "rgb");
        var r = args[0];
        var g = args[1];
        var b = args[2];
        var min_ = min$1(r, g, b);
        var max_ = max$1(r, g, b);
        var delta = max_ - min_;
        var h, s, v;
        v = max_ / 255.0;
        if (max_ === 0) {
            h = Number.NaN;
            s = 0;
        } else {
            s = delta / max_;
            if (r === max_) h = (g - b) / delta;
            if (g === max_) h = 2 + (b - r) / delta;
            if (b === max_) h = 4 + (r - g) / delta;
            h *= 60;
            if (h < 0) h += 360;
        }
        return [
            h,
            s,
            v
        ];
    };
    var rgb2hsv$1 = rgb2hsl;
    var unpack$j = utils.unpack;
    var floor$2 = Math.floor;
    var hsv2rgb = function() {
        var assign, assign$1, assign$2, assign$3, assign$4, assign$5;
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$j(args, "hsv");
        var h = args[0];
        var s = args[1];
        var v = args[2];
        var r, g, b;
        v *= 255;
        if (s === 0) r = g = b = v;
        else {
            if (h === 360) h = 0;
            if (h > 360) h -= 360;
            if (h < 0) h += 360;
            h /= 60;
            var i = floor$2(h);
            var f = h - i;
            var p = v * (1 - s);
            var q = v * (1 - s * f);
            var t = v * (1 - s * (1 - f));
            switch(i){
                case 0:
                    assign = [
                        v,
                        t,
                        p
                    ], r = assign[0], g = assign[1], b = assign[2];
                    break;
                case 1:
                    assign$1 = [
                        q,
                        v,
                        p
                    ], r = assign$1[0], g = assign$1[1], b = assign$1[2];
                    break;
                case 2:
                    assign$2 = [
                        p,
                        v,
                        t
                    ], r = assign$2[0], g = assign$2[1], b = assign$2[2];
                    break;
                case 3:
                    assign$3 = [
                        p,
                        q,
                        v
                    ], r = assign$3[0], g = assign$3[1], b = assign$3[2];
                    break;
                case 4:
                    assign$4 = [
                        t,
                        p,
                        v
                    ], r = assign$4[0], g = assign$4[1], b = assign$4[2];
                    break;
                case 5:
                    assign$5 = [
                        v,
                        p,
                        q
                    ], r = assign$5[0], g = assign$5[1], b = assign$5[2];
                    break;
            }
        }
        return [
            r,
            g,
            b,
            args.length > 3 ? args[3] : 1
        ];
    };
    var hsv2rgb_1 = hsv2rgb;
    var unpack$i = utils.unpack;
    var type$f = utils.type;
    var chroma$c = chroma_1;
    var Color$v = Color_1;
    var input$8 = input$h;
    var rgb2hsv = rgb2hsv$1;
    Color$v.prototype.hsv = function() {
        return rgb2hsv(this._rgb);
    };
    chroma$c.hsv = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$v, [
            null
        ].concat(args, [
            "hsv"
        ])));
    };
    input$8.format.hsv = hsv2rgb_1;
    input$8.autodetect.push({
        p: 2,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$i(args, "hsv");
            if (type$f(args) === "array" && args.length === 3) return "hsv";
        }
    });
    var labConstants = {
        // Corresponds roughly to RGB brighter/darker
        Kn: 18,
        // D65 standard referent
        Xn: 0.950470,
        Yn: 1,
        Zn: 1.088830,
        t0: 0.137931034,
        t1: 0.206896552,
        t2: 0.12841855,
        t3: 0.008856452
    };
    var LAB_CONSTANTS$3 = labConstants;
    var unpack$h = utils.unpack;
    var pow$a = Math.pow;
    var rgb2lab$2 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$h(args, "rgb");
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var ref$1 = rgb2xyz(r, g, b);
        var x = ref$1[0];
        var y = ref$1[1];
        var z = ref$1[2];
        var l = 116 * y - 16;
        return [
            l < 0 ? 0 : l,
            500 * (x - y),
            200 * (y - z)
        ];
    };
    var rgb_xyz = function(r) {
        if ((r /= 255) <= 0.04045) return r / 12.92;
        return pow$a((r + 0.055) / 1.055, 2.4);
    };
    var xyz_lab = function(t) {
        if (t > LAB_CONSTANTS$3.t3) return pow$a(t, 1 / 3);
        return t / LAB_CONSTANTS$3.t2 + LAB_CONSTANTS$3.t0;
    };
    var rgb2xyz = function(r, g, b) {
        r = rgb_xyz(r);
        g = rgb_xyz(g);
        b = rgb_xyz(b);
        var x = xyz_lab((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / LAB_CONSTANTS$3.Xn);
        var y = xyz_lab((0.2126729 * r + 0.7151522 * g + 0.0721750 * b) / LAB_CONSTANTS$3.Yn);
        var z = xyz_lab((0.0193339 * r + 0.1191920 * g + 0.9503041 * b) / LAB_CONSTANTS$3.Zn);
        return [
            x,
            y,
            z
        ];
    };
    var rgb2lab_1 = rgb2lab$2;
    var LAB_CONSTANTS$2 = labConstants;
    var unpack$g = utils.unpack;
    var pow$9 = Math.pow;
    /*
     * L* [0..100]
     * a [-100..100]
     * b [-100..100]
     */ var lab2rgb$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$g(args, "lab");
        var l = args[0];
        var a = args[1];
        var b = args[2];
        var x, y, z, r, g, b_;
        y = (l + 16) / 116;
        x = isNaN(a) ? y : y + a / 500;
        z = isNaN(b) ? y : y - b / 200;
        y = LAB_CONSTANTS$2.Yn * lab_xyz(y);
        x = LAB_CONSTANTS$2.Xn * lab_xyz(x);
        z = LAB_CONSTANTS$2.Zn * lab_xyz(z);
        r = xyz_rgb(3.2404542 * x - 1.5371385 * y - 0.4985314 * z); // D65 -> sRGB
        g = xyz_rgb(-0.969266 * x + 1.8760108 * y + 0.0415560 * z);
        b_ = xyz_rgb(0.0556434 * x - 0.2040259 * y + 1.0572252 * z);
        return [
            r,
            g,
            b_,
            args.length > 3 ? args[3] : 1
        ];
    };
    var xyz_rgb = function(r) {
        return 255 * (r <= 0.00304 ? 12.92 * r : 1.055 * pow$9(r, 1 / 2.4) - 0.055);
    };
    var lab_xyz = function(t) {
        return t > LAB_CONSTANTS$2.t1 ? t * t * t : LAB_CONSTANTS$2.t2 * (t - LAB_CONSTANTS$2.t0);
    };
    var lab2rgb_1 = lab2rgb$1;
    var unpack$f = utils.unpack;
    var type$e = utils.type;
    var chroma$b = chroma_1;
    var Color$u = Color_1;
    var input$7 = input$h;
    var rgb2lab$1 = rgb2lab_1;
    Color$u.prototype.lab = function() {
        return rgb2lab$1(this._rgb);
    };
    chroma$b.lab = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$u, [
            null
        ].concat(args, [
            "lab"
        ])));
    };
    input$7.format.lab = lab2rgb_1;
    input$7.autodetect.push({
        p: 2,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$f(args, "lab");
            if (type$e(args) === "array" && args.length === 3) return "lab";
        }
    });
    var unpack$e = utils.unpack;
    var RAD2DEG = utils.RAD2DEG;
    var sqrt$3 = Math.sqrt;
    var atan2$2 = Math.atan2;
    var round$2 = Math.round;
    var lab2lch$2 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$e(args, "lab");
        var l = ref[0];
        var a = ref[1];
        var b = ref[2];
        var c = sqrt$3(a * a + b * b);
        var h = (atan2$2(b, a) * RAD2DEG + 360) % 360;
        if (round$2(c * 10000) === 0) h = Number.NaN;
        return [
            l,
            c,
            h
        ];
    };
    var lab2lch_1 = lab2lch$2;
    var unpack$d = utils.unpack;
    var rgb2lab = rgb2lab_1;
    var lab2lch$1 = lab2lch_1;
    var rgb2lch$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$d(args, "rgb");
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var ref$1 = rgb2lab(r, g, b);
        var l = ref$1[0];
        var a = ref$1[1];
        var b_ = ref$1[2];
        return lab2lch$1(l, a, b_);
    };
    var rgb2lch_1 = rgb2lch$1;
    var unpack$c = utils.unpack;
    var DEG2RAD = utils.DEG2RAD;
    var sin$3 = Math.sin;
    var cos$3 = Math.cos;
    var lch2lab$2 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        /*
        Convert from a qualitative parameter h and a quantitative parameter l to a 24-bit pixel.
        These formulas were invented by David Dalrymple to obtain maximum contrast without going
        out of gamut if the parameters are in the range 0-1.

        A saturation multiplier was added by Gregor Aisch
        */ var ref = unpack$c(args, "lch");
        var l = ref[0];
        var c = ref[1];
        var h = ref[2];
        if (isNaN(h)) h = 0;
        h = h * DEG2RAD;
        return [
            l,
            cos$3(h) * c,
            sin$3(h) * c
        ];
    };
    var lch2lab_1 = lch2lab$2;
    var unpack$b = utils.unpack;
    var lch2lab$1 = lch2lab_1;
    var lab2rgb = lab2rgb_1;
    var lch2rgb$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$b(args, "lch");
        var l = args[0];
        var c = args[1];
        var h = args[2];
        var ref = lch2lab$1(l, c, h);
        var L = ref[0];
        var a = ref[1];
        var b_ = ref[2];
        var ref$1 = lab2rgb(L, a, b_);
        var r = ref$1[0];
        var g = ref$1[1];
        var b = ref$1[2];
        return [
            r,
            g,
            b,
            args.length > 3 ? args[3] : 1
        ];
    };
    var lch2rgb_1 = lch2rgb$1;
    var unpack$a = utils.unpack;
    var lch2rgb = lch2rgb_1;
    var hcl2rgb = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var hcl = unpack$a(args, "hcl").reverse();
        return lch2rgb.apply(void 0, hcl);
    };
    var hcl2rgb_1 = hcl2rgb;
    var unpack$9 = utils.unpack;
    var type$d = utils.type;
    var chroma$a = chroma_1;
    var Color$t = Color_1;
    var input$6 = input$h;
    var rgb2lch = rgb2lch_1;
    Color$t.prototype.lch = function() {
        return rgb2lch(this._rgb);
    };
    Color$t.prototype.hcl = function() {
        return rgb2lch(this._rgb).reverse();
    };
    chroma$a.lch = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$t, [
            null
        ].concat(args, [
            "lch"
        ])));
    };
    chroma$a.hcl = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$t, [
            null
        ].concat(args, [
            "hcl"
        ])));
    };
    input$6.format.lch = lch2rgb_1;
    input$6.format.hcl = hcl2rgb_1;
    [
        "lch",
        "hcl"
    ].forEach(function(m) {
        return input$6.autodetect.push({
            p: 2,
            test: function() {
                var args = [], len = arguments.length;
                while(len--)args[len] = arguments[len];
                args = unpack$9(args, m);
                if (type$d(args) === "array" && args.length === 3) return m;
            }
        });
    });
    /**
    	X11 color names

    	http://www.w3.org/TR/css3-color/#svg-color
    */ var w3cx11$1 = {
        aliceblue: "#f0f8ff",
        antiquewhite: "#faebd7",
        aqua: "#00ffff",
        aquamarine: "#7fffd4",
        azure: "#f0ffff",
        beige: "#f5f5dc",
        bisque: "#ffe4c4",
        black: "#000000",
        blanchedalmond: "#ffebcd",
        blue: "#0000ff",
        blueviolet: "#8a2be2",
        brown: "#a52a2a",
        burlywood: "#deb887",
        cadetblue: "#5f9ea0",
        chartreuse: "#7fff00",
        chocolate: "#d2691e",
        coral: "#ff7f50",
        cornflower: "#6495ed",
        cornflowerblue: "#6495ed",
        cornsilk: "#fff8dc",
        crimson: "#dc143c",
        cyan: "#00ffff",
        darkblue: "#00008b",
        darkcyan: "#008b8b",
        darkgoldenrod: "#b8860b",
        darkgray: "#a9a9a9",
        darkgreen: "#006400",
        darkgrey: "#a9a9a9",
        darkkhaki: "#bdb76b",
        darkmagenta: "#8b008b",
        darkolivegreen: "#556b2f",
        darkorange: "#ff8c00",
        darkorchid: "#9932cc",
        darkred: "#8b0000",
        darksalmon: "#e9967a",
        darkseagreen: "#8fbc8f",
        darkslateblue: "#483d8b",
        darkslategray: "#2f4f4f",
        darkslategrey: "#2f4f4f",
        darkturquoise: "#00ced1",
        darkviolet: "#9400d3",
        deeppink: "#ff1493",
        deepskyblue: "#00bfff",
        dimgray: "#696969",
        dimgrey: "#696969",
        dodgerblue: "#1e90ff",
        firebrick: "#b22222",
        floralwhite: "#fffaf0",
        forestgreen: "#228b22",
        fuchsia: "#ff00ff",
        gainsboro: "#dcdcdc",
        ghostwhite: "#f8f8ff",
        gold: "#ffd700",
        goldenrod: "#daa520",
        gray: "#808080",
        green: "#008000",
        greenyellow: "#adff2f",
        grey: "#808080",
        honeydew: "#f0fff0",
        hotpink: "#ff69b4",
        indianred: "#cd5c5c",
        indigo: "#4b0082",
        ivory: "#fffff0",
        khaki: "#f0e68c",
        laserlemon: "#ffff54",
        lavender: "#e6e6fa",
        lavenderblush: "#fff0f5",
        lawngreen: "#7cfc00",
        lemonchiffon: "#fffacd",
        lightblue: "#add8e6",
        lightcoral: "#f08080",
        lightcyan: "#e0ffff",
        lightgoldenrod: "#fafad2",
        lightgoldenrodyellow: "#fafad2",
        lightgray: "#d3d3d3",
        lightgreen: "#90ee90",
        lightgrey: "#d3d3d3",
        lightpink: "#ffb6c1",
        lightsalmon: "#ffa07a",
        lightseagreen: "#20b2aa",
        lightskyblue: "#87cefa",
        lightslategray: "#778899",
        lightslategrey: "#778899",
        lightsteelblue: "#b0c4de",
        lightyellow: "#ffffe0",
        lime: "#00ff00",
        limegreen: "#32cd32",
        linen: "#faf0e6",
        magenta: "#ff00ff",
        maroon: "#800000",
        maroon2: "#7f0000",
        maroon3: "#b03060",
        mediumaquamarine: "#66cdaa",
        mediumblue: "#0000cd",
        mediumorchid: "#ba55d3",
        mediumpurple: "#9370db",
        mediumseagreen: "#3cb371",
        mediumslateblue: "#7b68ee",
        mediumspringgreen: "#00fa9a",
        mediumturquoise: "#48d1cc",
        mediumvioletred: "#c71585",
        midnightblue: "#191970",
        mintcream: "#f5fffa",
        mistyrose: "#ffe4e1",
        moccasin: "#ffe4b5",
        navajowhite: "#ffdead",
        navy: "#000080",
        oldlace: "#fdf5e6",
        olive: "#808000",
        olivedrab: "#6b8e23",
        orange: "#ffa500",
        orangered: "#ff4500",
        orchid: "#da70d6",
        palegoldenrod: "#eee8aa",
        palegreen: "#98fb98",
        paleturquoise: "#afeeee",
        palevioletred: "#db7093",
        papayawhip: "#ffefd5",
        peachpuff: "#ffdab9",
        peru: "#cd853f",
        pink: "#ffc0cb",
        plum: "#dda0dd",
        powderblue: "#b0e0e6",
        purple: "#800080",
        purple2: "#7f007f",
        purple3: "#a020f0",
        rebeccapurple: "#663399",
        red: "#ff0000",
        rosybrown: "#bc8f8f",
        royalblue: "#4169e1",
        saddlebrown: "#8b4513",
        salmon: "#fa8072",
        sandybrown: "#f4a460",
        seagreen: "#2e8b57",
        seashell: "#fff5ee",
        sienna: "#a0522d",
        silver: "#c0c0c0",
        skyblue: "#87ceeb",
        slateblue: "#6a5acd",
        slategray: "#708090",
        slategrey: "#708090",
        snow: "#fffafa",
        springgreen: "#00ff7f",
        steelblue: "#4682b4",
        tan: "#d2b48c",
        teal: "#008080",
        thistle: "#d8bfd8",
        tomato: "#ff6347",
        turquoise: "#40e0d0",
        violet: "#ee82ee",
        wheat: "#f5deb3",
        white: "#ffffff",
        whitesmoke: "#f5f5f5",
        yellow: "#ffff00",
        yellowgreen: "#9acd32"
    };
    var w3cx11_1 = w3cx11$1;
    var Color$s = Color_1;
    var input$5 = input$h;
    var type$c = utils.type;
    var w3cx11 = w3cx11_1;
    var hex2rgb = hex2rgb_1;
    var rgb2hex = rgb2hex_1;
    Color$s.prototype.name = function() {
        var hex = rgb2hex(this._rgb, "rgb");
        for(var i = 0, list = Object.keys(w3cx11); i < list.length; i += 1){
            var n = list[i];
            if (w3cx11[n] === hex) return n.toLowerCase();
        }
        return hex;
    };
    input$5.format.named = function(name) {
        name = name.toLowerCase();
        if (w3cx11[name]) return hex2rgb(w3cx11[name]);
        throw new Error("unknown color name: " + name);
    };
    input$5.autodetect.push({
        p: 5,
        test: function(h) {
            var rest = [], len = arguments.length - 1;
            while(len-- > 0)rest[len] = arguments[len + 1];
            if (!rest.length && type$c(h) === "string" && w3cx11[h.toLowerCase()]) return "named";
        }
    });
    var unpack$8 = utils.unpack;
    var rgb2num$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$8(args, "rgb");
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        return (r << 16) + (g << 8) + b;
    };
    var rgb2num_1 = rgb2num$1;
    var type$b = utils.type;
    var num2rgb = function(num) {
        if (type$b(num) == "number" && num >= 0 && num <= 0xFFFFFF) {
            var r = num >> 16;
            var g = num >> 8 & 0xFF;
            var b = num & 0xFF;
            return [
                r,
                g,
                b,
                1
            ];
        }
        throw new Error("unknown num color: " + num);
    };
    var num2rgb_1 = num2rgb;
    var chroma$9 = chroma_1;
    var Color$r = Color_1;
    var input$4 = input$h;
    var type$a = utils.type;
    var rgb2num = rgb2num_1;
    Color$r.prototype.num = function() {
        return rgb2num(this._rgb);
    };
    chroma$9.num = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$r, [
            null
        ].concat(args, [
            "num"
        ])));
    };
    input$4.format.num = num2rgb_1;
    input$4.autodetect.push({
        p: 5,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            if (args.length === 1 && type$a(args[0]) === "number" && args[0] >= 0 && args[0] <= 0xFFFFFF) return "num";
        }
    });
    var chroma$8 = chroma_1;
    var Color$q = Color_1;
    var input$3 = input$h;
    var unpack$7 = utils.unpack;
    var type$9 = utils.type;
    var round$1 = Math.round;
    Color$q.prototype.rgb = function(rnd) {
        if (rnd === void 0) rnd = true;
        if (rnd === false) return this._rgb.slice(0, 3);
        return this._rgb.slice(0, 3).map(round$1);
    };
    Color$q.prototype.rgba = function(rnd) {
        if (rnd === void 0) rnd = true;
        return this._rgb.slice(0, 4).map(function(v, i) {
            return i < 3 ? rnd === false ? v : round$1(v) : v;
        });
    };
    chroma$8.rgb = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$q, [
            null
        ].concat(args, [
            "rgb"
        ])));
    };
    input$3.format.rgb = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var rgba = unpack$7(args, "rgba");
        if (rgba[3] === undefined) rgba[3] = 1;
        return rgba;
    };
    input$3.autodetect.push({
        p: 3,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$7(args, "rgba");
            if (type$9(args) === "array" && (args.length === 3 || args.length === 4 && type$9(args[3]) == "number" && args[3] >= 0 && args[3] <= 1)) return "rgb";
        }
    });
    /*
     * Based on implementation by Neil Bartlett
     * https://github.com/neilbartlett/color-temperature
     */ var log$1 = Math.log;
    var temperature2rgb$1 = function(kelvin) {
        var temp = kelvin / 100;
        var r, g, b;
        if (temp < 66) {
            r = 255;
            g = temp < 6 ? 0 : -155.25485562709179 - 0.44596950469579133 * (g = temp - 2) + 104.49216199393888 * log$1(g);
            b = temp < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (b = temp - 10) + 115.67994401066147 * log$1(b);
        } else {
            r = 351.97690566805693 + 0.114206453784165 * (r = temp - 55) - 40.25366309332127 * log$1(r);
            g = 325.4494125711974 + 0.07943456536662342 * (g = temp - 50) - 28.0852963507957 * log$1(g);
            b = 255;
        }
        return [
            r,
            g,
            b,
            1
        ];
    };
    var temperature2rgb_1 = temperature2rgb$1;
    /*
     * Based on implementation by Neil Bartlett
     * https://github.com/neilbartlett/color-temperature
     **/ var temperature2rgb = temperature2rgb_1;
    var unpack$6 = utils.unpack;
    var round = Math.round;
    var rgb2temperature$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var rgb = unpack$6(args, "rgb");
        var r = rgb[0], b = rgb[2];
        var minTemp = 1000;
        var maxTemp = 40000;
        var eps = 0.4;
        var temp;
        while(maxTemp - minTemp > eps){
            temp = (maxTemp + minTemp) * 0.5;
            var rgb$1 = temperature2rgb(temp);
            if (rgb$1[2] / rgb$1[0] >= b / r) maxTemp = temp;
            else minTemp = temp;
        }
        return round(temp);
    };
    var rgb2temperature_1 = rgb2temperature$1;
    var chroma$7 = chroma_1;
    var Color$p = Color_1;
    var input$2 = input$h;
    var rgb2temperature = rgb2temperature_1;
    Color$p.prototype.temp = Color$p.prototype.kelvin = Color$p.prototype.temperature = function() {
        return rgb2temperature(this._rgb);
    };
    chroma$7.temp = chroma$7.kelvin = chroma$7.temperature = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$p, [
            null
        ].concat(args, [
            "temp"
        ])));
    };
    input$2.format.temp = input$2.format.kelvin = input$2.format.temperature = temperature2rgb_1;
    var unpack$5 = utils.unpack;
    var cbrt = Math.cbrt;
    var pow$8 = Math.pow;
    var sign$1 = Math.sign;
    var rgb2oklab$2 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        // OKLab color space implementation taken from
        // https://bottosson.github.io/posts/oklab/
        var ref = unpack$5(args, "rgb");
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var ref$1 = [
            rgb2lrgb(r / 255),
            rgb2lrgb(g / 255),
            rgb2lrgb(b / 255)
        ];
        var lr = ref$1[0];
        var lg = ref$1[1];
        var lb = ref$1[2];
        var l = cbrt(0.4122214708 * lr + 0.5363325363 * lg + 0.0514459929 * lb);
        var m = cbrt(0.2119034982 * lr + 0.6806995451 * lg + 0.1073969566 * lb);
        var s = cbrt(0.0883024619 * lr + 0.2817188376 * lg + 0.6299787005 * lb);
        return [
            0.2104542553 * l + 0.793617785 * m - 0.0040720468 * s,
            1.9779984951 * l - 2.428592205 * m + 0.4505937099 * s,
            0.0259040371 * l + 0.7827717662 * m - 0.808675766 * s
        ];
    };
    var rgb2oklab_1 = rgb2oklab$2;
    function rgb2lrgb(c) {
        var abs = Math.abs(c);
        if (abs < 0.04045) return c / 12.92;
        return (sign$1(c) || 1) * pow$8((abs + 0.055) / 1.055, 2.4);
    }
    var unpack$4 = utils.unpack;
    var pow$7 = Math.pow;
    var sign = Math.sign;
    /*
     * L* [0..100]
     * a [-100..100]
     * b [-100..100]
     */ var oklab2rgb$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$4(args, "lab");
        var L = args[0];
        var a = args[1];
        var b = args[2];
        var l = pow$7(L + 0.3963377774 * a + 0.2158037573 * b, 3);
        var m = pow$7(L - 0.1055613458 * a - 0.0638541728 * b, 3);
        var s = pow$7(L - 0.0894841775 * a - 1.291485548 * b, 3);
        return [
            255 * lrgb2rgb(4.0767416621 * l - 3.3077115913 * m + 0.2309699292 * s),
            255 * lrgb2rgb(-1.2684380046 * l + 2.6097574011 * m - 0.3413193965 * s),
            255 * lrgb2rgb(-0.0041960863 * l - 0.7034186147 * m + 1.707614701 * s),
            args.length > 3 ? args[3] : 1
        ];
    };
    var oklab2rgb_1 = oklab2rgb$1;
    function lrgb2rgb(c) {
        var abs = Math.abs(c);
        if (abs > 0.0031308) return (sign(c) || 1) * (1.055 * pow$7(abs, 1 / 2.4) - 0.055);
        return c * 12.92;
    }
    var unpack$3 = utils.unpack;
    var type$8 = utils.type;
    var chroma$6 = chroma_1;
    var Color$o = Color_1;
    var input$1 = input$h;
    var rgb2oklab$1 = rgb2oklab_1;
    Color$o.prototype.oklab = function() {
        return rgb2oklab$1(this._rgb);
    };
    chroma$6.oklab = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$o, [
            null
        ].concat(args, [
            "oklab"
        ])));
    };
    input$1.format.oklab = oklab2rgb_1;
    input$1.autodetect.push({
        p: 3,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$3(args, "oklab");
            if (type$8(args) === "array" && args.length === 3) return "oklab";
        }
    });
    var unpack$2 = utils.unpack;
    var rgb2oklab = rgb2oklab_1;
    var lab2lch = lab2lch_1;
    var rgb2oklch$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$2(args, "rgb");
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var ref$1 = rgb2oklab(r, g, b);
        var l = ref$1[0];
        var a = ref$1[1];
        var b_ = ref$1[2];
        return lab2lch(l, a, b_);
    };
    var rgb2oklch_1 = rgb2oklch$1;
    var unpack$1 = utils.unpack;
    var lch2lab = lch2lab_1;
    var oklab2rgb = oklab2rgb_1;
    var oklch2rgb = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$1(args, "lch");
        var l = args[0];
        var c = args[1];
        var h = args[2];
        var ref = lch2lab(l, c, h);
        var L = ref[0];
        var a = ref[1];
        var b_ = ref[2];
        var ref$1 = oklab2rgb(L, a, b_);
        var r = ref$1[0];
        var g = ref$1[1];
        var b = ref$1[2];
        return [
            r,
            g,
            b,
            args.length > 3 ? args[3] : 1
        ];
    };
    var oklch2rgb_1 = oklch2rgb;
    var unpack = utils.unpack;
    var type$7 = utils.type;
    var chroma$5 = chroma_1;
    var Color$n = Color_1;
    var input = input$h;
    var rgb2oklch = rgb2oklch_1;
    Color$n.prototype.oklch = function() {
        return rgb2oklch(this._rgb);
    };
    chroma$5.oklch = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$n, [
            null
        ].concat(args, [
            "oklch"
        ])));
    };
    input.format.oklch = oklch2rgb_1;
    input.autodetect.push({
        p: 3,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack(args, "oklch");
            if (type$7(args) === "array" && args.length === 3) return "oklch";
        }
    });
    var Color$m = Color_1;
    var type$6 = utils.type;
    Color$m.prototype.alpha = function(a, mutate) {
        if (mutate === void 0) mutate = false;
        if (a !== undefined && type$6(a) === "number") {
            if (mutate) {
                this._rgb[3] = a;
                return this;
            }
            return new Color$m([
                this._rgb[0],
                this._rgb[1],
                this._rgb[2],
                a
            ], "rgb");
        }
        return this._rgb[3];
    };
    var Color$l = Color_1;
    Color$l.prototype.clipped = function() {
        return this._rgb._clipped || false;
    };
    var Color$k = Color_1;
    var LAB_CONSTANTS$1 = labConstants;
    Color$k.prototype.darken = function(amount) {
        if (amount === void 0) amount = 1;
        var me = this;
        var lab = me.lab();
        lab[0] -= LAB_CONSTANTS$1.Kn * amount;
        return new Color$k(lab, "lab").alpha(me.alpha(), true);
    };
    Color$k.prototype.brighten = function(amount) {
        if (amount === void 0) amount = 1;
        return this.darken(-amount);
    };
    Color$k.prototype.darker = Color$k.prototype.darken;
    Color$k.prototype.brighter = Color$k.prototype.brighten;
    var Color$j = Color_1;
    Color$j.prototype.get = function(mc) {
        var ref = mc.split(".");
        var mode = ref[0];
        var channel = ref[1];
        var src = this[mode]();
        if (channel) {
            var i = mode.indexOf(channel) - (mode.substr(0, 2) === "ok" ? 2 : 0);
            if (i > -1) return src[i];
            throw new Error("unknown channel " + channel + " in mode " + mode);
        } else return src;
    };
    var Color$i = Color_1;
    var type$5 = utils.type;
    var pow$6 = Math.pow;
    var EPS = 1e-7;
    var MAX_ITER = 20;
    Color$i.prototype.luminance = function(lum) {
        if (lum !== undefined && type$5(lum) === "number") {
            if (lum === 0) // return pure black
            return new Color$i([
                0,
                0,
                0,
                this._rgb[3]
            ], "rgb");
            if (lum === 1) // return pure white
            return new Color$i([
                255,
                255,
                255,
                this._rgb[3]
            ], "rgb");
            // compute new color using...
            var cur_lum = this.luminance();
            var mode = "rgb";
            var max_iter = MAX_ITER;
            var test = function(low, high) {
                var mid = low.interpolate(high, 0.5, mode);
                var lm = mid.luminance();
                if (Math.abs(lum - lm) < EPS || !max_iter--) // close enough
                return mid;
                return lm > lum ? test(low, mid) : test(mid, high);
            };
            var rgb = (cur_lum > lum ? test(new Color$i([
                0,
                0,
                0
            ]), this) : test(this, new Color$i([
                255,
                255,
                255
            ]))).rgb();
            return new Color$i(rgb.concat([
                this._rgb[3]
            ]));
        }
        return rgb2luminance.apply(void 0, this._rgb.slice(0, 3));
    };
    var rgb2luminance = function(r, g, b) {
        // relative luminance
        // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        r = luminance_x(r);
        g = luminance_x(g);
        b = luminance_x(b);
        return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    };
    var luminance_x = function(x) {
        x /= 255;
        return x <= 0.03928 ? x / 12.92 : pow$6((x + 0.055) / 1.055, 2.4);
    };
    var interpolator$1 = {};
    var Color$h = Color_1;
    var type$4 = utils.type;
    var interpolator = interpolator$1;
    var mix$1 = function(col1, col2, f) {
        if (f === void 0) f = 0.5;
        var rest = [], len = arguments.length - 3;
        while(len-- > 0)rest[len] = arguments[len + 3];
        var mode = rest[0] || "lrgb";
        if (!interpolator[mode] && !rest.length) // fall back to the first supported mode
        mode = Object.keys(interpolator)[0];
        if (!interpolator[mode]) throw new Error("interpolation mode " + mode + " is not defined");
        if (type$4(col1) !== "object") col1 = new Color$h(col1);
        if (type$4(col2) !== "object") col2 = new Color$h(col2);
        return interpolator[mode](col1, col2, f).alpha(col1.alpha() + f * (col2.alpha() - col1.alpha()));
    };
    var Color$g = Color_1;
    var mix = mix$1;
    Color$g.prototype.mix = Color$g.prototype.interpolate = function(col2, f) {
        if (f === void 0) f = 0.5;
        var rest = [], len = arguments.length - 2;
        while(len-- > 0)rest[len] = arguments[len + 2];
        return mix.apply(void 0, [
            this,
            col2,
            f
        ].concat(rest));
    };
    var Color$f = Color_1;
    Color$f.prototype.premultiply = function(mutate) {
        if (mutate === void 0) mutate = false;
        var rgb = this._rgb;
        var a = rgb[3];
        if (mutate) {
            this._rgb = [
                rgb[0] * a,
                rgb[1] * a,
                rgb[2] * a,
                a
            ];
            return this;
        } else return new Color$f([
            rgb[0] * a,
            rgb[1] * a,
            rgb[2] * a,
            a
        ], "rgb");
    };
    var Color$e = Color_1;
    var LAB_CONSTANTS = labConstants;
    Color$e.prototype.saturate = function(amount) {
        if (amount === void 0) amount = 1;
        var me = this;
        var lch = me.lch();
        lch[1] += LAB_CONSTANTS.Kn * amount;
        if (lch[1] < 0) lch[1] = 0;
        return new Color$e(lch, "lch").alpha(me.alpha(), true);
    };
    Color$e.prototype.desaturate = function(amount) {
        if (amount === void 0) amount = 1;
        return this.saturate(-amount);
    };
    var Color$d = Color_1;
    var type$3 = utils.type;
    Color$d.prototype.set = function(mc, value, mutate) {
        if (mutate === void 0) mutate = false;
        var ref = mc.split(".");
        var mode = ref[0];
        var channel = ref[1];
        var src = this[mode]();
        if (channel) {
            var i = mode.indexOf(channel) - (mode.substr(0, 2) === "ok" ? 2 : 0);
            if (i > -1) {
                if (type$3(value) == "string") switch(value.charAt(0)){
                    case "+":
                        src[i] += +value;
                        break;
                    case "-":
                        src[i] += +value;
                        break;
                    case "*":
                        src[i] *= +value.substr(1);
                        break;
                    case "/":
                        src[i] /= +value.substr(1);
                        break;
                    default:
                        src[i] = +value;
                }
                else if (type$3(value) === "number") src[i] = value;
                else throw new Error("unsupported value for Color.set");
                var out = new Color$d(src, mode);
                if (mutate) {
                    this._rgb = out._rgb;
                    return this;
                }
                return out;
            }
            throw new Error("unknown channel " + channel + " in mode " + mode);
        } else return src;
    };
    var Color$c = Color_1;
    var rgb = function(col1, col2, f) {
        var xyz0 = col1._rgb;
        var xyz1 = col2._rgb;
        return new Color$c(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), "rgb");
    };
    // register interpolator
    interpolator$1.rgb = rgb;
    var Color$b = Color_1;
    var sqrt$2 = Math.sqrt;
    var pow$5 = Math.pow;
    var lrgb = function(col1, col2, f) {
        var ref = col1._rgb;
        var x1 = ref[0];
        var y1 = ref[1];
        var z1 = ref[2];
        var ref$1 = col2._rgb;
        var x2 = ref$1[0];
        var y2 = ref$1[1];
        var z2 = ref$1[2];
        return new Color$b(sqrt$2(pow$5(x1, 2) * (1 - f) + pow$5(x2, 2) * f), sqrt$2(pow$5(y1, 2) * (1 - f) + pow$5(y2, 2) * f), sqrt$2(pow$5(z1, 2) * (1 - f) + pow$5(z2, 2) * f), "rgb");
    };
    // register interpolator
    interpolator$1.lrgb = lrgb;
    var Color$a = Color_1;
    var lab = function(col1, col2, f) {
        var xyz0 = col1.lab();
        var xyz1 = col2.lab();
        return new Color$a(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), "lab");
    };
    // register interpolator
    interpolator$1.lab = lab;
    var Color$9 = Color_1;
    var _hsx = function(col1, col2, f, m) {
        var assign, assign$1;
        var xyz0, xyz1;
        if (m === "hsl") {
            xyz0 = col1.hsl();
            xyz1 = col2.hsl();
        } else if (m === "hsv") {
            xyz0 = col1.hsv();
            xyz1 = col2.hsv();
        } else if (m === "hcg") {
            xyz0 = col1.hcg();
            xyz1 = col2.hcg();
        } else if (m === "hsi") {
            xyz0 = col1.hsi();
            xyz1 = col2.hsi();
        } else if (m === "lch" || m === "hcl") {
            m = "hcl";
            xyz0 = col1.hcl();
            xyz1 = col2.hcl();
        } else if (m === "oklch") {
            xyz0 = col1.oklch().reverse();
            xyz1 = col2.oklch().reverse();
        }
        var hue0, hue1, sat0, sat1, lbv0, lbv1;
        if (m.substr(0, 1) === "h" || m === "oklch") {
            assign = xyz0, hue0 = assign[0], sat0 = assign[1], lbv0 = assign[2];
            assign$1 = xyz1, hue1 = assign$1[0], sat1 = assign$1[1], lbv1 = assign$1[2];
        }
        var sat, hue, lbv, dh;
        if (!isNaN(hue0) && !isNaN(hue1)) {
            // both colors have hue
            if (hue1 > hue0 && hue1 - hue0 > 180) dh = hue1 - (hue0 + 360);
            else if (hue1 < hue0 && hue0 - hue1 > 180) dh = hue1 + 360 - hue0;
            else dh = hue1 - hue0;
            hue = hue0 + f * dh;
        } else if (!isNaN(hue0)) {
            hue = hue0;
            if ((lbv1 == 1 || lbv1 == 0) && m != "hsv") sat = sat0;
        } else if (!isNaN(hue1)) {
            hue = hue1;
            if ((lbv0 == 1 || lbv0 == 0) && m != "hsv") sat = sat1;
        } else hue = Number.NaN;
        if (sat === undefined) sat = sat0 + f * (sat1 - sat0);
        lbv = lbv0 + f * (lbv1 - lbv0);
        return m === "oklch" ? new Color$9([
            lbv,
            sat,
            hue
        ], m) : new Color$9([
            hue,
            sat,
            lbv
        ], m);
    };
    var interpolate_hsx$5 = _hsx;
    var lch = function(col1, col2, f) {
        return interpolate_hsx$5(col1, col2, f, "lch");
    };
    // register interpolator
    interpolator$1.lch = lch;
    interpolator$1.hcl = lch;
    var Color$8 = Color_1;
    var num = function(col1, col2, f) {
        var c1 = col1.num();
        var c2 = col2.num();
        return new Color$8(c1 + f * (c2 - c1), "num");
    };
    // register interpolator
    interpolator$1.num = num;
    var interpolate_hsx$4 = _hsx;
    var hcg = function(col1, col2, f) {
        return interpolate_hsx$4(col1, col2, f, "hcg");
    };
    // register interpolator
    interpolator$1.hcg = hcg;
    var interpolate_hsx$3 = _hsx;
    var hsi = function(col1, col2, f) {
        return interpolate_hsx$3(col1, col2, f, "hsi");
    };
    // register interpolator
    interpolator$1.hsi = hsi;
    var interpolate_hsx$2 = _hsx;
    var hsl = function(col1, col2, f) {
        return interpolate_hsx$2(col1, col2, f, "hsl");
    };
    // register interpolator
    interpolator$1.hsl = hsl;
    var interpolate_hsx$1 = _hsx;
    var hsv = function(col1, col2, f) {
        return interpolate_hsx$1(col1, col2, f, "hsv");
    };
    // register interpolator
    interpolator$1.hsv = hsv;
    var Color$7 = Color_1;
    var oklab = function(col1, col2, f) {
        var xyz0 = col1.oklab();
        var xyz1 = col2.oklab();
        return new Color$7(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), "oklab");
    };
    // register interpolator
    interpolator$1.oklab = oklab;
    var interpolate_hsx = _hsx;
    var oklch = function(col1, col2, f) {
        return interpolate_hsx(col1, col2, f, "oklch");
    };
    // register interpolator
    interpolator$1.oklch = oklch;
    var Color$6 = Color_1;
    var clip_rgb$1 = utils.clip_rgb;
    var pow$4 = Math.pow;
    var sqrt$1 = Math.sqrt;
    var PI$1 = Math.PI;
    var cos$2 = Math.cos;
    var sin$2 = Math.sin;
    var atan2$1 = Math.atan2;
    var average = function(colors, mode, weights) {
        if (mode === void 0) mode = "lrgb";
        if (weights === void 0) weights = null;
        var l = colors.length;
        if (!weights) weights = Array.from(new Array(l)).map(function() {
            return 1;
        });
        // normalize weights
        var k = l / weights.reduce(function(a, b) {
            return a + b;
        });
        weights.forEach(function(w, i) {
            weights[i] *= k;
        });
        // convert colors to Color objects
        colors = colors.map(function(c) {
            return new Color$6(c);
        });
        if (mode === "lrgb") return _average_lrgb(colors, weights);
        var first = colors.shift();
        var xyz = first.get(mode);
        var cnt = [];
        var dx = 0;
        var dy = 0;
        // initial color
        for(var i = 0; i < xyz.length; i++){
            xyz[i] = (xyz[i] || 0) * weights[0];
            cnt.push(isNaN(xyz[i]) ? 0 : weights[0]);
            if (mode.charAt(i) === "h" && !isNaN(xyz[i])) {
                var A = xyz[i] / 180 * PI$1;
                dx += cos$2(A) * weights[0];
                dy += sin$2(A) * weights[0];
            }
        }
        var alpha = first.alpha() * weights[0];
        colors.forEach(function(c, ci) {
            var xyz2 = c.get(mode);
            alpha += c.alpha() * weights[ci + 1];
            for(var i = 0; i < xyz.length; i++)if (!isNaN(xyz2[i])) {
                cnt[i] += weights[ci + 1];
                if (mode.charAt(i) === "h") {
                    var A = xyz2[i] / 180 * PI$1;
                    dx += cos$2(A) * weights[ci + 1];
                    dy += sin$2(A) * weights[ci + 1];
                } else xyz[i] += xyz2[i] * weights[ci + 1];
            }
        });
        for(var i$1 = 0; i$1 < xyz.length; i$1++)if (mode.charAt(i$1) === "h") {
            var A$1 = atan2$1(dy / cnt[i$1], dx / cnt[i$1]) / PI$1 * 180;
            while(A$1 < 0)A$1 += 360;
            while(A$1 >= 360)A$1 -= 360;
            xyz[i$1] = A$1;
        } else xyz[i$1] = xyz[i$1] / cnt[i$1];
        alpha /= l;
        return new Color$6(xyz, mode).alpha(alpha > 0.99999 ? 1 : alpha, true);
    };
    var _average_lrgb = function(colors, weights) {
        var l = colors.length;
        var xyz = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0; i < colors.length; i++){
            var col = colors[i];
            var f = weights[i] / l;
            var rgb = col._rgb;
            xyz[0] += pow$4(rgb[0], 2) * f;
            xyz[1] += pow$4(rgb[1], 2) * f;
            xyz[2] += pow$4(rgb[2], 2) * f;
            xyz[3] += rgb[3] * f;
        }
        xyz[0] = sqrt$1(xyz[0]);
        xyz[1] = sqrt$1(xyz[1]);
        xyz[2] = sqrt$1(xyz[2]);
        if (xyz[3] > 0.9999999) xyz[3] = 1;
        return new Color$6(clip_rgb$1(xyz));
    };
    // minimal multi-purpose interface
    // @requires utils color analyze
    var chroma$4 = chroma_1;
    var type$2 = utils.type;
    var pow$3 = Math.pow;
    var scale$2 = function(colors) {
        // constructor
        var _mode = "rgb";
        var _nacol = chroma$4("#ccc");
        var _spread = 0;
        // const _fixed = false;
        var _domain = [
            0,
            1
        ];
        var _pos = [];
        var _padding = [
            0,
            0
        ];
        var _classes = false;
        var _colors = [];
        var _out = false;
        var _min = 0;
        var _max = 1;
        var _correctLightness = false;
        var _colorCache = {};
        var _useCache = true;
        var _gamma = 1;
        // private methods
        var setColors = function(colors) {
            colors = colors || [
                "#fff",
                "#000"
            ];
            if (colors && type$2(colors) === "string" && chroma$4.brewer && chroma$4.brewer[colors.toLowerCase()]) colors = chroma$4.brewer[colors.toLowerCase()];
            if (type$2(colors) === "array") {
                // handle single color
                if (colors.length === 1) colors = [
                    colors[0],
                    colors[0]
                ];
                // make a copy of the colors
                colors = colors.slice(0);
                // convert to chroma classes
                for(var c = 0; c < colors.length; c++)colors[c] = chroma$4(colors[c]);
                // auto-fill color position
                _pos.length = 0;
                for(var c$1 = 0; c$1 < colors.length; c$1++)_pos.push(c$1 / (colors.length - 1));
            }
            resetCache();
            return _colors = colors;
        };
        var getClass = function(value) {
            if (_classes != null) {
                var n = _classes.length - 1;
                var i = 0;
                while(i < n && value >= _classes[i])i++;
                return i - 1;
            }
            return 0;
        };
        var tMapLightness = function(t) {
            return t;
        };
        var tMapDomain = function(t) {
            return t;
        };
        // const classifyValue = function(value) {
        //     let val = value;
        //     if (_classes.length > 2) {
        //         const n = _classes.length-1;
        //         const i = getClass(value);
        //         const minc = _classes[0] + ((_classes[1]-_classes[0]) * (0 + (_spread * 0.5)));  // center of 1st class
        //         const maxc = _classes[n-1] + ((_classes[n]-_classes[n-1]) * (1 - (_spread * 0.5)));  // center of last class
        //         val = _min + ((((_classes[i] + ((_classes[i+1] - _classes[i]) * 0.5)) - minc) / (maxc-minc)) * (_max - _min));
        //     }
        //     return val;
        // };
        var getColor = function(val, bypassMap) {
            var col, t;
            if (bypassMap == null) bypassMap = false;
            if (isNaN(val) || val === null) return _nacol;
            if (!bypassMap) {
                if (_classes && _classes.length > 2) {
                    // find the class
                    var c = getClass(val);
                    t = c / (_classes.length - 2);
                } else if (_max !== _min) // just interpolate between min/max
                t = (val - _min) / (_max - _min);
                else t = 1;
            } else t = val;
            // domain map
            t = tMapDomain(t);
            if (!bypassMap) t = tMapLightness(t); // lightness correction
            if (_gamma !== 1) t = pow$3(t, _gamma);
            t = _padding[0] + t * (1 - _padding[0] - _padding[1]);
            t = Math.min(1, Math.max(0, t));
            var k = Math.floor(t * 10000);
            if (_useCache && _colorCache[k]) col = _colorCache[k];
            else {
                if (type$2(_colors) === "array") //for i in [0.._pos.length-1]
                for(var i = 0; i < _pos.length; i++){
                    var p = _pos[i];
                    if (t <= p) {
                        col = _colors[i];
                        break;
                    }
                    if (t >= p && i === _pos.length - 1) {
                        col = _colors[i];
                        break;
                    }
                    if (t > p && t < _pos[i + 1]) {
                        t = (t - p) / (_pos[i + 1] - p);
                        col = chroma$4.interpolate(_colors[i], _colors[i + 1], t, _mode);
                        break;
                    }
                }
                else if (type$2(_colors) === "function") col = _colors(t);
                if (_useCache) _colorCache[k] = col;
            }
            return col;
        };
        var resetCache = function() {
            return _colorCache = {};
        };
        setColors(colors);
        // public interface
        var f = function(v) {
            var c = chroma$4(getColor(v));
            if (_out && c[_out]) return c[_out]();
            else return c;
        };
        f.classes = function(classes) {
            if (classes != null) {
                if (type$2(classes) === "array") {
                    _classes = classes;
                    _domain = [
                        classes[0],
                        classes[classes.length - 1]
                    ];
                } else {
                    var d = chroma$4.analyze(_domain);
                    if (classes === 0) _classes = [
                        d.min,
                        d.max
                    ];
                    else _classes = chroma$4.limits(d, "e", classes);
                }
                return f;
            }
            return _classes;
        };
        f.domain = function(domain) {
            if (!arguments.length) return _domain;
            _min = domain[0];
            _max = domain[domain.length - 1];
            _pos = [];
            var k = _colors.length;
            if (domain.length === k && _min !== _max) // update positions
            for(var i = 0, list = Array.from(domain); i < list.length; i += 1){
                var d = list[i];
                _pos.push((d - _min) / (_max - _min));
            }
            else {
                for(var c = 0; c < k; c++)_pos.push(c / (k - 1));
                if (domain.length > 2) {
                    // set domain map
                    var tOut = domain.map(function(d, i) {
                        return i / (domain.length - 1);
                    });
                    var tBreaks = domain.map(function(d) {
                        return (d - _min) / (_max - _min);
                    });
                    if (!tBreaks.every(function(val, i) {
                        return tOut[i] === val;
                    })) tMapDomain = function(t) {
                        if (t <= 0 || t >= 1) return t;
                        var i = 0;
                        while(t >= tBreaks[i + 1])i++;
                        var f = (t - tBreaks[i]) / (tBreaks[i + 1] - tBreaks[i]);
                        var out = tOut[i] + f * (tOut[i + 1] - tOut[i]);
                        return out;
                    };
                }
            }
            _domain = [
                _min,
                _max
            ];
            return f;
        };
        f.mode = function(_m) {
            if (!arguments.length) return _mode;
            _mode = _m;
            resetCache();
            return f;
        };
        f.range = function(colors, _pos) {
            setColors(colors);
            return f;
        };
        f.out = function(_o) {
            _out = _o;
            return f;
        };
        f.spread = function(val) {
            if (!arguments.length) return _spread;
            _spread = val;
            return f;
        };
        f.correctLightness = function(v) {
            if (v == null) v = true;
            _correctLightness = v;
            resetCache();
            if (_correctLightness) tMapLightness = function(t) {
                var L0 = getColor(0, true).lab()[0];
                var L1 = getColor(1, true).lab()[0];
                var pol = L0 > L1;
                var L_actual = getColor(t, true).lab()[0];
                var L_ideal = L0 + (L1 - L0) * t;
                var L_diff = L_actual - L_ideal;
                var t0 = 0;
                var t1 = 1;
                var max_iter = 20;
                while(Math.abs(L_diff) > 1e-2 && max_iter-- > 0)(function() {
                    if (pol) L_diff *= -1;
                    if (L_diff < 0) {
                        t0 = t;
                        t += (t1 - t) * 0.5;
                    } else {
                        t1 = t;
                        t += (t0 - t) * 0.5;
                    }
                    L_actual = getColor(t, true).lab()[0];
                    return L_diff = L_actual - L_ideal;
                })();
                return t;
            };
            else tMapLightness = function(t) {
                return t;
            };
            return f;
        };
        f.padding = function(p) {
            if (p != null) {
                if (type$2(p) === "number") p = [
                    p,
                    p
                ];
                _padding = p;
                return f;
            } else return _padding;
        };
        f.colors = function(numColors, out) {
            // If no arguments are given, return the original colors that were provided
            if (arguments.length < 2) out = "hex";
            var result = [];
            if (arguments.length === 0) result = _colors.slice(0);
            else if (numColors === 1) result = [
                f(0.5)
            ];
            else if (numColors > 1) {
                var dm = _domain[0];
                var dd = _domain[1] - dm;
                result = __range__(0, numColors, false).map(function(i) {
                    return f(dm + i / (numColors - 1) * dd);
                });
            } else {
                colors = [];
                var samples = [];
                if (_classes && _classes.length > 2) for(var i = 1, end = _classes.length, asc = 1 <= end; asc ? i < end : i > end; asc ? i++ : i--)samples.push((_classes[i - 1] + _classes[i]) * 0.5);
                else samples = _domain;
                result = samples.map(function(v) {
                    return f(v);
                });
            }
            if (chroma$4[out]) result = result.map(function(c) {
                return c[out]();
            });
            return result;
        };
        f.cache = function(c) {
            if (c != null) {
                _useCache = c;
                return f;
            } else return _useCache;
        };
        f.gamma = function(g) {
            if (g != null) {
                _gamma = g;
                return f;
            } else return _gamma;
        };
        f.nodata = function(d) {
            if (d != null) {
                _nacol = chroma$4(d);
                return f;
            } else return _nacol;
        };
        return f;
    };
    function __range__(left, right, inclusive) {
        var range = [];
        var ascending = left < right;
        var end = !inclusive ? right : ascending ? right + 1 : right - 1;
        for(var i = left; ascending ? i < end : i > end; ascending ? i++ : i--)range.push(i);
        return range;
    }
    //
    // interpolates between a set of colors uzing a bezier spline
    //
    // @requires utils lab
    var Color$5 = Color_1;
    var scale$1 = scale$2;
    // nth row of the pascal triangle
    var binom_row = function(n) {
        var row = [
            1,
            1
        ];
        for(var i = 1; i < n; i++){
            var newrow = [
                1
            ];
            for(var j = 1; j <= row.length; j++)newrow[j] = (row[j] || 0) + row[j - 1];
            row = newrow;
        }
        return row;
    };
    var bezier = function(colors) {
        var assign, assign$1, assign$2;
        var I, lab0, lab1, lab2;
        colors = colors.map(function(c) {
            return new Color$5(c);
        });
        if (colors.length === 2) {
            // linear interpolation
            assign = colors.map(function(c) {
                return c.lab();
            }), lab0 = assign[0], lab1 = assign[1];
            I = function(t) {
                var lab = [
                    0,
                    1,
                    2
                ].map(function(i) {
                    return lab0[i] + t * (lab1[i] - lab0[i]);
                });
                return new Color$5(lab, "lab");
            };
        } else if (colors.length === 3) {
            // quadratic bezier interpolation
            assign$1 = colors.map(function(c) {
                return c.lab();
            }), lab0 = assign$1[0], lab1 = assign$1[1], lab2 = assign$1[2];
            I = function(t) {
                var lab = [
                    0,
                    1,
                    2
                ].map(function(i) {
                    return (1 - t) * (1 - t) * lab0[i] + 2 * (1 - t) * t * lab1[i] + t * t * lab2[i];
                });
                return new Color$5(lab, "lab");
            };
        } else if (colors.length === 4) {
            // cubic bezier interpolation
            var lab3;
            assign$2 = colors.map(function(c) {
                return c.lab();
            }), lab0 = assign$2[0], lab1 = assign$2[1], lab2 = assign$2[2], lab3 = assign$2[3];
            I = function(t) {
                var lab = [
                    0,
                    1,
                    2
                ].map(function(i) {
                    return (1 - t) * (1 - t) * (1 - t) * lab0[i] + 3 * (1 - t) * (1 - t) * t * lab1[i] + 3 * (1 - t) * t * t * lab2[i] + t * t * t * lab3[i];
                });
                return new Color$5(lab, "lab");
            };
        } else if (colors.length >= 5) {
            // general case (degree n bezier)
            var labs, row, n;
            labs = colors.map(function(c) {
                return c.lab();
            });
            n = colors.length - 1;
            row = binom_row(n);
            I = function(t) {
                var u = 1 - t;
                var lab = [
                    0,
                    1,
                    2
                ].map(function(i) {
                    return labs.reduce(function(sum, el, j) {
                        return sum + row[j] * Math.pow(u, n - j) * Math.pow(t, j) * el[i];
                    }, 0);
                });
                return new Color$5(lab, "lab");
            };
        } else throw new RangeError("No point in running bezier with only one color.");
        return I;
    };
    var bezier_1 = function(colors) {
        var f = bezier(colors);
        f.scale = function() {
            return scale$1(f);
        };
        return f;
    };
    /*
     * interpolates between a set of colors uzing a bezier spline
     * blend mode formulas taken from http://www.venture-ware.com/kevin/coding/lets-learn-math-photoshop-blend-modes/
     */ var chroma$3 = chroma_1;
    var blend = function(bottom, top, mode) {
        if (!blend[mode]) throw new Error("unknown blend mode " + mode);
        return blend[mode](bottom, top);
    };
    var blend_f = function(f) {
        return function(bottom, top) {
            var c0 = chroma$3(top).rgb();
            var c1 = chroma$3(bottom).rgb();
            return chroma$3.rgb(f(c0, c1));
        };
    };
    var each = function(f) {
        return function(c0, c1) {
            var out = [];
            out[0] = f(c0[0], c1[0]);
            out[1] = f(c0[1], c1[1]);
            out[2] = f(c0[2], c1[2]);
            return out;
        };
    };
    var normal = function(a) {
        return a;
    };
    var multiply = function(a, b) {
        return a * b / 255;
    };
    var darken = function(a, b) {
        return a > b ? b : a;
    };
    var lighten = function(a, b) {
        return a > b ? a : b;
    };
    var screen = function(a, b) {
        return 255 * (1 - (1 - a / 255) * (1 - b / 255));
    };
    var overlay = function(a, b) {
        return b < 128 ? 2 * a * b / 255 : 255 * (1 - 2 * (1 - a / 255) * (1 - b / 255));
    };
    var burn = function(a, b) {
        return 255 * (1 - (1 - b / 255) / (a / 255));
    };
    var dodge = function(a, b) {
        if (a === 255) return 255;
        a = 255 * (b / 255) / (1 - a / 255);
        return a > 255 ? 255 : a;
    };
    // # add = (a,b) ->
    // #     if (a + b > 255) then 255 else a + b
    blend.normal = blend_f(each(normal));
    blend.multiply = blend_f(each(multiply));
    blend.screen = blend_f(each(screen));
    blend.overlay = blend_f(each(overlay));
    blend.darken = blend_f(each(darken));
    blend.lighten = blend_f(each(lighten));
    blend.dodge = blend_f(each(dodge));
    blend.burn = blend_f(each(burn));
    // blend.add = blend_f(each(add));
    var blend_1 = blend;
    // cubehelix interpolation
    // based on D.A. Green "A colour scheme for the display of astronomical intensity images"
    // http://astron-soc.in/bulletin/11June/289392011.pdf
    var type$1 = utils.type;
    var clip_rgb = utils.clip_rgb;
    var TWOPI = utils.TWOPI;
    var pow$2 = Math.pow;
    var sin$1 = Math.sin;
    var cos$1 = Math.cos;
    var chroma$2 = chroma_1;
    var cubehelix = function(start, rotations, hue, gamma, lightness) {
        if (start === void 0) start = 300;
        if (rotations === void 0) rotations = -1.5;
        if (hue === void 0) hue = 1;
        if (gamma === void 0) gamma = 1;
        if (lightness === void 0) lightness = [
            0,
            1
        ];
        var dh = 0, dl;
        if (type$1(lightness) === "array") dl = lightness[1] - lightness[0];
        else {
            dl = 0;
            lightness = [
                lightness,
                lightness
            ];
        }
        var f = function(fract) {
            var a = TWOPI * ((start + 120) / 360 + rotations * fract);
            var l = pow$2(lightness[0] + dl * fract, gamma);
            var h = dh !== 0 ? hue[0] + fract * dh : hue;
            var amp = h * l * (1 - l) / 2;
            var cos_a = cos$1(a);
            var sin_a = sin$1(a);
            var r = l + amp * (-0.14861 * cos_a + 1.78277 * sin_a);
            var g = l + amp * (-0.29227 * cos_a - 0.90649 * sin_a);
            var b = l + amp * (1.97294 * cos_a);
            return chroma$2(clip_rgb([
                r * 255,
                g * 255,
                b * 255,
                1
            ]));
        };
        f.start = function(s) {
            if (s == null) return start;
            start = s;
            return f;
        };
        f.rotations = function(r) {
            if (r == null) return rotations;
            rotations = r;
            return f;
        };
        f.gamma = function(g) {
            if (g == null) return gamma;
            gamma = g;
            return f;
        };
        f.hue = function(h) {
            if (h == null) return hue;
            hue = h;
            if (type$1(hue) === "array") {
                dh = hue[1] - hue[0];
                if (dh === 0) hue = hue[1];
            } else dh = 0;
            return f;
        };
        f.lightness = function(h) {
            if (h == null) return lightness;
            if (type$1(h) === "array") {
                lightness = h;
                dl = h[1] - h[0];
            } else {
                lightness = [
                    h,
                    h
                ];
                dl = 0;
            }
            return f;
        };
        f.scale = function() {
            return chroma$2.scale(f);
        };
        f.hue(hue);
        return f;
    };
    var Color$4 = Color_1;
    var digits = "0123456789abcdef";
    var floor$1 = Math.floor;
    var random = Math.random;
    var random_1 = function() {
        var code = "#";
        for(var i = 0; i < 6; i++)code += digits.charAt(floor$1(random() * 16));
        return new Color$4(code, "hex");
    };
    var type = type$p;
    var log = Math.log;
    var pow$1 = Math.pow;
    var floor = Math.floor;
    var abs$1 = Math.abs;
    var analyze = function(data, key) {
        if (key === void 0) key = null;
        var r = {
            min: Number.MAX_VALUE,
            max: Number.MAX_VALUE * -1,
            sum: 0,
            values: [],
            count: 0
        };
        if (type(data) === "object") data = Object.values(data);
        data.forEach(function(val) {
            if (key && type(val) === "object") val = val[key];
            if (val !== undefined && val !== null && !isNaN(val)) {
                r.values.push(val);
                r.sum += val;
                if (val < r.min) r.min = val;
                if (val > r.max) r.max = val;
                r.count += 1;
            }
        });
        r.domain = [
            r.min,
            r.max
        ];
        r.limits = function(mode, num) {
            return limits(r, mode, num);
        };
        return r;
    };
    var limits = function(data, mode, num) {
        if (mode === void 0) mode = "equal";
        if (num === void 0) num = 7;
        if (type(data) == "array") data = analyze(data);
        var min = data.min;
        var max = data.max;
        var values = data.values.sort(function(a, b) {
            return a - b;
        });
        if (num === 1) return [
            min,
            max
        ];
        var limits = [];
        if (mode.substr(0, 1) === "c") {
            limits.push(min);
            limits.push(max);
        }
        if (mode.substr(0, 1) === "e") {
            limits.push(min);
            for(var i = 1; i < num; i++)limits.push(min + i / num * (max - min));
            limits.push(max);
        } else if (mode.substr(0, 1) === "l") {
            if (min <= 0) throw new Error("Logarithmic scales are only possible for values > 0");
            var min_log = Math.LOG10E * log(min);
            var max_log = Math.LOG10E * log(max);
            limits.push(min);
            for(var i$1 = 1; i$1 < num; i$1++)limits.push(pow$1(10, min_log + i$1 / num * (max_log - min_log)));
            limits.push(max);
        } else if (mode.substr(0, 1) === "q") {
            limits.push(min);
            for(var i$2 = 1; i$2 < num; i$2++){
                var p = (values.length - 1) * i$2 / num;
                var pb = floor(p);
                if (pb === p) limits.push(values[pb]);
                else {
                    var pr = p - pb;
                    limits.push(values[pb] * (1 - pr) + values[pb + 1] * pr);
                }
            }
            limits.push(max);
        } else if (mode.substr(0, 1) === "k") {
            /*
            implementation based on
            http://code.google.com/p/figue/source/browse/trunk/figue.js#336
            simplified for 1-d input values
            */ var cluster;
            var n = values.length;
            var assignments = new Array(n);
            var clusterSizes = new Array(num);
            var repeat = true;
            var nb_iters = 0;
            var centroids = null;
            // get seed values
            centroids = [];
            centroids.push(min);
            for(var i$3 = 1; i$3 < num; i$3++)centroids.push(min + i$3 / num * (max - min));
            centroids.push(max);
            while(repeat){
                // assignment step
                for(var j = 0; j < num; j++)clusterSizes[j] = 0;
                for(var i$4 = 0; i$4 < n; i$4++){
                    var value = values[i$4];
                    var mindist = Number.MAX_VALUE;
                    var best = void 0;
                    for(var j$1 = 0; j$1 < num; j$1++){
                        var dist = abs$1(centroids[j$1] - value);
                        if (dist < mindist) {
                            mindist = dist;
                            best = j$1;
                        }
                        clusterSizes[best]++;
                        assignments[i$4] = best;
                    }
                }
                // update centroids step
                var newCentroids = new Array(num);
                for(var j$2 = 0; j$2 < num; j$2++)newCentroids[j$2] = null;
                for(var i$5 = 0; i$5 < n; i$5++){
                    cluster = assignments[i$5];
                    if (newCentroids[cluster] === null) newCentroids[cluster] = values[i$5];
                    else newCentroids[cluster] += values[i$5];
                }
                for(var j$3 = 0; j$3 < num; j$3++)newCentroids[j$3] *= 1 / clusterSizes[j$3];
                // check convergence
                repeat = false;
                for(var j$4 = 0; j$4 < num; j$4++)if (newCentroids[j$4] !== centroids[j$4]) {
                    repeat = true;
                    break;
                }
                centroids = newCentroids;
                nb_iters++;
                if (nb_iters > 200) repeat = false;
            }
            // finished k-means clustering
            // the next part is borrowed from gabrielflor.it
            var kClusters = {};
            for(var j$5 = 0; j$5 < num; j$5++)kClusters[j$5] = [];
            for(var i$6 = 0; i$6 < n; i$6++){
                cluster = assignments[i$6];
                kClusters[cluster].push(values[i$6]);
            }
            var tmpKMeansBreaks = [];
            for(var j$6 = 0; j$6 < num; j$6++){
                tmpKMeansBreaks.push(kClusters[j$6][0]);
                tmpKMeansBreaks.push(kClusters[j$6][kClusters[j$6].length - 1]);
            }
            tmpKMeansBreaks = tmpKMeansBreaks.sort(function(a, b) {
                return a - b;
            });
            limits.push(tmpKMeansBreaks[0]);
            for(var i$7 = 1; i$7 < tmpKMeansBreaks.length; i$7 += 2){
                var v = tmpKMeansBreaks[i$7];
                if (!isNaN(v) && limits.indexOf(v) === -1) limits.push(v);
            }
        }
        return limits;
    };
    var analyze_1 = {
        analyze: analyze,
        limits: limits
    };
    var Color$3 = Color_1;
    var contrast = function(a, b) {
        // WCAG contrast ratio
        // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
        a = new Color$3(a);
        b = new Color$3(b);
        var l1 = a.luminance();
        var l2 = b.luminance();
        return l1 > l2 ? (l1 + 0.05) / (l2 + 0.05) : (l2 + 0.05) / (l1 + 0.05);
    };
    var Color$2 = Color_1;
    var sqrt = Math.sqrt;
    var pow = Math.pow;
    var min = Math.min;
    var max = Math.max;
    var atan2 = Math.atan2;
    var abs = Math.abs;
    var cos = Math.cos;
    var sin = Math.sin;
    var exp = Math.exp;
    var PI = Math.PI;
    var deltaE = function(a, b, Kl, Kc, Kh) {
        if (Kl === void 0) Kl = 1;
        if (Kc === void 0) Kc = 1;
        if (Kh === void 0) Kh = 1;
        // Delta E (CIE 2000)
        // see http://www.brucelindbloom.com/index.html?Eqn_DeltaE_CIE2000.html
        var rad2deg = function(rad) {
            return 360 * rad / (2 * PI);
        };
        var deg2rad = function(deg) {
            return 2 * PI * deg / 360;
        };
        a = new Color$2(a);
        b = new Color$2(b);
        var ref = Array.from(a.lab());
        var L1 = ref[0];
        var a1 = ref[1];
        var b1 = ref[2];
        var ref$1 = Array.from(b.lab());
        var L2 = ref$1[0];
        var a2 = ref$1[1];
        var b2 = ref$1[2];
        var avgL = (L1 + L2) / 2;
        var C1 = sqrt(pow(a1, 2) + pow(b1, 2));
        var C2 = sqrt(pow(a2, 2) + pow(b2, 2));
        var avgC = (C1 + C2) / 2;
        var G = 0.5 * (1 - sqrt(pow(avgC, 7) / (pow(avgC, 7) + pow(25, 7))));
        var a1p = a1 * (1 + G);
        var a2p = a2 * (1 + G);
        var C1p = sqrt(pow(a1p, 2) + pow(b1, 2));
        var C2p = sqrt(pow(a2p, 2) + pow(b2, 2));
        var avgCp = (C1p + C2p) / 2;
        var arctan1 = rad2deg(atan2(b1, a1p));
        var arctan2 = rad2deg(atan2(b2, a2p));
        var h1p = arctan1 >= 0 ? arctan1 : arctan1 + 360;
        var h2p = arctan2 >= 0 ? arctan2 : arctan2 + 360;
        var avgHp = abs(h1p - h2p) > 180 ? (h1p + h2p + 360) / 2 : (h1p + h2p) / 2;
        var T = 1 - 0.17 * cos(deg2rad(avgHp - 30)) + 0.24 * cos(deg2rad(2 * avgHp)) + 0.32 * cos(deg2rad(3 * avgHp + 6)) - 0.2 * cos(deg2rad(4 * avgHp - 63));
        var deltaHp = h2p - h1p;
        deltaHp = abs(deltaHp) <= 180 ? deltaHp : h2p <= h1p ? deltaHp + 360 : deltaHp - 360;
        deltaHp = 2 * sqrt(C1p * C2p) * sin(deg2rad(deltaHp) / 2);
        var deltaL = L2 - L1;
        var deltaCp = C2p - C1p;
        var sl = 1 + 0.015 * pow(avgL - 50, 2) / sqrt(20 + pow(avgL - 50, 2));
        var sc = 1 + 0.045 * avgCp;
        var sh = 1 + 0.015 * avgCp * T;
        var deltaTheta = 30 * exp(-pow((avgHp - 275) / 25, 2));
        var Rc = 2 * sqrt(pow(avgCp, 7) / (pow(avgCp, 7) + pow(25, 7)));
        var Rt = -Rc * sin(2 * deg2rad(deltaTheta));
        var result = sqrt(pow(deltaL / (Kl * sl), 2) + pow(deltaCp / (Kc * sc), 2) + pow(deltaHp / (Kh * sh), 2) + Rt * (deltaCp / (Kc * sc)) * (deltaHp / (Kh * sh)));
        return max(0, min(100, result));
    };
    var Color$1 = Color_1;
    // simple Euclidean distance
    var distance = function(a, b, mode) {
        if (mode === void 0) mode = "lab";
        // Delta E (CIE 1976)
        // see http://www.brucelindbloom.com/index.html?Equations.html
        a = new Color$1(a);
        b = new Color$1(b);
        var l1 = a.get(mode);
        var l2 = b.get(mode);
        var sum_sq = 0;
        for(var i in l1){
            var d = (l1[i] || 0) - (l2[i] || 0);
            sum_sq += d * d;
        }
        return Math.sqrt(sum_sq);
    };
    var Color = Color_1;
    var valid = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        try {
            new (Function.prototype.bind.apply(Color, [
                null
            ].concat(args)));
            return true;
        } catch (e) {
            return false;
        }
    };
    // some pre-defined color scales:
    var chroma$1 = chroma_1;
    var scale = scale$2;
    var scales = {
        cool: function cool() {
            return scale([
                chroma$1.hsl(180, 1, .9),
                chroma$1.hsl(250, .7, .4)
            ]);
        },
        hot: function hot() {
            return scale([
                "#000",
                "#f00",
                "#ff0",
                "#fff"
            ]).mode("rgb");
        }
    };
    /**
        ColorBrewer colors for chroma.js

        Copyright (c) 2002 Cynthia Brewer, Mark Harrower, and The
        Pennsylvania State University.

        Licensed under the Apache License, Version 2.0 (the "License");
        you may not use this file except in compliance with the License.
        You may obtain a copy of the License at
        http://www.apache.org/licenses/LICENSE-2.0

        Unless required by applicable law or agreed to in writing, software distributed
        under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
        CONDITIONS OF ANY KIND, either express or implied. See the License for the
        specific language governing permissions and limitations under the License.
    */ var colorbrewer = {
        // sequential
        OrRd: [
            "#fff7ec",
            "#fee8c8",
            "#fdd49e",
            "#fdbb84",
            "#fc8d59",
            "#ef6548",
            "#d7301f",
            "#b30000",
            "#7f0000"
        ],
        PuBu: [
            "#fff7fb",
            "#ece7f2",
            "#d0d1e6",
            "#a6bddb",
            "#74a9cf",
            "#3690c0",
            "#0570b0",
            "#045a8d",
            "#023858"
        ],
        BuPu: [
            "#f7fcfd",
            "#e0ecf4",
            "#bfd3e6",
            "#9ebcda",
            "#8c96c6",
            "#8c6bb1",
            "#88419d",
            "#810f7c",
            "#4d004b"
        ],
        Oranges: [
            "#fff5eb",
            "#fee6ce",
            "#fdd0a2",
            "#fdae6b",
            "#fd8d3c",
            "#f16913",
            "#d94801",
            "#a63603",
            "#7f2704"
        ],
        BuGn: [
            "#f7fcfd",
            "#e5f5f9",
            "#ccece6",
            "#99d8c9",
            "#66c2a4",
            "#41ae76",
            "#238b45",
            "#006d2c",
            "#00441b"
        ],
        YlOrBr: [
            "#ffffe5",
            "#fff7bc",
            "#fee391",
            "#fec44f",
            "#fe9929",
            "#ec7014",
            "#cc4c02",
            "#993404",
            "#662506"
        ],
        YlGn: [
            "#ffffe5",
            "#f7fcb9",
            "#d9f0a3",
            "#addd8e",
            "#78c679",
            "#41ab5d",
            "#238443",
            "#006837",
            "#004529"
        ],
        Reds: [
            "#fff5f0",
            "#fee0d2",
            "#fcbba1",
            "#fc9272",
            "#fb6a4a",
            "#ef3b2c",
            "#cb181d",
            "#a50f15",
            "#67000d"
        ],
        RdPu: [
            "#fff7f3",
            "#fde0dd",
            "#fcc5c0",
            "#fa9fb5",
            "#f768a1",
            "#dd3497",
            "#ae017e",
            "#7a0177",
            "#49006a"
        ],
        Greens: [
            "#f7fcf5",
            "#e5f5e0",
            "#c7e9c0",
            "#a1d99b",
            "#74c476",
            "#41ab5d",
            "#238b45",
            "#006d2c",
            "#00441b"
        ],
        YlGnBu: [
            "#ffffd9",
            "#edf8b1",
            "#c7e9b4",
            "#7fcdbb",
            "#41b6c4",
            "#1d91c0",
            "#225ea8",
            "#253494",
            "#081d58"
        ],
        Purples: [
            "#fcfbfd",
            "#efedf5",
            "#dadaeb",
            "#bcbddc",
            "#9e9ac8",
            "#807dba",
            "#6a51a3",
            "#54278f",
            "#3f007d"
        ],
        GnBu: [
            "#f7fcf0",
            "#e0f3db",
            "#ccebc5",
            "#a8ddb5",
            "#7bccc4",
            "#4eb3d3",
            "#2b8cbe",
            "#0868ac",
            "#084081"
        ],
        Greys: [
            "#ffffff",
            "#f0f0f0",
            "#d9d9d9",
            "#bdbdbd",
            "#969696",
            "#737373",
            "#525252",
            "#252525",
            "#000000"
        ],
        YlOrRd: [
            "#ffffcc",
            "#ffeda0",
            "#fed976",
            "#feb24c",
            "#fd8d3c",
            "#fc4e2a",
            "#e31a1c",
            "#bd0026",
            "#800026"
        ],
        PuRd: [
            "#f7f4f9",
            "#e7e1ef",
            "#d4b9da",
            "#c994c7",
            "#df65b0",
            "#e7298a",
            "#ce1256",
            "#980043",
            "#67001f"
        ],
        Blues: [
            "#f7fbff",
            "#deebf7",
            "#c6dbef",
            "#9ecae1",
            "#6baed6",
            "#4292c6",
            "#2171b5",
            "#08519c",
            "#08306b"
        ],
        PuBuGn: [
            "#fff7fb",
            "#ece2f0",
            "#d0d1e6",
            "#a6bddb",
            "#67a9cf",
            "#3690c0",
            "#02818a",
            "#016c59",
            "#014636"
        ],
        Viridis: [
            "#440154",
            "#482777",
            "#3f4a8a",
            "#31678e",
            "#26838f",
            "#1f9d8a",
            "#6cce5a",
            "#b6de2b",
            "#fee825"
        ],
        // diverging
        Spectral: [
            "#9e0142",
            "#d53e4f",
            "#f46d43",
            "#fdae61",
            "#fee08b",
            "#ffffbf",
            "#e6f598",
            "#abdda4",
            "#66c2a5",
            "#3288bd",
            "#5e4fa2"
        ],
        RdYlGn: [
            "#a50026",
            "#d73027",
            "#f46d43",
            "#fdae61",
            "#fee08b",
            "#ffffbf",
            "#d9ef8b",
            "#a6d96a",
            "#66bd63",
            "#1a9850",
            "#006837"
        ],
        RdBu: [
            "#67001f",
            "#b2182b",
            "#d6604d",
            "#f4a582",
            "#fddbc7",
            "#f7f7f7",
            "#d1e5f0",
            "#92c5de",
            "#4393c3",
            "#2166ac",
            "#053061"
        ],
        PiYG: [
            "#8e0152",
            "#c51b7d",
            "#de77ae",
            "#f1b6da",
            "#fde0ef",
            "#f7f7f7",
            "#e6f5d0",
            "#b8e186",
            "#7fbc41",
            "#4d9221",
            "#276419"
        ],
        PRGn: [
            "#40004b",
            "#762a83",
            "#9970ab",
            "#c2a5cf",
            "#e7d4e8",
            "#f7f7f7",
            "#d9f0d3",
            "#a6dba0",
            "#5aae61",
            "#1b7837",
            "#00441b"
        ],
        RdYlBu: [
            "#a50026",
            "#d73027",
            "#f46d43",
            "#fdae61",
            "#fee090",
            "#ffffbf",
            "#e0f3f8",
            "#abd9e9",
            "#74add1",
            "#4575b4",
            "#313695"
        ],
        BrBG: [
            "#543005",
            "#8c510a",
            "#bf812d",
            "#dfc27d",
            "#f6e8c3",
            "#f5f5f5",
            "#c7eae5",
            "#80cdc1",
            "#35978f",
            "#01665e",
            "#003c30"
        ],
        RdGy: [
            "#67001f",
            "#b2182b",
            "#d6604d",
            "#f4a582",
            "#fddbc7",
            "#ffffff",
            "#e0e0e0",
            "#bababa",
            "#878787",
            "#4d4d4d",
            "#1a1a1a"
        ],
        PuOr: [
            "#7f3b08",
            "#b35806",
            "#e08214",
            "#fdb863",
            "#fee0b6",
            "#f7f7f7",
            "#d8daeb",
            "#b2abd2",
            "#8073ac",
            "#542788",
            "#2d004b"
        ],
        // qualitative
        Set2: [
            "#66c2a5",
            "#fc8d62",
            "#8da0cb",
            "#e78ac3",
            "#a6d854",
            "#ffd92f",
            "#e5c494",
            "#b3b3b3"
        ],
        Accent: [
            "#7fc97f",
            "#beaed4",
            "#fdc086",
            "#ffff99",
            "#386cb0",
            "#f0027f",
            "#bf5b17",
            "#666666"
        ],
        Set1: [
            "#e41a1c",
            "#377eb8",
            "#4daf4a",
            "#984ea3",
            "#ff7f00",
            "#ffff33",
            "#a65628",
            "#f781bf",
            "#999999"
        ],
        Set3: [
            "#8dd3c7",
            "#ffffb3",
            "#bebada",
            "#fb8072",
            "#80b1d3",
            "#fdb462",
            "#b3de69",
            "#fccde5",
            "#d9d9d9",
            "#bc80bd",
            "#ccebc5",
            "#ffed6f"
        ],
        Dark2: [
            "#1b9e77",
            "#d95f02",
            "#7570b3",
            "#e7298a",
            "#66a61e",
            "#e6ab02",
            "#a6761d",
            "#666666"
        ],
        Paired: [
            "#a6cee3",
            "#1f78b4",
            "#b2df8a",
            "#33a02c",
            "#fb9a99",
            "#e31a1c",
            "#fdbf6f",
            "#ff7f00",
            "#cab2d6",
            "#6a3d9a",
            "#ffff99",
            "#b15928"
        ],
        Pastel2: [
            "#b3e2cd",
            "#fdcdac",
            "#cbd5e8",
            "#f4cae4",
            "#e6f5c9",
            "#fff2ae",
            "#f1e2cc",
            "#cccccc"
        ],
        Pastel1: [
            "#fbb4ae",
            "#b3cde3",
            "#ccebc5",
            "#decbe4",
            "#fed9a6",
            "#ffffcc",
            "#e5d8bd",
            "#fddaec",
            "#f2f2f2"
        ]
    };
    // add lowercase aliases for case-insensitive matches
    for(var i = 0, list = Object.keys(colorbrewer); i < list.length; i += 1){
        var key = list[i];
        colorbrewer[key.toLowerCase()] = colorbrewer[key];
    }
    var colorbrewer_1 = colorbrewer;
    var chroma = chroma_1;
    // feel free to comment out anything to rollup
    // a smaller chroma.js built
    // io --> convert colors
    // operators --> modify existing Colors
    // interpolators
    // generators -- > create new colors
    chroma.average = average;
    chroma.bezier = bezier_1;
    chroma.blend = blend_1;
    chroma.cubehelix = cubehelix;
    chroma.mix = chroma.interpolate = mix$1;
    chroma.random = random_1;
    chroma.scale = scale$2;
    // other utility methods
    chroma.analyze = analyze_1.analyze;
    chroma.contrast = contrast;
    chroma.deltaE = deltaE;
    chroma.distance = distance;
    chroma.limits = analyze_1.limits;
    chroma.valid = valid;
    // scale
    chroma.scales = scales;
    // colors
    chroma.colors = w3cx11_1;
    chroma.brewer = colorbrewer_1;
    var chroma_js = chroma;
    return chroma_js;
});



function $adcf363a09f534a1$var$e(e, t) {
    for(var o = 0; o < t.length; o++){
        var n = t[o];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
}
function $adcf363a09f534a1$var$t(e) {
    return function(e) {
        if (Array.isArray(e)) return $adcf363a09f534a1$var$o(e);
    }(e) || function(e) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
    }(e) || function(e, t) {
        if (!e) return;
        if ("string" == typeof e) return $adcf363a09f534a1$var$o(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === n && e.constructor && (n = e.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(e);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $adcf363a09f534a1$var$o(e, t);
    }(e) || function() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $adcf363a09f534a1$var$o(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
    return n;
}
var $adcf363a09f534a1$var$n, $adcf363a09f534a1$var$i, $adcf363a09f534a1$var$a, $adcf363a09f534a1$var$r, $adcf363a09f534a1$var$s, $adcf363a09f534a1$var$l = ($adcf363a09f534a1$var$n = [
    "a[href]",
    "area[href]",
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    "select:not([disabled]):not([aria-hidden])",
    "textarea:not([disabled]):not([aria-hidden])",
    "button:not([disabled]):not([aria-hidden])",
    "iframe",
    "object",
    "embed",
    "[contenteditable]",
    '[tabindex]:not([tabindex^="-"])'
], $adcf363a09f534a1$var$i = function() {
    function o(e) {
        var n = e.targetModal, i = e.triggers, a = void 0 === i ? [] : i, r = e.onShow, s = void 0 === r ? function() {} : r, l = e.onClose, c = void 0 === l ? function() {} : l, d = e.openTrigger, u = void 0 === d ? "data-micromodal-trigger" : d, f = e.closeTrigger, h = void 0 === f ? "data-micromodal-close" : f, v = e.openClass, g = void 0 === v ? "is-open" : v, m = e.disableScroll, b = void 0 !== m && m, y = e.disableFocus, p = void 0 !== y && y, w = e.awaitCloseAnimation, E = void 0 !== w && w, k = e.awaitOpenAnimation, M = void 0 !== k && k, A = e.debugMode, C = void 0 !== A && A;
        !function(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, o), this.modal = document.getElementById(n), this.config = {
            debugMode: C,
            disableScroll: b,
            openTrigger: u,
            closeTrigger: h,
            openClass: g,
            onShow: s,
            onClose: c,
            awaitCloseAnimation: E,
            awaitOpenAnimation: M,
            disableFocus: p
        }, a.length > 0 && this.registerTriggers.apply(this, $adcf363a09f534a1$var$t(a)), this.onClick = this.onClick.bind(this), this.onKeydown = this.onKeydown.bind(this);
    }
    var i, a, r;
    return i = o, a = [
        {
            key: "registerTriggers",
            value: function() {
                for(var e = this, t = arguments.length, o = new Array(t), n = 0; n < t; n++)o[n] = arguments[n];
                o.filter(Boolean).forEach(function(t) {
                    t.addEventListener("click", function(t) {
                        return e.showModal(t);
                    });
                });
            }
        },
        {
            key: "showModal",
            value: function() {
                var e = this, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                if (this.activeElement = document.activeElement, this.modal.setAttribute("aria-hidden", "false"), this.modal.classList.add(this.config.openClass), this.scrollBehaviour("disable"), this.addEventListeners(), this.config.awaitOpenAnimation) {
                    var o = function t() {
                        e.modal.removeEventListener("animationend", t, !1), e.setFocusToFirstNode();
                    };
                    this.modal.addEventListener("animationend", o, !1);
                } else this.setFocusToFirstNode();
                this.config.onShow(this.modal, this.activeElement, t);
            }
        },
        {
            key: "closeModal",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, t = this.modal;
                if (this.modal.setAttribute("aria-hidden", "true"), this.removeEventListeners(), this.scrollBehaviour("enable"), this.activeElement && this.activeElement.focus && this.activeElement.focus(), this.config.onClose(this.modal, this.activeElement, e), this.config.awaitCloseAnimation) {
                    var o = this.config.openClass;
                    this.modal.addEventListener("animationend", function e() {
                        t.classList.remove(o), t.removeEventListener("animationend", e, !1);
                    }, !1);
                } else t.classList.remove(this.config.openClass);
            }
        },
        {
            key: "closeModalById",
            value: function(e) {
                this.modal = document.getElementById(e), this.modal && this.closeModal();
            }
        },
        {
            key: "scrollBehaviour",
            value: function(e) {
                if (this.config.disableScroll) {
                    var t = document.querySelector("body");
                    switch(e){
                        case "enable":
                            Object.assign(t.style, {
                                overflow: ""
                            });
                            break;
                        case "disable":
                            Object.assign(t.style, {
                                overflow: "hidden"
                            });
                    }
                }
            }
        },
        {
            key: "addEventListeners",
            value: function() {
                this.modal.addEventListener("touchstart", this.onClick), this.modal.addEventListener("click", this.onClick), document.addEventListener("keydown", this.onKeydown);
            }
        },
        {
            key: "removeEventListeners",
            value: function() {
                this.modal.removeEventListener("touchstart", this.onClick), this.modal.removeEventListener("click", this.onClick), document.removeEventListener("keydown", this.onKeydown);
            }
        },
        {
            key: "onClick",
            value: function(e) {
                (e.target.hasAttribute(this.config.closeTrigger) || e.target.parentNode.hasAttribute(this.config.closeTrigger)) && (e.preventDefault(), e.stopPropagation(), this.closeModal(e));
            }
        },
        {
            key: "onKeydown",
            value: function(e) {
                27 === e.keyCode && this.closeModal(e), 9 === e.keyCode && this.retainFocus(e);
            }
        },
        {
            key: "getFocusableNodes",
            value: function() {
                var e = this.modal.querySelectorAll($adcf363a09f534a1$var$n);
                return Array.apply(void 0, $adcf363a09f534a1$var$t(e));
            }
        },
        {
            key: "setFocusToFirstNode",
            value: function() {
                var e = this;
                if (!this.config.disableFocus) {
                    var t = this.getFocusableNodes();
                    if (0 !== t.length) {
                        var o = t.filter(function(t) {
                            return !t.hasAttribute(e.config.closeTrigger);
                        });
                        o.length > 0 && o[0].focus(), 0 === o.length && t[0].focus();
                    }
                }
            }
        },
        {
            key: "retainFocus",
            value: function(e) {
                var t = this.getFocusableNodes();
                if (0 !== t.length) {
                    if (t = t.filter(function(e) {
                        return null !== e.offsetParent;
                    }), this.modal.contains(document.activeElement)) {
                        var o = t.indexOf(document.activeElement);
                        e.shiftKey && 0 === o && (t[t.length - 1].focus(), e.preventDefault()), !e.shiftKey && t.length > 0 && o === t.length - 1 && (t[0].focus(), e.preventDefault());
                    } else t[0].focus();
                }
            }
        }
    ], $adcf363a09f534a1$var$e(i.prototype, a), r && $adcf363a09f534a1$var$e(i, r), o;
}(), $adcf363a09f534a1$var$a = null, $adcf363a09f534a1$var$r = function(e) {
    if (!document.getElementById(e)) return console.warn("MicroModal: \u2757Seems like you have missed %c'".concat(e, "'"), "background-color: #f8f9fa;color: #50596c;font-weight: bold;", "ID somewhere in your code. Refer example below to resolve it."), console.warn("%cExample:", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", '<div class="modal" id="'.concat(e, '"></div>')), !1;
}, $adcf363a09f534a1$var$s = function(e, t) {
    if (function(e) {
        e.length <= 0 && (console.warn("MicroModal: \u2757Please specify at least one %c'micromodal-trigger'", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", "data attribute."), console.warn("%cExample:", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", '<a href="#" data-micromodal-trigger="my-modal"></a>'));
    }(e), !t) return !0;
    for(var o in t)$adcf363a09f534a1$var$r(o);
    return !0;
}, {
    init: function(e) {
        var o = Object.assign({}, {
            openTrigger: "data-micromodal-trigger"
        }, e), n = $adcf363a09f534a1$var$t(document.querySelectorAll("[".concat(o.openTrigger, "]"))), r = function(e, t) {
            var o = [];
            return e.forEach(function(e) {
                var n = e.attributes[t].value;
                void 0 === o[n] && (o[n] = []), o[n].push(e);
            }), o;
        }(n, o.openTrigger);
        if (!0 !== o.debugMode || !1 !== $adcf363a09f534a1$var$s(n, r)) for(var l in r){
            var c = r[l];
            o.targetModal = l, o.triggers = $adcf363a09f534a1$var$t(c), $adcf363a09f534a1$var$a = new $adcf363a09f534a1$var$i(o);
        }
    },
    show: function(e, t) {
        var o = t || {};
        o.targetModal = e, !0 === o.debugMode && !1 === $adcf363a09f534a1$var$r(e) || ($adcf363a09f534a1$var$a && $adcf363a09f534a1$var$a.removeEventListeners(), ($adcf363a09f534a1$var$a = new $adcf363a09f534a1$var$i(o)).showModal());
    },
    close: function(e) {
        e ? $adcf363a09f534a1$var$a.closeModalById(e) : $adcf363a09f534a1$var$a.closeModal();
    }
});
"undefined" != typeof window && (window.MicroModal = $adcf363a09f534a1$var$l);
var $adcf363a09f534a1$export$2e2bcd8739ae039 = $adcf363a09f534a1$var$l;


/*! medium-zoom 1.1.0 | MIT License | https://github.com/francoischalifour/medium-zoom */ var $4ffa2ba0c2b40bcc$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $4ffa2ba0c2b40bcc$var$isSupported = function isSupported(node) {
    return node.tagName === "IMG";
};
/* eslint-disable-next-line no-prototype-builtins */ var $4ffa2ba0c2b40bcc$var$isNodeList = function isNodeList(selector) {
    return NodeList.prototype.isPrototypeOf(selector);
};
var $4ffa2ba0c2b40bcc$var$isNode = function isNode(selector) {
    return selector && selector.nodeType === 1;
};
var $4ffa2ba0c2b40bcc$var$isSvg = function isSvg(image) {
    var source = image.currentSrc || image.src;
    return source.substr(-4).toLowerCase() === ".svg";
};
var $4ffa2ba0c2b40bcc$var$getImagesFromSelector = function getImagesFromSelector(selector) {
    try {
        if (Array.isArray(selector)) return selector.filter($4ffa2ba0c2b40bcc$var$isSupported);
        if ($4ffa2ba0c2b40bcc$var$isNodeList(selector)) // Do not use spread operator or Array.from() for IE support
        return [].slice.call(selector).filter($4ffa2ba0c2b40bcc$var$isSupported);
        if ($4ffa2ba0c2b40bcc$var$isNode(selector)) return [
            selector
        ].filter($4ffa2ba0c2b40bcc$var$isSupported);
        if (typeof selector === "string") // Do not use spread operator or Array.from() for IE support
        return [].slice.call(document.querySelectorAll(selector)).filter($4ffa2ba0c2b40bcc$var$isSupported);
        return [];
    } catch (err) {
        throw new TypeError("The provided selector is invalid.\nExpects a CSS selector, a Node element, a NodeList or an array.\nSee: https://github.com/francoischalifour/medium-zoom");
    }
};
var $4ffa2ba0c2b40bcc$var$createOverlay = function createOverlay(background) {
    var overlay = document.createElement("div");
    overlay.classList.add("medium-zoom-overlay");
    overlay.style.background = background;
    return overlay;
};
var $4ffa2ba0c2b40bcc$var$cloneTarget = function cloneTarget(template) {
    var _template$getBounding = template.getBoundingClientRect(), top = _template$getBounding.top, left = _template$getBounding.left, width = _template$getBounding.width, height = _template$getBounding.height;
    var clone = template.cloneNode();
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
    clone.removeAttribute("id");
    clone.style.position = "absolute";
    clone.style.top = top + scrollTop + "px";
    clone.style.left = left + scrollLeft + "px";
    clone.style.width = width + "px";
    clone.style.height = height + "px";
    clone.style.transform = "";
    return clone;
};
var $4ffa2ba0c2b40bcc$var$createCustomEvent = function createCustomEvent(type, params) {
    var eventParams = $4ffa2ba0c2b40bcc$var$_extends({
        bubbles: false,
        cancelable: false,
        detail: undefined
    }, params);
    if (typeof window.CustomEvent === "function") return new CustomEvent(type, eventParams);
    var customEvent = document.createEvent("CustomEvent");
    customEvent.initCustomEvent(type, eventParams.bubbles, eventParams.cancelable, eventParams.detail);
    return customEvent;
};
var $4ffa2ba0c2b40bcc$var$mediumZoom = function mediumZoom(selector) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    /**
   * Ensure the compatibility with IE11 if no Promise polyfill are used.
   */ var Promise = window.Promise || function Promise(fn) {
        function noop() {}
        fn(noop, noop);
    };
    var _handleClick = function _handleClick(event) {
        var target = event.target;
        if (target === overlay) {
            close();
            return;
        }
        if (images.indexOf(target) === -1) return;
        toggle({
            target: target
        });
    };
    var _handleScroll = function _handleScroll() {
        if (isAnimating || !active.original) return;
        var currentScroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        if (Math.abs(scrollTop - currentScroll) > zoomOptions.scrollOffset) setTimeout(close, 150);
    };
    var _handleKeyUp = function _handleKeyUp(event) {
        var key = event.key || event.keyCode;
        // Close if escape key is pressed
        if (key === "Escape" || key === "Esc" || key === 27) close();
    };
    var update = function update() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var newOptions = options;
        if (options.background) overlay.style.background = options.background;
        if (options.container && options.container instanceof Object) newOptions.container = $4ffa2ba0c2b40bcc$var$_extends({}, zoomOptions.container, options.container);
        if (options.template) {
            var template = $4ffa2ba0c2b40bcc$var$isNode(options.template) ? options.template : document.querySelector(options.template);
            newOptions.template = template;
        }
        zoomOptions = $4ffa2ba0c2b40bcc$var$_extends({}, zoomOptions, newOptions);
        images.forEach(function(image) {
            image.dispatchEvent($4ffa2ba0c2b40bcc$var$createCustomEvent("medium-zoom:update", {
                detail: {
                    zoom: zoom
                }
            }));
        });
        return zoom;
    };
    var clone = function clone() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return mediumZoom($4ffa2ba0c2b40bcc$var$_extends({}, zoomOptions, options));
    };
    var attach = function attach() {
        for(var _len = arguments.length, selectors = Array(_len), _key = 0; _key < _len; _key++)selectors[_key] = arguments[_key];
        var newImages = selectors.reduce(function(imagesAccumulator, currentSelector) {
            return [].concat(imagesAccumulator, $4ffa2ba0c2b40bcc$var$getImagesFromSelector(currentSelector));
        }, []);
        newImages.filter(function(newImage) {
            return images.indexOf(newImage) === -1;
        }).forEach(function(newImage) {
            images.push(newImage);
            newImage.classList.add("medium-zoom-image");
        });
        eventListeners.forEach(function(_ref) {
            var type = _ref.type, listener = _ref.listener, options = _ref.options;
            newImages.forEach(function(image) {
                image.addEventListener(type, listener, options);
            });
        });
        return zoom;
    };
    var detach = function detach() {
        for(var _len2 = arguments.length, selectors = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)selectors[_key2] = arguments[_key2];
        if (active.zoomed) close();
        var imagesToDetach = selectors.length > 0 ? selectors.reduce(function(imagesAccumulator, currentSelector) {
            return [].concat(imagesAccumulator, $4ffa2ba0c2b40bcc$var$getImagesFromSelector(currentSelector));
        }, []) : images;
        imagesToDetach.forEach(function(image) {
            image.classList.remove("medium-zoom-image");
            image.dispatchEvent($4ffa2ba0c2b40bcc$var$createCustomEvent("medium-zoom:detach", {
                detail: {
                    zoom: zoom
                }
            }));
        });
        images = images.filter(function(image) {
            return imagesToDetach.indexOf(image) === -1;
        });
        return zoom;
    };
    var on = function on(type, listener) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        images.forEach(function(image) {
            image.addEventListener("medium-zoom:" + type, listener, options);
        });
        eventListeners.push({
            type: "medium-zoom:" + type,
            listener: listener,
            options: options
        });
        return zoom;
    };
    var off = function off(type, listener) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        images.forEach(function(image) {
            image.removeEventListener("medium-zoom:" + type, listener, options);
        });
        eventListeners = eventListeners.filter(function(eventListener) {
            return !(eventListener.type === "medium-zoom:" + type && eventListener.listener.toString() === listener.toString());
        });
        return zoom;
    };
    var open = function open() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, target = _ref2.target;
        var _animate = function _animate() {
            var container = {
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight,
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            };
            var viewportWidth = void 0;
            var viewportHeight = void 0;
            if (zoomOptions.container) {
                if (zoomOptions.container instanceof Object) {
                    // The container is given as an object with properties like width, height, left, top
                    container = $4ffa2ba0c2b40bcc$var$_extends({}, container, zoomOptions.container);
                    // We need to adjust custom options like container.right or container.bottom
                    viewportWidth = container.width - container.left - container.right - zoomOptions.margin * 2;
                    viewportHeight = container.height - container.top - container.bottom - zoomOptions.margin * 2;
                } else {
                    // The container is given as an element
                    var zoomContainer = $4ffa2ba0c2b40bcc$var$isNode(zoomOptions.container) ? zoomOptions.container : document.querySelector(zoomOptions.container);
                    var _zoomContainer$getBou = zoomContainer.getBoundingClientRect(), _width = _zoomContainer$getBou.width, _height = _zoomContainer$getBou.height, _left = _zoomContainer$getBou.left, _top = _zoomContainer$getBou.top;
                    container = $4ffa2ba0c2b40bcc$var$_extends({}, container, {
                        width: _width,
                        height: _height,
                        left: _left,
                        top: _top
                    });
                }
            }
            viewportWidth = viewportWidth || container.width - zoomOptions.margin * 2;
            viewportHeight = viewportHeight || container.height - zoomOptions.margin * 2;
            var zoomTarget = active.zoomedHd || active.original;
            var naturalWidth = $4ffa2ba0c2b40bcc$var$isSvg(zoomTarget) ? viewportWidth : zoomTarget.naturalWidth || viewportWidth;
            var naturalHeight = $4ffa2ba0c2b40bcc$var$isSvg(zoomTarget) ? viewportHeight : zoomTarget.naturalHeight || viewportHeight;
            var _zoomTarget$getBoundi = zoomTarget.getBoundingClientRect(), top = _zoomTarget$getBoundi.top, left = _zoomTarget$getBoundi.left, width = _zoomTarget$getBoundi.width, height = _zoomTarget$getBoundi.height;
            var scaleX = Math.min(Math.max(width, naturalWidth), viewportWidth) / width;
            var scaleY = Math.min(Math.max(height, naturalHeight), viewportHeight) / height;
            var scale = Math.min(scaleX, scaleY);
            var translateX = (-left + (viewportWidth - width) / 2 + zoomOptions.margin + container.left) / scale;
            var translateY = (-top + (viewportHeight - height) / 2 + zoomOptions.margin + container.top) / scale;
            var transform = "scale(" + scale + ") translate3d(" + translateX + "px, " + translateY + "px, 0)";
            active.zoomed.style.transform = transform;
            if (active.zoomedHd) active.zoomedHd.style.transform = transform;
        };
        return new Promise(function(resolve) {
            if (target && images.indexOf(target) === -1) {
                resolve(zoom);
                return;
            }
            var _handleOpenEnd = function _handleOpenEnd() {
                isAnimating = false;
                active.zoomed.removeEventListener("transitionend", _handleOpenEnd);
                active.original.dispatchEvent($4ffa2ba0c2b40bcc$var$createCustomEvent("medium-zoom:opened", {
                    detail: {
                        zoom: zoom
                    }
                }));
                resolve(zoom);
            };
            if (active.zoomed) {
                resolve(zoom);
                return;
            }
            if (target) // The zoom was triggered manually via a click
            active.original = target;
            else if (images.length > 0) {
                var _images = images;
                active.original = _images[0];
            } else {
                resolve(zoom);
                return;
            }
            active.original.dispatchEvent($4ffa2ba0c2b40bcc$var$createCustomEvent("medium-zoom:open", {
                detail: {
                    zoom: zoom
                }
            }));
            scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
            isAnimating = true;
            active.zoomed = $4ffa2ba0c2b40bcc$var$cloneTarget(active.original);
            document.body.appendChild(overlay);
            if (zoomOptions.template) {
                var template = $4ffa2ba0c2b40bcc$var$isNode(zoomOptions.template) ? zoomOptions.template : document.querySelector(zoomOptions.template);
                active.template = document.createElement("div");
                active.template.appendChild(template.content.cloneNode(true));
                document.body.appendChild(active.template);
            }
            // If the selected <img> tag is inside a <picture> tag, set the
            // currently-applied source as the cloned `src=` attribute.
            // (as these might differ, or src= might be unset in some cases)
            if (active.original.parentElement && active.original.parentElement.tagName === "PICTURE" && active.original.currentSrc) active.zoomed.src = active.original.currentSrc;
            document.body.appendChild(active.zoomed);
            window.requestAnimationFrame(function() {
                document.body.classList.add("medium-zoom--opened");
            });
            active.original.classList.add("medium-zoom-image--hidden");
            active.zoomed.classList.add("medium-zoom-image--opened");
            active.zoomed.addEventListener("click", close);
            active.zoomed.addEventListener("transitionend", _handleOpenEnd);
            if (active.original.getAttribute("data-zoom-src")) {
                active.zoomedHd = active.zoomed.cloneNode();
                // Reset the `scrset` property or the HD image won't load.
                active.zoomedHd.removeAttribute("srcset");
                active.zoomedHd.removeAttribute("sizes");
                // Remove loading attribute so the browser can load the image normally
                active.zoomedHd.removeAttribute("loading");
                active.zoomedHd.src = active.zoomed.getAttribute("data-zoom-src");
                active.zoomedHd.onerror = function() {
                    clearInterval(getZoomTargetSize);
                    console.warn("Unable to reach the zoom image target " + active.zoomedHd.src);
                    active.zoomedHd = null;
                    _animate();
                };
                // We need to access the natural size of the full HD
                // target as fast as possible to compute the animation.
                var getZoomTargetSize = setInterval(function() {
                    if (active.zoomedHd.complete) {
                        clearInterval(getZoomTargetSize);
                        active.zoomedHd.classList.add("medium-zoom-image--opened");
                        active.zoomedHd.addEventListener("click", close);
                        document.body.appendChild(active.zoomedHd);
                        _animate();
                    }
                }, 10);
            } else if (active.original.hasAttribute("srcset")) {
                // If an image has a `srcset` attribuet, we don't know the dimensions of the
                // zoomed (HD) image (like when `data-zoom-src` is specified).
                // Therefore the approach is quite similar.
                active.zoomedHd = active.zoomed.cloneNode();
                // Resetting the sizes attribute tells the browser to load the
                // image best fitting the current viewport size, respecting the `srcset`.
                active.zoomedHd.removeAttribute("sizes");
                // In Firefox, the `loading` attribute needs to be set to `eager` (default
                // value) for the load event to be fired.
                active.zoomedHd.removeAttribute("loading");
                // Wait for the load event of the hd image. This will fire if the image
                // is already cached.
                var loadEventListener = active.zoomedHd.addEventListener("load", function() {
                    active.zoomedHd.removeEventListener("load", loadEventListener);
                    active.zoomedHd.classList.add("medium-zoom-image--opened");
                    active.zoomedHd.addEventListener("click", close);
                    document.body.appendChild(active.zoomedHd);
                    _animate();
                });
            } else _animate();
        });
    };
    var close = function close() {
        return new Promise(function(resolve) {
            if (isAnimating || !active.original) {
                resolve(zoom);
                return;
            }
            var _handleCloseEnd = function _handleCloseEnd() {
                active.original.classList.remove("medium-zoom-image--hidden");
                document.body.removeChild(active.zoomed);
                if (active.zoomedHd) document.body.removeChild(active.zoomedHd);
                document.body.removeChild(overlay);
                active.zoomed.classList.remove("medium-zoom-image--opened");
                if (active.template) document.body.removeChild(active.template);
                isAnimating = false;
                active.zoomed.removeEventListener("transitionend", _handleCloseEnd);
                active.original.dispatchEvent($4ffa2ba0c2b40bcc$var$createCustomEvent("medium-zoom:closed", {
                    detail: {
                        zoom: zoom
                    }
                }));
                active.original = null;
                active.zoomed = null;
                active.zoomedHd = null;
                active.template = null;
                resolve(zoom);
            };
            isAnimating = true;
            document.body.classList.remove("medium-zoom--opened");
            active.zoomed.style.transform = "";
            if (active.zoomedHd) active.zoomedHd.style.transform = "";
            // Fade out the template so it's not too abrupt
            if (active.template) {
                active.template.style.transition = "opacity 150ms";
                active.template.style.opacity = 0;
            }
            active.original.dispatchEvent($4ffa2ba0c2b40bcc$var$createCustomEvent("medium-zoom:close", {
                detail: {
                    zoom: zoom
                }
            }));
            active.zoomed.addEventListener("transitionend", _handleCloseEnd);
        });
    };
    var toggle = function toggle() {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, target = _ref3.target;
        if (active.original) return close();
        return open({
            target: target
        });
    };
    var getOptions = function getOptions() {
        return zoomOptions;
    };
    var getImages = function getImages() {
        return images;
    };
    var getZoomedImage = function getZoomedImage() {
        return active.original;
    };
    var images = [];
    var eventListeners = [];
    var isAnimating = false;
    var scrollTop = 0;
    var zoomOptions = options;
    var active = {
        original: null,
        zoomed: null,
        zoomedHd: null,
        template: null
    };
    if (Object.prototype.toString.call(selector) === "[object Object]") zoomOptions = selector;
    else if (selector || typeof selector === "string" // to process empty string as a selector
    ) attach(selector);
    // Apply the default option values
    zoomOptions = $4ffa2ba0c2b40bcc$var$_extends({
        margin: 0,
        background: "#fff",
        scrollOffset: 40,
        container: null,
        template: null
    }, zoomOptions);
    var overlay = $4ffa2ba0c2b40bcc$var$createOverlay(zoomOptions.background);
    document.addEventListener("click", _handleClick);
    document.addEventListener("keyup", _handleKeyUp);
    document.addEventListener("scroll", _handleScroll);
    window.addEventListener("resize", close);
    var zoom = {
        open: open,
        close: close,
        toggle: toggle,
        update: update,
        clone: clone,
        attach: attach,
        detach: detach,
        on: on,
        off: off,
        getOptions: getOptions,
        getImages: getImages,
        getZoomedImage: getZoomedImage
    };
    return zoom;
};
function $4ffa2ba0c2b40bcc$var$styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") return;
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) head.insertBefore(style, head.firstChild);
        else head.appendChild(style);
    } else head.appendChild(style);
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild(document.createTextNode(css));
}
var $4ffa2ba0c2b40bcc$var$css = ".medium-zoom-overlay{position:fixed;top:0;right:0;bottom:0;left:0;opacity:0;transition:opacity .3s;will-change:opacity}.medium-zoom--opened .medium-zoom-overlay{cursor:pointer;cursor:zoom-out;opacity:1}.medium-zoom-image{cursor:pointer;cursor:zoom-in;transition:transform .3s cubic-bezier(.2,0,.2,1)!important}.medium-zoom-image--hidden{visibility:hidden}.medium-zoom-image--opened{position:relative;cursor:pointer;cursor:zoom-out;will-change:transform}";
$4ffa2ba0c2b40bcc$var$styleInject($4ffa2ba0c2b40bcc$var$css);
var $4ffa2ba0c2b40bcc$export$2e2bcd8739ae039 = $4ffa2ba0c2b40bcc$var$mediumZoom;


!function(t) {
    var e = {};
    function n(r) {
        if (e[r]) return e[r].exports;
        var o = e[r] = {
            i: r,
            l: !1,
            exports: {}
        };
        return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    n.m = t, n.c = e, n.d = function(t, e, r) {
        n.o(t, e) || Object.defineProperty(t, e, {
            enumerable: !0,
            get: r
        });
    }, n.r = function(t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(t, "__esModule", {
            value: !0
        });
    }, n.t = function(t, e) {
        if (1 & e && (t = n(t)), 8 & e) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var r = Object.create(null);
        if (n.r(r), Object.defineProperty(r, "default", {
            enumerable: !0,
            value: t
        }), 2 & e && "string" != typeof t) for(var o in t)n.d(r, o, (function(e) {
            return t[e];
        }).bind(null, o));
        return r;
    }, n.n = function(t) {
        var e = t && t.__esModule ? function() {
            return t.default;
        } : function() {
            return t;
        };
        return n.d(e, "a", e), e;
    }, n.o = function(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 74);
}([
    function(t, e, n) {
        var r = n(28)("wks"), o = n(21), i = n(1).Symbol, u = "function" == typeof i;
        (t.exports = function(t) {
            return r[t] || (r[t] = u && i[t] || (u ? i : o)("Symbol." + t));
        }).store = r;
    },
    function(t, e) {
        var n = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
        "number" == typeof __g && (__g = n);
    },
    function(t, e) {
        t.exports = function(t) {
            return "object" == typeof t ? null !== t : "function" == typeof t;
        };
    },
    function(t, e, n) {
        var r = n(4), o = n(45), i = n(33), u = Object.defineProperty;
        e.f = n(5) ? Object.defineProperty : function(t, e, n) {
            if (r(t), e = i(e, !0), r(n), o) try {
                return u(t, e, n);
            } catch (t) {}
            if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");
            return "value" in n && (t[e] = n.value), t;
        };
    },
    function(t, e, n) {
        var r = n(2);
        t.exports = function(t) {
            if (!r(t)) throw TypeError(t + " is not an object!");
            return t;
        };
    },
    function(t, e, n) {
        t.exports = !n(6)(function() {
            return 7 != Object.defineProperty({}, "a", {
                get: function() {
                    return 7;
                }
            }).a;
        });
    },
    function(t, e) {
        t.exports = function(t) {
            try {
                return !!t();
            } catch (t) {
                return !0;
            }
        };
    },
    function(t, e, n) {
        var r = n(1), o = n(18), i = n(8), u = n(14), c = n(23), _ = function(t, e, n) {
            var f, a, l, s, p = t & _.F, y = t & _.G, h = t & _.S, v = t & _.P, d = t & _.B, b = y ? r : h ? r[e] || (r[e] = {}) : (r[e] || {}).prototype, E = y ? o : o[e] || (o[e] = {}), g = E.prototype || (E.prototype = {});
            for(f in y && (n = e), n)l = ((a = !p && b && void 0 !== b[f]) ? b : n)[f], s = d && a ? c(l, r) : v && "function" == typeof l ? c(Function.call, l) : l, b && u(b, f, l, t & _.U), E[f] != l && i(E, f, s), v && g[f] != l && (g[f] = l);
        };
        r.core = o, _.F = 1, _.G = 2, _.S = 4, _.P = 8, _.B = 16, _.W = 32, _.U = 64, _.R = 128, t.exports = _;
    },
    function(t, e, n) {
        var r = n(3), o = n(22);
        t.exports = n(5) ? function(t, e, n) {
            return r.f(t, e, o(1, n));
        } : function(t, e, n) {
            return t[e] = n, t;
        };
    },
    function(t, e, n) {
        "use strict";
        var r = n(59), o = n(60), i = n(26), u = n(19);
        t.exports = n(41)(Array, "Array", function(t, e) {
            this._t = u(t), this._i = 0, this._k = e;
        }, function() {
            var t = this._t, e = this._k, n = this._i++;
            return !t || n >= t.length ? (this._t = void 0, o(1)) : o(0, "keys" == e ? n : "values" == e ? t[n] : [
                n,
                t[n]
            ]);
        }, "values"), i.Arguments = i.Array, r("keys"), r("values"), r("entries");
    },
    function(t, e) {
        var n;
        n = function() {
            return this;
        }();
        try {
            n = n || new Function("return this")();
        } catch (t) {
            "object" == typeof window && (n = window);
        }
        t.exports = n;
    },
    function(t, e, n) {
        n(43)("asyncIterator");
    },
    function(t, e, n) {
        "use strict";
        var r = n(1), o = n(13), i = n(5), u = n(7), c = n(14), _ = n(34).KEY, f = n(6), a = n(28), l = n(29), s = n(21), p = n(0), y = n(44), h = n(43), v = n(76), d = n(79), b = n(4), E = n(2), g = n(19), O = n(33), R = n(22), m = n(39), L = n(82), S = n(52), I = n(3), w = n(24), x = S.f, j = I.f, A = L.f, T = r.Symbol, G = r.JSON, N = G && G.stringify, D = p("_hidden"), $ = p("toPrimitive"), P = {}.propertyIsEnumerable, k = a("symbol-registry"), M = a("symbols"), B = a("op-symbols"), W = Object.prototype, F = "function" == typeof T, C = r.QObject, U = !C || !C.prototype || !C.prototype.findChild, Y = i && f(function() {
            return 7 != m(j({}, "a", {
                get: function() {
                    return j(this, "a", {
                        value: 7
                    }).a;
                }
            })).a;
        }) ? function(t, e, n) {
            var r = x(W, e);
            r && delete W[e], j(t, e, n), r && t !== W && j(W, e, r);
        } : j, X = function(t) {
            var e = M[t] = m(T.prototype);
            return e._k = t, e;
        }, J = F && "symbol" == typeof T.iterator ? function(t) {
            return "symbol" == typeof t;
        } : function(t) {
            return t instanceof T;
        }, q = function(t, e, n) {
            return t === W && q(B, e, n), b(t), e = O(e, !0), b(n), o(M, e) ? (n.enumerable ? (o(t, D) && t[D][e] && (t[D][e] = !1), n = m(n, {
                enumerable: R(0, !1)
            })) : (o(t, D) || j(t, D, R(1, {})), t[D][e] = !0), Y(t, e, n)) : j(t, e, n);
        }, H = function(t, e) {
            b(t);
            for(var n, r = v(e = g(e)), o = 0, i = r.length; i > o;)q(t, n = r[o++], e[n]);
            return t;
        }, K = function(t) {
            var e = P.call(this, t = O(t, !0));
            return !(this === W && o(M, t) && !o(B, t)) && (!(e || !o(this, t) || !o(M, t) || o(this, D) && this[D][t]) || e);
        }, V = function(t, e) {
            if (t = g(t), e = O(e, !0), t !== W || !o(M, e) || o(B, e)) {
                var n = x(t, e);
                return !n || !o(M, e) || o(t, D) && t[D][e] || (n.enumerable = !0), n;
            }
        }, z = function(t) {
            for(var e, n = A(g(t)), r = [], i = 0; n.length > i;)o(M, e = n[i++]) || e == D || e == _ || r.push(e);
            return r;
        }, Q = function(t) {
            for(var e, n = t === W, r = A(n ? B : g(t)), i = [], u = 0; r.length > u;)!o(M, e = r[u++]) || n && !o(W, e) || i.push(M[e]);
            return i;
        };
        F || (c((T = function() {
            if (this instanceof T) throw TypeError("Symbol is not a constructor!");
            var t = s(arguments.length > 0 ? arguments[0] : void 0), e = function(n) {
                this === W && e.call(B, n), o(this, D) && o(this[D], t) && (this[D][t] = !1), Y(this, t, R(1, n));
            };
            return i && U && Y(W, t, {
                configurable: !0,
                set: e
            }), X(t);
        }).prototype, "toString", function() {
            return this._k;
        }), S.f = V, I.f = q, n(51).f = L.f = z, n(38).f = K, n(50).f = Q, i && !n(27) && c(W, "propertyIsEnumerable", K, !0), y.f = function(t) {
            return X(p(t));
        }), u(u.G + u.W + u.F * !F, {
            Symbol: T
        });
        for(var Z = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), tt = 0; Z.length > tt;)p(Z[tt++]);
        for(var et = w(p.store), nt = 0; et.length > nt;)h(et[nt++]);
        u(u.S + u.F * !F, "Symbol", {
            for: function(t) {
                return o(k, t += "") ? k[t] : k[t] = T(t);
            },
            keyFor: function(t) {
                if (!J(t)) throw TypeError(t + " is not a symbol!");
                for(var e in k)if (k[e] === t) return e;
            },
            useSetter: function() {
                U = !0;
            },
            useSimple: function() {
                U = !1;
            }
        }), u(u.S + u.F * !F, "Object", {
            create: function(t, e) {
                return void 0 === e ? m(t) : H(m(t), e);
            },
            defineProperty: q,
            defineProperties: H,
            getOwnPropertyDescriptor: V,
            getOwnPropertyNames: z,
            getOwnPropertySymbols: Q
        }), G && u(u.S + u.F * (!F || f(function() {
            var t = T();
            return "[null]" != N([
                t
            ]) || "{}" != N({
                a: t
            }) || "{}" != N(Object(t));
        })), "JSON", {
            stringify: function(t) {
                for(var e, n, r = [
                    t
                ], o = 1; arguments.length > o;)r.push(arguments[o++]);
                if (n = e = r[1], (E(e) || void 0 !== t) && !J(t)) return d(e) || (e = function(t, e) {
                    if ("function" == typeof n && (e = n.call(this, t, e)), !J(e)) return e;
                }), r[1] = e, N.apply(G, r);
            }
        }), T.prototype[$] || n(8)(T.prototype, $, T.prototype.valueOf), l(T, "Symbol"), l(Math, "Math", !0), l(r.JSON, "JSON", !0);
    },
    function(t, e) {
        var n = {}.hasOwnProperty;
        t.exports = function(t, e) {
            return n.call(t, e);
        };
    },
    function(t, e, n) {
        var r = n(1), o = n(8), i = n(13), u = n(21)("src"), c = n(75), _ = ("" + c).split("toString");
        n(18).inspectSource = function(t) {
            return c.call(t);
        }, (t.exports = function(t, e, n, c) {
            var f = "function" == typeof n;
            f && (i(n, "name") || o(n, "name", e)), t[e] !== n && (f && (i(n, u) || o(n, u, t[e] ? "" + t[e] : _.join(String(e)))), t === r ? t[e] = n : c ? t[e] ? t[e] = n : o(t, e, n) : (delete t[e], o(t, e, n)));
        })(Function.prototype, "toString", function() {
            return "function" == typeof this && this[u] || c.call(this);
        });
    },
    function(t, e, n) {
        var r = n(3).f, o = Function.prototype, i = /^\s*function ([^ (]*)/;
        "name" in o || n(5) && r(o, "name", {
            configurable: !0,
            get: function() {
                try {
                    return ("" + this).match(i)[1];
                } catch (t) {
                    return "";
                }
            }
        });
    },
    function(t, e, n) {
        var r = n(40), o = n(24);
        n(53)("keys", function() {
            return function(t) {
                return o(r(t));
            };
        });
    },
    function(t, e, n) {
        for(var r = n(9), o = n(24), i = n(14), u = n(1), c = n(8), _ = n(26), f = n(0), a = f("iterator"), l = f("toStringTag"), s = _.Array, p = {
            CSSRuleList: !0,
            CSSStyleDeclaration: !1,
            CSSValueList: !1,
            ClientRectList: !1,
            DOMRectList: !1,
            DOMStringList: !1,
            DOMTokenList: !0,
            DataTransferItemList: !1,
            FileList: !1,
            HTMLAllCollection: !1,
            HTMLCollection: !1,
            HTMLFormElement: !1,
            HTMLSelectElement: !1,
            MediaList: !0,
            MimeTypeArray: !1,
            NamedNodeMap: !1,
            NodeList: !0,
            PaintRequestList: !1,
            Plugin: !1,
            PluginArray: !1,
            SVGLengthList: !1,
            SVGNumberList: !1,
            SVGPathSegList: !1,
            SVGPointList: !1,
            SVGStringList: !1,
            SVGTransformList: !1,
            SourceBufferList: !1,
            StyleSheetList: !0,
            TextTrackCueList: !1,
            TextTrackList: !1,
            TouchList: !1
        }, y = o(p), h = 0; h < y.length; h++){
            var v, d = y[h], b = p[d], E = u[d], g = E && E.prototype;
            if (g && (g[a] || c(g, a, s), g[l] || c(g, l, d), _[d] = s, b)) for(v in r)g[v] || i(g, v, r[v], !0);
        }
    },
    function(t, e) {
        var n = t.exports = {
            version: "2.6.5"
        };
        "number" == typeof __e && (__e = n);
    },
    function(t, e, n) {
        var r = n(77), o = n(25);
        t.exports = function(t) {
            return r(o(t));
        };
    },
    function(t, e, n) {
        var r = n(2);
        n(53)("isExtensible", function(t) {
            return function(e) {
                return !!r(e) && (!t || t(e));
            };
        });
    },
    function(t, e) {
        var n = 0, r = Math.random();
        t.exports = function(t) {
            return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++n + r).toString(36));
        };
    },
    function(t, e) {
        t.exports = function(t, e) {
            return {
                enumerable: !(1 & t),
                configurable: !(2 & t),
                writable: !(4 & t),
                value: e
            };
        };
    },
    function(t, e, n) {
        var r = n(47);
        t.exports = function(t, e, n) {
            if (r(t), void 0 === e) return t;
            switch(n){
                case 1:
                    return function(n) {
                        return t.call(e, n);
                    };
                case 2:
                    return function(n, r) {
                        return t.call(e, n, r);
                    };
                case 3:
                    return function(n, r, o) {
                        return t.call(e, n, r, o);
                    };
            }
            return function() {
                return t.apply(e, arguments);
            };
        };
    },
    function(t, e, n) {
        var r = n(48), o = n(37);
        t.exports = Object.keys || function(t) {
            return r(t, o);
        };
    },
    function(t, e) {
        t.exports = function(t) {
            if (null == t) throw TypeError("Can't call method on  " + t);
            return t;
        };
    },
    function(t, e) {
        t.exports = {};
    },
    function(t, e) {
        t.exports = !1;
    },
    function(t, e, n) {
        var r = n(18), o = n(1), i = o["__core-js_shared__"] || (o["__core-js_shared__"] = {});
        (t.exports = function(t, e) {
            return i[t] || (i[t] = void 0 !== e ? e : {});
        })("versions", []).push({
            version: r.version,
            mode: n(27) ? "pure" : "global",
            copyright: "\xa9 2019 Denis Pushkarev (zloirock.ru)"
        });
    },
    function(t, e, n) {
        var r = n(3).f, o = n(13), i = n(0)("toStringTag");
        t.exports = function(t, e, n) {
            t && !o(t = n ? t : t.prototype, i) && r(t, i, {
                configurable: !0,
                value: e
            });
        };
    },
    function(t, e) {
        var n = {}.toString;
        t.exports = function(t) {
            return n.call(t).slice(8, -1);
        };
    },
    function(t, e, n) {
        var r = n(35), o = Math.min;
        t.exports = function(t) {
            return t > 0 ? o(r(t), 9007199254740991) : 0;
        };
    },
    function(t, e, n) {
        "use strict";
        (function(t) {
            n(11), n(12), n(20), n(15), n(9), n(16), n(96), n(17);
            function r(t) {
                return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                    return typeof t;
                } : function(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            function o(t, e) {
                var n = [];
                return t.split(",").forEach(function(t) {
                    var r = t.split("-"), o = parseInt(r[0], 10), i = parseInt(r[1], 10);
                    if (2 === r.length) {
                        "-" === t[t.length - 1] && null != e && (i = e);
                        for(var u = o; u <= i; u++)n.push(u);
                    } else 1 === r.length && n.push(parseInt(r[0], 10));
                }), n;
            }
            function i() {
                try {
                    if (t) return t;
                } catch (t) {
                    try {
                        if (window) return window;
                    } catch (t) {
                        return this;
                    }
                }
            }
            e.a = p("getLineNumbers");
            var u, c = null;
            function _() {
                if (null === c) {
                    var t = i();
                    t.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ || (t.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0), c = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
                }
                return c;
            }
            function f() {
                var t = i();
                return t.__$$GLOBAL_REWIRE_REGISTRY__ || (t.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null)), t.__$$GLOBAL_REWIRE_REGISTRY__;
            }
            function a() {
                var t = _(), e = f(), n = e[t];
                return n || (e[t] = Object.create(null), n = e[t]), n;
            }
            (u = i()).__rewire_reset_all__ || (u.__rewire_reset_all__ = function() {
                u.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
            });
            var l = "__INTENTIONAL_UNDEFINED__", s = {};
            function p(t) {
                var e = a();
                if (void 0 === e[t]) return function(t) {
                    switch(t){
                        case "getLineNumbers":
                            return o;
                    }
                    return;
                }(t);
                var n = e[t];
                return n === l ? void 0 : n;
            }
            function y(t, e) {
                var n = a();
                return "object" === r(t) ? (Object.keys(t).forEach(function(e) {
                    n[e] = t[e];
                }), function() {
                    Object.keys(t).forEach(function(e) {
                        h(t);
                    });
                }) : (n[t] = void 0 === e ? l : e, function() {
                    h(t);
                });
            }
            function h(t) {
                var e = a();
                delete e[t], 0 == Object.keys(e).length && delete f()[_];
            }
            function v(t) {
                var e = a(), n = Object.keys(t), r = {};
                function o() {
                    n.forEach(function(t) {
                        e[t] = r[t];
                    });
                }
                return function(i) {
                    n.forEach(function(n) {
                        r[n] = e[n], e[n] = t[n];
                    });
                    var u = i();
                    return u && "function" == typeof u.then ? u.then(o).catch(o) : o(), u;
                };
            }
            !function() {
                function t(t, e) {
                    Object.defineProperty(s, t, {
                        value: e,
                        enumerable: !1,
                        configurable: !0
                    });
                }
                t("__get__", p), t("__GetDependency__", p), t("__Rewire__", y), t("__set__", y), t("__reset__", h), t("__ResetDependency__", h), t("__with__", v);
            }();
            var d = r(o);
            function b(t, e) {
                Object.defineProperty(o, t, {
                    value: e,
                    enumerable: !1,
                    configurable: !0
                });
            }
            "object" !== d && "function" !== d || !Object.isExtensible(o) || (b("__get__", p), b("__GetDependency__", p), b("__Rewire__", y), b("__set__", y), b("__reset__", h), b("__ResetDependency__", h), b("__with__", v), b("__RewireAPI__", s));
        }).call(this, n(10));
    },
    function(t, e, n) {
        var r = n(2);
        t.exports = function(t, e) {
            if (!r(t)) return t;
            var n, o;
            if (e && "function" == typeof (n = t.toString) && !r(o = n.call(t))) return o;
            if ("function" == typeof (n = t.valueOf) && !r(o = n.call(t))) return o;
            if (!e && "function" == typeof (n = t.toString) && !r(o = n.call(t))) return o;
            throw TypeError("Can't convert object to primitive value");
        };
    },
    function(t, e, n) {
        var r = n(21)("meta"), o = n(2), i = n(13), u = n(3).f, c = 0, _ = Object.isExtensible || function() {
            return !0;
        }, f = !n(6)(function() {
            return _(Object.preventExtensions({}));
        }), a = function(t) {
            u(t, r, {
                value: {
                    i: "O" + ++c,
                    w: {}
                }
            });
        }, l = t.exports = {
            KEY: r,
            NEED: !1,
            fastKey: function(t, e) {
                if (!o(t)) return "symbol" == typeof t ? t : ("string" == typeof t ? "S" : "P") + t;
                if (!i(t, r)) {
                    if (!_(t)) return "F";
                    if (!e) return "E";
                    a(t);
                }
                return t[r].i;
            },
            getWeak: function(t, e) {
                if (!i(t, r)) {
                    if (!_(t)) return !0;
                    if (!e) return !1;
                    a(t);
                }
                return t[r].w;
            },
            onFreeze: function(t) {
                return f && l.NEED && _(t) && !i(t, r) && a(t), t;
            }
        };
    },
    function(t, e) {
        var n = Math.ceil, r = Math.floor;
        t.exports = function(t) {
            return isNaN(t = +t) ? 0 : (t > 0 ? r : n)(t);
        };
    },
    function(t, e, n) {
        var r = n(28)("keys"), o = n(21);
        t.exports = function(t) {
            return r[t] || (r[t] = o(t));
        };
    },
    function(t, e) {
        t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
    },
    function(t, e) {
        e.f = ({}).propertyIsEnumerable;
    },
    function(t, e, n) {
        var r = n(4), o = n(80), i = n(37), u = n(36)("IE_PROTO"), c = function() {}, _ = function() {
            var t, e = n(46)("iframe"), r = i.length;
            for(e.style.display = "none", n(81).appendChild(e), e.src = "javascript:", (t = e.contentWindow.document).open(), t.write("<script>document.F=Object</script>"), t.close(), _ = t.F; r--;)delete _.prototype[i[r]];
            return _();
        };
        t.exports = Object.create || function(t, e) {
            var n;
            return null !== t ? (c.prototype = r(t), n = new c, c.prototype = null, n[u] = t) : n = _(), void 0 === e ? n : o(n, e);
        };
    },
    function(t, e, n) {
        var r = n(25);
        t.exports = function(t) {
            return Object(r(t));
        };
    },
    function(t, e, n) {
        "use strict";
        var r = n(27), o = n(7), i = n(14), u = n(8), c = n(26), _ = n(85), f = n(29), a = n(86), l = n(0)("iterator"), s = !([].keys && "next" in [].keys()), p = function() {
            return this;
        };
        t.exports = function(t, e, n, y, h, v, d) {
            _(n, e, y);
            var b, E, g, O = function(t) {
                if (!s && t in S) return S[t];
                switch(t){
                    case "keys":
                    case "values":
                        return function() {
                            return new n(this, t);
                        };
                }
                return function() {
                    return new n(this, t);
                };
            }, R = e + " Iterator", m = "values" == h, L = !1, S = t.prototype, I = S[l] || S["@@iterator"] || h && S[h], w = I || O(h), x = h ? m ? O("entries") : w : void 0, j = "Array" == e && S.entries || I;
            if (j && (g = a(j.call(new t))) !== Object.prototype && g.next && (f(g, R, !0), r || "function" == typeof g[l] || u(g, l, p)), m && I && "values" !== I.name && (L = !0, w = function() {
                return I.call(this);
            }), r && !d || !s && !L && S[l] || u(S, l, w), c[e] = w, c[R] = p, h) {
                if (b = {
                    values: m ? w : O("values"),
                    keys: v ? w : O("keys"),
                    entries: x
                }, d) for(E in b)E in S || i(S, E, b[E]);
                else o(o.P + o.F * (s || L), e, b);
            }
            return b;
        };
    },
    function(t, e, n) {
        "use strict";
        var r, o, i = n(100), u = RegExp.prototype.exec, c = String.prototype.replace, _ = u, f = (r = /a/, o = /b*/g, u.call(r, "a"), u.call(o, "a"), 0 !== r.lastIndex || 0 !== o.lastIndex), a = void 0 !== /()??/.exec("")[1];
        (f || a) && (_ = function(t) {
            var e, n, r, o, _ = this;
            return a && (n = new RegExp("^" + _.source + "$(?!\\s)", i.call(_))), f && (e = _.lastIndex), r = u.call(_, t), f && r && (_.lastIndex = _.global ? r.index + r[0].length : e), a && r && r.length > 1 && c.call(r[0], n, function() {
                for(o = 1; o < arguments.length - 2; o++)void 0 === arguments[o] && (r[o] = void 0);
            }), r;
        }), t.exports = _;
    },
    function(t, e, n) {
        var r = n(1), o = n(18), i = n(27), u = n(44), c = n(3).f;
        t.exports = function(t) {
            var e = o.Symbol || (o.Symbol = i ? {} : r.Symbol || {});
            "_" == t.charAt(0) || t in e || c(e, t, {
                value: u.f(t)
            });
        };
    },
    function(t, e, n) {
        e.f = n(0);
    },
    function(t, e, n) {
        t.exports = !n(5) && !n(6)(function() {
            return 7 != Object.defineProperty(n(46)("div"), "a", {
                get: function() {
                    return 7;
                }
            }).a;
        });
    },
    function(t, e, n) {
        var r = n(2), o = n(1).document, i = r(o) && r(o.createElement);
        t.exports = function(t) {
            return i ? o.createElement(t) : {};
        };
    },
    function(t, e) {
        t.exports = function(t) {
            if ("function" != typeof t) throw TypeError(t + " is not a function!");
            return t;
        };
    },
    function(t, e, n) {
        var r = n(13), o = n(19), i = n(49)(!1), u = n(36)("IE_PROTO");
        t.exports = function(t, e) {
            var n, c = o(t), _ = 0, f = [];
            for(n in c)n != u && r(c, n) && f.push(n);
            for(; e.length > _;)r(c, n = e[_++]) && (~i(f, n) || f.push(n));
            return f;
        };
    },
    function(t, e, n) {
        var r = n(19), o = n(31), i = n(78);
        t.exports = function(t) {
            return function(e, n, u) {
                var c, _ = r(e), f = o(_.length), a = i(u, f);
                if (t && n != n) {
                    for(; f > a;)if ((c = _[a++]) != c) return !0;
                } else for(; f > a; a++)if ((t || a in _) && _[a] === n) return t || a || 0;
                return !t && -1;
            };
        };
    },
    function(t, e) {
        e.f = Object.getOwnPropertySymbols;
    },
    function(t, e, n) {
        var r = n(48), o = n(37).concat("length", "prototype");
        e.f = Object.getOwnPropertyNames || function(t) {
            return r(t, o);
        };
    },
    function(t, e, n) {
        var r = n(38), o = n(22), i = n(19), u = n(33), c = n(13), _ = n(45), f = Object.getOwnPropertyDescriptor;
        e.f = n(5) ? f : function(t, e) {
            if (t = i(t), e = u(e, !0), _) try {
                return f(t, e);
            } catch (t) {}
            if (c(t, e)) return o(!r.f.call(t, e), t[e]);
        };
    },
    function(t, e, n) {
        var r = n(7), o = n(18), i = n(6);
        t.exports = function(t, e) {
            var n = (o.Object || {})[t] || Object[t], u = {};
            u[t] = e(n), r(r.S + r.F * i(function() {
                n(1);
            }), "Object", u);
        };
    },
    function(t, e, n) {
        var r = n(4);
        t.exports = function(t, e, n, o) {
            try {
                return o ? e(r(n)[0], n[1]) : e(n);
            } catch (e) {
                var i = t.return;
                throw void 0 !== i && r(i.call(t)), e;
            }
        };
    },
    function(t, e, n) {
        var r = n(26), o = n(0)("iterator"), i = Array.prototype;
        t.exports = function(t) {
            return void 0 !== t && (r.Array === t || i[o] === t);
        };
    },
    function(t, e, n) {
        var r = n(57), o = n(0)("iterator"), i = n(26);
        t.exports = n(18).getIteratorMethod = function(t) {
            if (null != t) return t[o] || t["@@iterator"] || i[r(t)];
        };
    },
    function(t, e, n) {
        var r = n(30), o = n(0)("toStringTag"), i = "Arguments" == r(function() {
            return arguments;
        }());
        t.exports = function(t) {
            var e, n, u;
            return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (n = function(t, e) {
                try {
                    return t[e];
                } catch (t) {}
            }(e = Object(t), o)) ? n : i ? r(e) : "Object" == (u = r(e)) && "function" == typeof e.callee ? "Arguments" : u;
        };
    },
    function(t, e, n) {
        var r = n(0)("iterator"), o = !1;
        try {
            var i = [
                7
            ][r]();
            i.return = function() {
                o = !0;
            }, Array.from(i, function() {
                throw 2;
            });
        } catch (t) {}
        t.exports = function(t, e) {
            if (!e && !o) return !1;
            var n = !1;
            try {
                var i = [
                    7
                ], u = i[r]();
                u.next = function() {
                    return {
                        done: n = !0
                    };
                }, i[r] = function() {
                    return u;
                }, t(i);
            } catch (t) {}
            return n;
        };
    },
    function(t, e, n) {
        var r = n(0)("unscopables"), o = Array.prototype;
        null == o[r] && n(8)(o, r, {}), t.exports = function(t) {
            o[r][t] = !0;
        };
    },
    function(t, e) {
        t.exports = function(t, e) {
            return {
                value: e,
                done: !!t
            };
        };
    },
    function(t, e, n) {
        var r = n(35), o = n(25);
        t.exports = function(t) {
            return function(e, n) {
                var i, u, c = String(o(e)), _ = r(n), f = c.length;
                return _ < 0 || _ >= f ? t ? "" : void 0 : (i = c.charCodeAt(_)) < 55296 || i > 56319 || _ + 1 === f || (u = c.charCodeAt(_ + 1)) < 56320 || u > 57343 ? t ? c.charAt(_) : i : t ? c.slice(_, _ + 2) : u - 56320 + (i - 55296 << 10) + 65536;
            };
        };
    },
    function(t, e, n) {
        var r = n(14);
        t.exports = function(t, e, n) {
            for(var o in e)r(t, o, e[o], n);
            return t;
        };
    },
    function(t, e) {
        t.exports = function(t, e, n, r) {
            if (!(t instanceof e) || void 0 !== r && r in t) throw TypeError(n + ": incorrect invocation!");
            return t;
        };
    },
    function(t, e, n) {
        var r = n(23), o = n(54), i = n(55), u = n(4), c = n(31), _ = n(56), f = {}, a = {};
        (e = t.exports = function(t, e, n, l, s) {
            var p, y, h, v, d = s ? function() {
                return t;
            } : _(t), b = r(n, l, e ? 2 : 1), E = 0;
            if ("function" != typeof d) throw TypeError(t + " is not iterable!");
            if (i(d)) {
                for(p = c(t.length); p > E; E++)if ((v = e ? b(u(y = t[E])[0], y[1]) : b(t[E])) === f || v === a) return v;
            } else for(h = d.call(t); !(y = h.next()).done;)if ((v = o(h, b, y.value, e)) === f || v === a) return v;
        }).BREAK = f, e.RETURN = a;
    },
    function(t, e, n) {
        var r = n(2);
        t.exports = function(t, e) {
            if (!r(t) || t._t !== e) throw TypeError("Incompatible receiver, " + e + " required!");
            return t;
        };
    },
    function(t, e, n) {
        "use strict";
        var r = n(7), o = n(49)(!0);
        r(r.P, "Array", {
            includes: function(t) {
                return o(this, t, arguments.length > 1 ? arguments[1] : void 0);
            }
        }), n(59)("includes");
    },
    function(t, e, n) {
        "use strict";
        var r = n(7), o = n(94);
        r(r.P + r.F * n(95)("includes"), "String", {
            includes: function(t) {
                return !!~o(this, t, "includes").indexOf(t, arguments.length > 1 ? arguments[1] : void 0);
            }
        });
    },
    function(t, e, n) {
        var r = n(2), o = n(30), i = n(0)("match");
        t.exports = function(t) {
            var e;
            return r(t) && (void 0 !== (e = t[i]) ? !!e : "RegExp" == o(t));
        };
    },
    function(t, e, n) {
        "use strict";
        (function(t) {
            n(11), n(12), n(20), n(15), n(9), n(16), n(17);
            function r(t) {
                return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                    return typeof t;
                } : function(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            function o(t, e) {
                t.querySelectorAll("table tbody").forEach(function(t) {
                    var n = document.createElement("tr"), r = document.createElement("td");
                    r.style.padding = "10px !important", r.style.borderBottom = "10px solid white", r.style.backgroundColor = "#f9f9f9", r.style.fontWeight = "bold", r.innerHTML = e;
                    var o = document.createElement("td");
                    o.style.backgroundColor = "#f9f9f9", o.style.borderBottom = "10px solid white", n.appendChild(o), n.appendChild(r), t.prepend(n);
                });
            }
            function i() {
                try {
                    if (t) return t;
                } catch (t) {
                    try {
                        if (window) return window;
                    } catch (t) {
                        return this;
                    }
                }
            }
            e.a = p("caption");
            var u, c = null;
            function _() {
                if (null === c) {
                    var t = i();
                    t.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ || (t.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0), c = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
                }
                return c;
            }
            function f() {
                var t = i();
                return t.__$$GLOBAL_REWIRE_REGISTRY__ || (t.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null)), t.__$$GLOBAL_REWIRE_REGISTRY__;
            }
            function a() {
                var t = _(), e = f(), n = e[t];
                return n || (e[t] = Object.create(null), n = e[t]), n;
            }
            (u = i()).__rewire_reset_all__ || (u.__rewire_reset_all__ = function() {
                u.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
            });
            var l = "__INTENTIONAL_UNDEFINED__", s = {};
            function p(t) {
                var e = a();
                if (void 0 === e[t]) return function(t) {
                    switch(t){
                        case "caption":
                            return o;
                    }
                    return;
                }(t);
                var n = e[t];
                return n === l ? void 0 : n;
            }
            function y(t, e) {
                var n = a();
                return "object" === r(t) ? (Object.keys(t).forEach(function(e) {
                    n[e] = t[e];
                }), function() {
                    Object.keys(t).forEach(function(e) {
                        h(t);
                    });
                }) : (n[t] = void 0 === e ? l : e, function() {
                    h(t);
                });
            }
            function h(t) {
                var e = a();
                delete e[t], 0 == Object.keys(e).length && delete f()[_];
            }
            function v(t) {
                var e = a(), n = Object.keys(t), r = {};
                function o() {
                    n.forEach(function(t) {
                        e[t] = r[t];
                    });
                }
                return function(i) {
                    n.forEach(function(n) {
                        r[n] = e[n], e[n] = t[n];
                    });
                    var u = i();
                    return u && "function" == typeof u.then ? u.then(o).catch(o) : o(), u;
                };
            }
            !function() {
                function t(t, e) {
                    Object.defineProperty(s, t, {
                        value: e,
                        enumerable: !1,
                        configurable: !0
                    });
                }
                t("__get__", p), t("__GetDependency__", p), t("__Rewire__", y), t("__set__", y), t("__reset__", h), t("__ResetDependency__", h), t("__with__", v);
            }();
            var d = r(o);
            function b(t, e) {
                Object.defineProperty(o, t, {
                    value: e,
                    enumerable: !1,
                    configurable: !0
                });
            }
            "object" !== d && "function" !== d || !Object.isExtensible(o) || (b("__get__", p), b("__GetDependency__", p), b("__Rewire__", y), b("__set__", y), b("__reset__", h), b("__ResetDependency__", h), b("__with__", v), b("__RewireAPI__", s));
        }).call(this, n(10));
    },
    function(t, e, n) {
        "use strict";
        (function(t) {
            n(11), n(12), n(20), n(15), n(9), n(16), n(17);
            function r(t) {
                return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                    return typeof t;
                } : function(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            function o(t) {
                t.querySelectorAll(".gist-meta").forEach(function(t) {
                    null != t.parentNode && t.parentNode.removeChild(t);
                }), t.querySelectorAll(".gist-data").forEach(function(t) {
                    null != t && (t.style.borderBottom = "0px");
                }), t.querySelectorAll(".gist-file").forEach(function(t) {
                    null != t && (t.style.borderBottom = "1px solid #dddddd");
                });
            }
            function i() {
                try {
                    if (t) return t;
                } catch (t) {
                    try {
                        if (window) return window;
                    } catch (t) {
                        return this;
                    }
                }
            }
            e.a = p("hideFooter");
            var u, c = null;
            function _() {
                if (null === c) {
                    var t = i();
                    t.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ || (t.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0), c = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
                }
                return c;
            }
            function f() {
                var t = i();
                return t.__$$GLOBAL_REWIRE_REGISTRY__ || (t.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null)), t.__$$GLOBAL_REWIRE_REGISTRY__;
            }
            function a() {
                var t = _(), e = f(), n = e[t];
                return n || (e[t] = Object.create(null), n = e[t]), n;
            }
            (u = i()).__rewire_reset_all__ || (u.__rewire_reset_all__ = function() {
                u.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
            });
            var l = "__INTENTIONAL_UNDEFINED__", s = {};
            function p(t) {
                var e = a();
                if (void 0 === e[t]) return function(t) {
                    switch(t){
                        case "hideFooter":
                            return o;
                    }
                    return;
                }(t);
                var n = e[t];
                return n === l ? void 0 : n;
            }
            function y(t, e) {
                var n = a();
                return "object" === r(t) ? (Object.keys(t).forEach(function(e) {
                    n[e] = t[e];
                }), function() {
                    Object.keys(t).forEach(function(e) {
                        h(t);
                    });
                }) : (n[t] = void 0 === e ? l : e, function() {
                    h(t);
                });
            }
            function h(t) {
                var e = a();
                delete e[t], 0 == Object.keys(e).length && delete f()[_];
            }
            function v(t) {
                var e = a(), n = Object.keys(t), r = {};
                function o() {
                    n.forEach(function(t) {
                        e[t] = r[t];
                    });
                }
                return function(i) {
                    n.forEach(function(n) {
                        r[n] = e[n], e[n] = t[n];
                    });
                    var u = i();
                    return u && "function" == typeof u.then ? u.then(o).catch(o) : o(), u;
                };
            }
            !function() {
                function t(t, e) {
                    Object.defineProperty(s, t, {
                        value: e,
                        enumerable: !1,
                        configurable: !0
                    });
                }
                t("__get__", p), t("__GetDependency__", p), t("__Rewire__", y), t("__set__", y), t("__reset__", h), t("__ResetDependency__", h), t("__with__", v);
            }();
            var d = r(o);
            function b(t, e) {
                Object.defineProperty(o, t, {
                    value: e,
                    enumerable: !1,
                    configurable: !0
                });
            }
            "object" !== d && "function" !== d || !Object.isExtensible(o) || (b("__get__", p), b("__GetDependency__", p), b("__Rewire__", y), b("__set__", y), b("__reset__", h), b("__ResetDependency__", h), b("__with__", v), b("__RewireAPI__", s));
        }).call(this, n(10));
    },
    function(t, e, n) {
        "use strict";
        (function(t) {
            n(11), n(12), n(20), n(15), n(9), n(16), n(17);
            function r(t) {
                return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                    return typeof t;
                } : function(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            function o(t) {
                t.querySelectorAll(".js-line-number").forEach(function(t) {
                    null != t.parentNode && t.parentNode.removeChild(t);
                });
            }
            function i() {
                try {
                    if (t) return t;
                } catch (t) {
                    try {
                        if (window) return window;
                    } catch (t) {
                        return this;
                    }
                }
            }
            e.a = p("hideLineNumbers");
            var u, c = null;
            function _() {
                if (null === c) {
                    var t = i();
                    t.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ || (t.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0), c = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
                }
                return c;
            }
            function f() {
                var t = i();
                return t.__$$GLOBAL_REWIRE_REGISTRY__ || (t.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null)), t.__$$GLOBAL_REWIRE_REGISTRY__;
            }
            function a() {
                var t = _(), e = f(), n = e[t];
                return n || (e[t] = Object.create(null), n = e[t]), n;
            }
            (u = i()).__rewire_reset_all__ || (u.__rewire_reset_all__ = function() {
                u.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
            });
            var l = "__INTENTIONAL_UNDEFINED__", s = {};
            function p(t) {
                var e = a();
                if (void 0 === e[t]) return function(t) {
                    switch(t){
                        case "hideLineNumbers":
                            return o;
                    }
                    return;
                }(t);
                var n = e[t];
                return n === l ? void 0 : n;
            }
            function y(t, e) {
                var n = a();
                return "object" === r(t) ? (Object.keys(t).forEach(function(e) {
                    n[e] = t[e];
                }), function() {
                    Object.keys(t).forEach(function(e) {
                        h(t);
                    });
                }) : (n[t] = void 0 === e ? l : e, function() {
                    h(t);
                });
            }
            function h(t) {
                var e = a();
                delete e[t], 0 == Object.keys(e).length && delete f()[_];
            }
            function v(t) {
                var e = a(), n = Object.keys(t), r = {};
                function o() {
                    n.forEach(function(t) {
                        e[t] = r[t];
                    });
                }
                return function(i) {
                    n.forEach(function(n) {
                        r[n] = e[n], e[n] = t[n];
                    });
                    var u = i();
                    return u && "function" == typeof u.then ? u.then(o).catch(o) : o(), u;
                };
            }
            !function() {
                function t(t, e) {
                    Object.defineProperty(s, t, {
                        value: e,
                        enumerable: !1,
                        configurable: !0
                    });
                }
                t("__get__", p), t("__GetDependency__", p), t("__Rewire__", y), t("__set__", y), t("__reset__", h), t("__ResetDependency__", h), t("__with__", v);
            }();
            var d = r(o);
            function b(t, e) {
                Object.defineProperty(o, t, {
                    value: e,
                    enumerable: !1,
                    configurable: !0
                });
            }
            "object" !== d && "function" !== d || !Object.isExtensible(o) || (b("__get__", p), b("__GetDependency__", p), b("__Rewire__", y), b("__set__", y), b("__reset__", h), b("__ResetDependency__", h), b("__with__", v), b("__RewireAPI__", s));
        }).call(this, n(10));
    },
    function(t, e, n) {
        "use strict";
        (function(t) {
            n(11), n(12), n(20), n(15), n(9), n(16), n(66), n(67), n(17);
            var r = n(32);
            function o(t) {
                return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                    return typeof t;
                } : function(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            function i(t, e) {
                var n = t.querySelectorAll(".js-file-line"), r = y("getLineNumbers")(e, n.length);
                t.querySelectorAll("td.line-data").forEach(function(t) {
                    t.style.width = "100%";
                }), n.forEach(function(t, e) {
                    r.includes(e + 1) && (t.style.backgroundColor = "rgb(255, 255, 204)");
                });
            }
            function u() {
                try {
                    if (t) return t;
                } catch (t) {
                    try {
                        if (window) return window;
                    } catch (t) {
                        return this;
                    }
                }
            }
            e.a = y("highlightLine");
            var c, _ = null;
            function f() {
                if (null === _) {
                    var t = u();
                    t.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ || (t.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0), _ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
                }
                return _;
            }
            function a() {
                var t = u();
                return t.__$$GLOBAL_REWIRE_REGISTRY__ || (t.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null)), t.__$$GLOBAL_REWIRE_REGISTRY__;
            }
            function l() {
                var t = f(), e = a(), n = e[t];
                return n || (e[t] = Object.create(null), n = e[t]), n;
            }
            (c = u()).__rewire_reset_all__ || (c.__rewire_reset_all__ = function() {
                c.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
            });
            var s = "__INTENTIONAL_UNDEFINED__", p = {};
            function y(t) {
                var e = l();
                if (void 0 === e[t]) return function(t) {
                    switch(t){
                        case "getLineNumbers":
                            return r.a;
                        case "highlightLine":
                            return i;
                    }
                    return;
                }(t);
                var n = e[t];
                return n === s ? void 0 : n;
            }
            function h(t, e) {
                var n = l();
                return "object" === o(t) ? (Object.keys(t).forEach(function(e) {
                    n[e] = t[e];
                }), function() {
                    Object.keys(t).forEach(function(e) {
                        v(t);
                    });
                }) : (n[t] = void 0 === e ? s : e, function() {
                    v(t);
                });
            }
            function v(t) {
                var e = l();
                delete e[t], 0 == Object.keys(e).length && delete a()[f];
            }
            function d(t) {
                var e = l(), n = Object.keys(t), r = {};
                function o() {
                    n.forEach(function(t) {
                        e[t] = r[t];
                    });
                }
                return function(i) {
                    n.forEach(function(n) {
                        r[n] = e[n], e[n] = t[n];
                    });
                    var u = i();
                    return u && "function" == typeof u.then ? u.then(o).catch(o) : o(), u;
                };
            }
            !function() {
                function t(t, e) {
                    Object.defineProperty(p, t, {
                        value: e,
                        enumerable: !1,
                        configurable: !0
                    });
                }
                t("__get__", y), t("__GetDependency__", y), t("__Rewire__", h), t("__set__", h), t("__reset__", v), t("__ResetDependency__", v), t("__with__", d);
            }();
            var b = o(i);
            function E(t, e) {
                Object.defineProperty(i, t, {
                    value: e,
                    enumerable: !1,
                    configurable: !0
                });
            }
            "object" !== b && "function" !== b || !Object.isExtensible(i) || (E("__get__", y), E("__GetDependency__", y), E("__Rewire__", h), E("__set__", h), E("__reset__", v), E("__ResetDependency__", v), E("__with__", d), E("__RewireAPI__", p));
        }).call(this, n(10));
    },
    function(t, e, n) {
        "use strict";
        (function(t) {
            n(11), n(12), n(20), n(15), n(9), n(16), n(66), n(67), n(17);
            var r = n(32);
            function o(t) {
                return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                    return typeof t;
                } : function(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            function i(t, e) {
                var n = t.querySelectorAll(".js-file-line"), r = y("getLineNumbers")(e, n.length);
                n.forEach(function(t, e) {
                    r.includes(e + 1) || null == t.parentNode || null == t.parentNode.parentNode || t.parentNode.parentNode.removeChild(t.parentNode);
                });
            }
            function u() {
                try {
                    if (t) return t;
                } catch (t) {
                    try {
                        if (window) return window;
                    } catch (t) {
                        return this;
                    }
                }
            }
            e.a = y("line");
            var c, _ = null;
            function f() {
                if (null === _) {
                    var t = u();
                    t.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ || (t.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0), _ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
                }
                return _;
            }
            function a() {
                var t = u();
                return t.__$$GLOBAL_REWIRE_REGISTRY__ || (t.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null)), t.__$$GLOBAL_REWIRE_REGISTRY__;
            }
            function l() {
                var t = f(), e = a(), n = e[t];
                return n || (e[t] = Object.create(null), n = e[t]), n;
            }
            (c = u()).__rewire_reset_all__ || (c.__rewire_reset_all__ = function() {
                c.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
            });
            var s = "__INTENTIONAL_UNDEFINED__", p = {};
            function y(t) {
                var e = l();
                if (void 0 === e[t]) return function(t) {
                    switch(t){
                        case "getLineNumbers":
                            return r.a;
                        case "line":
                            return i;
                    }
                    return;
                }(t);
                var n = e[t];
                return n === s ? void 0 : n;
            }
            function h(t, e) {
                var n = l();
                return "object" === o(t) ? (Object.keys(t).forEach(function(e) {
                    n[e] = t[e];
                }), function() {
                    Object.keys(t).forEach(function(e) {
                        v(t);
                    });
                }) : (n[t] = void 0 === e ? s : e, function() {
                    v(t);
                });
            }
            function v(t) {
                var e = l();
                delete e[t], 0 == Object.keys(e).length && delete a()[f];
            }
            function d(t) {
                var e = l(), n = Object.keys(t), r = {};
                function o() {
                    n.forEach(function(t) {
                        e[t] = r[t];
                    });
                }
                return function(i) {
                    n.forEach(function(n) {
                        r[n] = e[n], e[n] = t[n];
                    });
                    var u = i();
                    return u && "function" == typeof u.then ? u.then(o).catch(o) : o(), u;
                };
            }
            !function() {
                function t(t, e) {
                    Object.defineProperty(p, t, {
                        value: e,
                        enumerable: !1,
                        configurable: !0
                    });
                }
                t("__get__", y), t("__GetDependency__", y), t("__Rewire__", h), t("__set__", h), t("__reset__", v), t("__ResetDependency__", v), t("__with__", d);
            }();
            var b = o(i);
            function E(t, e) {
                Object.defineProperty(i, t, {
                    value: e,
                    enumerable: !1,
                    configurable: !0
                });
            }
            "object" !== b && "function" !== b || !Object.isExtensible(i) || (E("__get__", y), E("__GetDependency__", y), E("__Rewire__", h), E("__set__", h), E("__reset__", v), E("__ResetDependency__", v), E("__with__", d), E("__RewireAPI__", p));
        }).call(this, n(10));
    },
    function(t, e, n) {
        "use strict";
        n.r(e), (function(t) {
            n.d(e, "__get__", function() {
                return D;
            }), n.d(e, "__GetDependency__", function() {
                return D;
            }), n.d(e, "__Rewire__", function() {
                return $;
            }), n.d(e, "__set__", function() {
                return $;
            }), n.d(e, "__ResetDependency__", function() {
                return P;
            }), n.d(e, "__RewireAPI__", function() {
                return N;
            });
            n(11), n(12), n(15), n(16), n(83), n(17), n(9), n(87), n(88);
            var r = n(69), o = n(70), i = n(71), u = n(72), c = n(73);
            function _(t) {
                return (_ = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                    return typeof t;
                } : function(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            window.GistEmbedSettings = window.GistEmbedSettings || {}, window.GistEmbed = {};
            var f, a = new Set, l = "_gistEmbedJSONP_", s = 0, p = window.GistEmbedSettings.baseURL || "https://gist.github.com/", y = "data-gist-id", h = "data-gist-file";
            !function(t) {
                t.hideLineNumbersAttribute = "data-gist-hide-line-numbers", t.hideFooterAttribute = "data-gist-hide-footer", t.captionAttribute = "data-gist-caption", t.lineAttribute = "data-gist-line", t.highlightLineAttribute = "data-gist-highlight-line";
            }(f || (f = {}));
            var v = [
                f.hideLineNumbersAttribute,
                f.hideFooterAttribute,
                f.captionAttribute,
                f.lineAttribute,
                f.highlightLineAttribute
            ];
            function d() {
                Array.from(D("getAllGistEmbedDOMNodes")()).forEach(D("fetchJSONPForGistEmbedDOMNode"));
            }
            function b() {
                return document.querySelectorAll("[".concat(D("GIST_ID_ATTRIBUTE_NAME"), "]"));
            }
            function E() {
                var t, e, n;
                return t = "++", n = D(e = "_jsonpCallbackIDCounter"), function(t, e) {
                    var n = T();
                    void 0 === n[t] ? function(t, e) {
                        switch(t){
                            case "_jsonpCallbackIDCounter":
                                s = e;
                        }
                    }(t, e) : n[t] = e;
                }(e, "++" === t ? n + 1 : n - 1), "".concat(D("JSONP_CALLBACK_PREFIX")).concat(D("_jsonpCallbackIDCounter"));
            }
            function g(t) {
                if (!D("StylesheetURLs").has(t)) {
                    D("StylesheetURLs").add(t);
                    var e = document.createElement("link");
                    e.setAttribute("href", t), e.setAttribute("type", "text/css"), e.setAttribute("rel", "stylesheet"), document.body.appendChild(e);
                }
            }
            function O(t, e, n) {
                var r = D("generateJSONPCallbackPrefix")();
                window[r] = n;
                var o = document.createElement("script"), i = null != e ? "&file=".concat(encodeURIComponent(e)) : "";
                o.setAttribute("src", "".concat(D("GIST_URL_PREFIX")).concat(t, ".json?callback=").concat(r).concat(i)), document.body.appendChild(o);
            }
            function R(t) {
                var e = t.getAttribute(D("GIST_ID_ATTRIBUTE_NAME")), n = t.getAttribute(D("GIST_FILE_ATTRIBUTE_NAME"));
                null != e && "" !== e && D("getJSONP")(e, n, function(e) {
                    D("handleGetJSONPResponse")(t, e);
                });
            }
            function m(t, e) {
                null != e && null != e.div && null != e.stylesheet ? D("updateDOMNodeWithGistContent")(t, e.stylesheet, e.div) : t.innerHTML = "Error fetching gist";
            }
            function L(t, e, n) {
                D("appendStylesheet")(e), t.innerHTML = n, t.children.length && t.children[0].removeAttribute("id"), D("modify")(t);
            }
            function S(t) {
                D("MODIFIER_ATTRIBUTE_NAMES").forEach(function(e) {
                    var n = t.getAttribute(e);
                    if (null != n && "" !== n) switch(e){
                        case "data-gist-hide-line-numbers":
                            "true" === n && D("hideLineNumbers")(t);
                            break;
                        case "data-gist-hide-footer":
                            "true" === n && D("hideFooter")(t);
                            break;
                        case "data-gist-caption":
                            D("caption")(t, n);
                            break;
                        case "data-gist-line":
                            D("line")(t, n);
                            break;
                        case "data-gist-highlight-line":
                            D("highlightLine")(t, n);
                    }
                });
            }
            function I() {
                try {
                    if (t) return t;
                } catch (t) {
                    try {
                        if (window) return window;
                    } catch (t) {
                        return this;
                    }
                }
            }
            "complete" === document.readyState ? D("init")() : document.addEventListener("DOMContentLoaded", D("init")), window.GistEmbed.init = D("init");
            var w, x = null;
            function j() {
                if (null === x) {
                    var t = I();
                    t.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ || (t.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0), x = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
                }
                return x;
            }
            function A() {
                var t = I();
                return t.__$$GLOBAL_REWIRE_REGISTRY__ || (t.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null)), t.__$$GLOBAL_REWIRE_REGISTRY__;
            }
            function T() {
                var t = j(), e = A(), n = e[t];
                return n || (e[t] = Object.create(null), n = e[t]), n;
            }
            (w = I()).__rewire_reset_all__ || (w.__rewire_reset_all__ = function() {
                w.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
            });
            var G = "__INTENTIONAL_UNDEFINED__", N = {};
            function D(t) {
                var e = T();
                if (void 0 === e[t]) return function(t) {
                    switch(t){
                        case "init":
                            return d;
                        case "getAllGistEmbedDOMNodes":
                            return b;
                        case "fetchJSONPForGistEmbedDOMNode":
                            return R;
                        case "GIST_ID_ATTRIBUTE_NAME":
                            return y;
                        case "_jsonpCallbackIDCounter":
                            return s;
                        case "JSONP_CALLBACK_PREFIX":
                            return l;
                        case "StylesheetURLs":
                            return a;
                        case "generateJSONPCallbackPrefix":
                            return E;
                        case "GIST_URL_PREFIX":
                            return p;
                        case "GIST_FILE_ATTRIBUTE_NAME":
                            return h;
                        case "getJSONP":
                            return O;
                        case "handleGetJSONPResponse":
                            return m;
                        case "updateDOMNodeWithGistContent":
                            return L;
                        case "appendStylesheet":
                            return g;
                        case "modify":
                            return S;
                        case "MODIFIER_ATTRIBUTE_NAMES":
                            return v;
                        case "hideLineNumbers":
                            return i.a;
                        case "hideFooter":
                            return o.a;
                        case "caption":
                            return r.a;
                        case "line":
                            return c.a;
                        case "highlightLine":
                            return u.a;
                    }
                    return;
                }(t);
                var n = e[t];
                return n === G ? void 0 : n;
            }
            function $(t, e) {
                var n = T();
                return "object" === _(t) ? (Object.keys(t).forEach(function(e) {
                    n[e] = t[e];
                }), function() {
                    Object.keys(t).forEach(function(e) {
                        P(t);
                    });
                }) : (n[t] = void 0 === e ? G : e, function() {
                    P(t);
                });
            }
            function P(t) {
                var e = T();
                delete e[t], 0 == Object.keys(e).length && delete A()[j];
            }
            function k(t) {
                var e = T(), n = Object.keys(t), r = {};
                function o() {
                    n.forEach(function(t) {
                        e[t] = r[t];
                    });
                }
                return function(i) {
                    n.forEach(function(n) {
                        r[n] = e[n], e[n] = t[n];
                    });
                    var u = i();
                    return u && "function" == typeof u.then ? u.then(o).catch(o) : o(), u;
                };
            }
            !function() {
                function t(t, e) {
                    Object.defineProperty(N, t, {
                        value: e,
                        enumerable: !1,
                        configurable: !0
                    });
                }
                t("__get__", D), t("__GetDependency__", D), t("__Rewire__", $), t("__set__", $), t("__reset__", P), t("__ResetDependency__", P), t("__with__", k);
            }(), e.default = N;
        }).call(this, n(10));
    },
    function(t, e, n) {
        t.exports = n(28)("native-function-to-string", Function.toString);
    },
    function(t, e, n) {
        var r = n(24), o = n(50), i = n(38);
        t.exports = function(t) {
            var e = r(t), n = o.f;
            if (n) for(var u, c = n(t), _ = i.f, f = 0; c.length > f;)_.call(t, u = c[f++]) && e.push(u);
            return e;
        };
    },
    function(t, e, n) {
        var r = n(30);
        t.exports = Object("z").propertyIsEnumerable(0) ? Object : function(t) {
            return "String" == r(t) ? t.split("") : Object(t);
        };
    },
    function(t, e, n) {
        var r = n(35), o = Math.max, i = Math.min;
        t.exports = function(t, e) {
            return (t = r(t)) < 0 ? o(t + e, 0) : i(t, e);
        };
    },
    function(t, e, n) {
        var r = n(30);
        t.exports = Array.isArray || function(t) {
            return "Array" == r(t);
        };
    },
    function(t, e, n) {
        var r = n(3), o = n(4), i = n(24);
        t.exports = n(5) ? Object.defineProperties : function(t, e) {
            o(t);
            for(var n, u = i(e), c = u.length, _ = 0; c > _;)r.f(t, n = u[_++], e[n]);
            return t;
        };
    },
    function(t, e, n) {
        var r = n(1).document;
        t.exports = r && r.documentElement;
    },
    function(t, e, n) {
        var r = n(19), o = n(51).f, i = {}.toString, u = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
        t.exports.f = function(t) {
            return u && "[object Window]" == i.call(t) ? function(t) {
                try {
                    return o(t);
                } catch (t) {
                    return u.slice();
                }
            }(t) : o(r(t));
        };
    },
    function(t, e, n) {
        "use strict";
        var r = n(23), o = n(7), i = n(40), u = n(54), c = n(55), _ = n(31), f = n(84), a = n(56);
        o(o.S + o.F * !n(58)(function(t) {
            Array.from(t);
        }), "Array", {
            from: function(t) {
                var e, n, o, l, s = i(t), p = "function" == typeof this ? this : Array, y = arguments.length, h = y > 1 ? arguments[1] : void 0, v = void 0 !== h, d = 0, b = a(s);
                if (v && (h = r(h, y > 2 ? arguments[2] : void 0, 2)), null == b || p == Array && c(b)) for(n = new p(e = _(s.length)); e > d; d++)f(n, d, v ? h(s[d], d) : s[d]);
                else for(l = b.call(s), n = new p; !(o = l.next()).done; d++)f(n, d, v ? u(l, h, [
                    o.value,
                    d
                ], !0) : o.value);
                return n.length = d, n;
            }
        });
    },
    function(t, e, n) {
        "use strict";
        var r = n(3), o = n(22);
        t.exports = function(t, e, n) {
            e in t ? r.f(t, e, o(0, n)) : t[e] = n;
        };
    },
    function(t, e, n) {
        "use strict";
        var r = n(39), o = n(22), i = n(29), u = {};
        n(8)(u, n(0)("iterator"), function() {
            return this;
        }), t.exports = function(t, e, n) {
            t.prototype = r(u, {
                next: o(1, n)
            }), i(t, e + " Iterator");
        };
    },
    function(t, e, n) {
        var r = n(13), o = n(40), i = n(36)("IE_PROTO"), u = Object.prototype;
        t.exports = Object.getPrototypeOf || function(t) {
            return t = o(t), r(t, i) ? t[i] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? u : null;
        };
    },
    function(t, e, n) {
        "use strict";
        var r = n(61)(!0);
        n(41)(String, "String", function(t) {
            this._t = String(t), this._i = 0;
        }, function() {
            var t, e = this._t, n = this._i;
            return n >= e.length ? {
                value: void 0,
                done: !0
            } : (t = r(e, n), this._i += t.length, {
                value: t,
                done: !1
            });
        });
    },
    function(t, e, n) {
        "use strict";
        var r = n(89), o = n(65);
        t.exports = n(91)("Set", function(t) {
            return function() {
                return t(this, arguments.length > 0 ? arguments[0] : void 0);
            };
        }, {
            add: function(t) {
                return r.def(o(this, "Set"), t = 0 === t ? 0 : t, t);
            }
        }, r);
    },
    function(t, e, n) {
        "use strict";
        var r = n(3).f, o = n(39), i = n(62), u = n(23), c = n(63), _ = n(64), f = n(41), a = n(60), l = n(90), s = n(5), p = n(34).fastKey, y = n(65), h = s ? "_s" : "size", v = function(t, e) {
            var n, r = p(e);
            if ("F" !== r) return t._i[r];
            for(n = t._f; n; n = n.n)if (n.k == e) return n;
        };
        t.exports = {
            getConstructor: function(t, e, n, f) {
                var a = t(function(t, r) {
                    c(t, a, e, "_i"), t._t = e, t._i = o(null), t._f = void 0, t._l = void 0, t[h] = 0, null != r && _(r, n, t[f], t);
                });
                return i(a.prototype, {
                    clear: function() {
                        for(var t = y(this, e), n = t._i, r = t._f; r; r = r.n)r.r = !0, r.p && (r.p = r.p.n = void 0), delete n[r.i];
                        t._f = t._l = void 0, t[h] = 0;
                    },
                    delete: function(t) {
                        var n = y(this, e), r = v(n, t);
                        if (r) {
                            var o = r.n, i = r.p;
                            delete n._i[r.i], r.r = !0, i && (i.n = o), o && (o.p = i), n._f == r && (n._f = o), n._l == r && (n._l = i), n[h]--;
                        }
                        return !!r;
                    },
                    forEach: function(t) {
                        y(this, e);
                        for(var n, r = u(t, arguments.length > 1 ? arguments[1] : void 0, 3); n = n ? n.n : this._f;)for(r(n.v, n.k, this); n && n.r;)n = n.p;
                    },
                    has: function(t) {
                        return !!v(y(this, e), t);
                    }
                }), s && r(a.prototype, "size", {
                    get: function() {
                        return y(this, e)[h];
                    }
                }), a;
            },
            def: function(t, e, n) {
                var r, o, i = v(t, e);
                return i ? i.v = n : (t._l = i = {
                    i: o = p(e, !0),
                    k: e,
                    v: n,
                    p: r = t._l,
                    n: void 0,
                    r: !1
                }, t._f || (t._f = i), r && (r.n = i), t[h]++, "F" !== o && (t._i[o] = i)), t;
            },
            getEntry: v,
            setStrong: function(t, e, n) {
                f(t, e, function(t, n) {
                    this._t = y(t, e), this._k = n, this._l = void 0;
                }, function() {
                    for(var t = this._k, e = this._l; e && e.r;)e = e.p;
                    return this._t && (this._l = e = e ? e.n : this._t._f) ? a(0, "keys" == t ? e.k : "values" == t ? e.v : [
                        e.k,
                        e.v
                    ]) : (this._t = void 0, a(1));
                }, n ? "entries" : "values", !n, !0), l(e);
            }
        };
    },
    function(t, e, n) {
        "use strict";
        var r = n(1), o = n(3), i = n(5), u = n(0)("species");
        t.exports = function(t) {
            var e = r[t];
            i && e && !e[u] && o.f(e, u, {
                configurable: !0,
                get: function() {
                    return this;
                }
            });
        };
    },
    function(t, e, n) {
        "use strict";
        var r = n(1), o = n(7), i = n(14), u = n(62), c = n(34), _ = n(64), f = n(63), a = n(2), l = n(6), s = n(58), p = n(29), y = n(92);
        t.exports = function(t, e, n, h, v, d) {
            var b = r[t], E = b, g = v ? "set" : "add", O = E && E.prototype, R = {}, m = function(t) {
                var e = O[t];
                i(O, t, "delete" == t ? function(t) {
                    return !(d && !a(t)) && e.call(this, 0 === t ? 0 : t);
                } : "has" == t ? function(t) {
                    return !(d && !a(t)) && e.call(this, 0 === t ? 0 : t);
                } : "get" == t ? function(t) {
                    return d && !a(t) ? void 0 : e.call(this, 0 === t ? 0 : t);
                } : "add" == t ? function(t) {
                    return e.call(this, 0 === t ? 0 : t), this;
                } : function(t, n) {
                    return e.call(this, 0 === t ? 0 : t, n), this;
                });
            };
            if ("function" == typeof E && (d || O.forEach && !l(function() {
                (new E).entries().next();
            }))) {
                var L = new E, S = L[g](d ? {} : -0, 1) != L, I = l(function() {
                    L.has(1);
                }), w = s(function(t) {
                    new E(t);
                }), x = !d && l(function() {
                    for(var t = new E, e = 5; e--;)t[g](e, e);
                    return !t.has(-0);
                });
                w || ((E = e(function(e, n) {
                    f(e, E, t);
                    var r = y(new b, e, E);
                    return null != n && _(n, v, r[g], r), r;
                })).prototype = O, O.constructor = E), (I || x) && (m("delete"), m("has"), v && m("get")), (x || S) && m(g), d && O.clear && delete O.clear;
            } else E = h.getConstructor(e, t, v, g), u(E.prototype, n), c.NEED = !0;
            return p(E, t), R[t] = E, o(o.G + o.W + o.F * (E != b), R), d || h.setStrong(E, t, v), E;
        };
    },
    function(t, e, n) {
        var r = n(2), o = n(93).set;
        t.exports = function(t, e, n) {
            var i, u = e.constructor;
            return u !== n && "function" == typeof u && (i = u.prototype) !== n.prototype && r(i) && o && o(t, i), t;
        };
    },
    function(t, e, n) {
        var r = n(2), o = n(4), i = function(t, e) {
            if (o(t), !r(e) && null !== e) throw TypeError(e + ": can't set as prototype!");
        };
        t.exports = {
            set: Object.setPrototypeOf || ("__proto__" in {} ? function(t, e, r) {
                try {
                    (r = n(23)(Function.call, n(52).f(Object.prototype, "__proto__").set, 2))(t, []), e = !(t instanceof Array);
                } catch (t) {
                    e = !0;
                }
                return function(t, n) {
                    return i(t, n), e ? t.__proto__ = n : r(t, n), t;
                };
            }({}, !1) : void 0),
            check: i
        };
    },
    function(t, e, n) {
        var r = n(68), o = n(25);
        t.exports = function(t, e, n) {
            if (r(e)) throw TypeError("String#" + n + " doesn't accept regex!");
            return String(o(t));
        };
    },
    function(t, e, n) {
        var r = n(0)("match");
        t.exports = function(t) {
            var e = /./;
            try {
                "/./"[t](e);
            } catch (n) {
                try {
                    return e[r] = !1, !"/./"[t](e);
                } catch (t) {}
            }
            return !0;
        };
    },
    function(t, e, n) {
        "use strict";
        var r = n(68), o = n(4), i = n(97), u = n(98), c = n(31), _ = n(99), f = n(42), a = n(6), l = Math.min, s = [].push, p = !a(function() {
            RegExp(4294967295, "y");
        });
        n(101)("split", 2, function(t, e, n, a) {
            var y;
            return y = "c" == "abbc".split(/(b)*/)[1] || 4 != "test".split(/(?:)/, -1).length || 2 != "ab".split(/(?:ab)*/).length || 4 != ".".split(/(.?)(.?)/).length || ".".split(/()()/).length > 1 || "".split(/.?/).length ? function(t, e) {
                var o = String(this);
                if (void 0 === t && 0 === e) return [];
                if (!r(t)) return n.call(o, t, e);
                for(var i, u, c, _ = [], a = (t.ignoreCase ? "i" : "") + (t.multiline ? "m" : "") + (t.unicode ? "u" : "") + (t.sticky ? "y" : ""), l = 0, p = void 0 === e ? 4294967295 : e >>> 0, y = new RegExp(t.source, a + "g"); (i = f.call(y, o)) && !((u = y.lastIndex) > l && (_.push(o.slice(l, i.index)), i.length > 1 && i.index < o.length && s.apply(_, i.slice(1)), c = i[0].length, l = u, _.length >= p));)y.lastIndex === i.index && y.lastIndex++;
                return l === o.length ? !c && y.test("") || _.push("") : _.push(o.slice(l)), _.length > p ? _.slice(0, p) : _;
            } : "0".split(void 0, 0).length ? function(t, e) {
                return void 0 === t && 0 === e ? [] : n.call(this, t, e);
            } : n, [
                function(n, r) {
                    var o = t(this), i = null == n ? void 0 : n[e];
                    return void 0 !== i ? i.call(n, o, r) : y.call(String(o), n, r);
                },
                function(t, e) {
                    var r = a(y, t, this, e, y !== n);
                    if (r.done) return r.value;
                    var f = o(t), s = String(this), h = i(f, RegExp), v = f.unicode, d = (f.ignoreCase ? "i" : "") + (f.multiline ? "m" : "") + (f.unicode ? "u" : "") + (p ? "y" : "g"), b = new h(p ? f : "^(?:" + f.source + ")", d), E = void 0 === e ? 4294967295 : e >>> 0;
                    if (0 === E) return [];
                    if (0 === s.length) return null === _(b, s) ? [
                        s
                    ] : [];
                    for(var g = 0, O = 0, R = []; O < s.length;){
                        b.lastIndex = p ? O : 0;
                        var m, L = _(b, p ? s : s.slice(O));
                        if (null === L || (m = l(c(b.lastIndex + (p ? 0 : O)), s.length)) === g) O = u(s, O, v);
                        else {
                            if (R.push(s.slice(g, O)), R.length === E) return R;
                            for(var S = 1; S <= L.length - 1; S++)if (R.push(L[S]), R.length === E) return R;
                            O = g = m;
                        }
                    }
                    return R.push(s.slice(g)), R;
                }
            ];
        });
    },
    function(t, e, n) {
        var r = n(4), o = n(47), i = n(0)("species");
        t.exports = function(t, e) {
            var n, u = r(t).constructor;
            return void 0 === u || null == (n = r(u)[i]) ? e : o(n);
        };
    },
    function(t, e, n) {
        "use strict";
        var r = n(61)(!0);
        t.exports = function(t, e, n) {
            return e + (n ? r(t, e).length : 1);
        };
    },
    function(t, e, n) {
        "use strict";
        var r = n(57), o = RegExp.prototype.exec;
        t.exports = function(t, e) {
            var n = t.exec;
            if ("function" == typeof n) {
                var i = n.call(t, e);
                if ("object" != typeof i) throw new TypeError("RegExp exec method returned something other than an Object or null");
                return i;
            }
            if ("RegExp" !== r(t)) throw new TypeError("RegExp#exec called on incompatible receiver");
            return o.call(t, e);
        };
    },
    function(t, e, n) {
        "use strict";
        var r = n(4);
        t.exports = function() {
            var t = r(this), e = "";
            return t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.unicode && (e += "u"), t.sticky && (e += "y"), e;
        };
    },
    function(t, e, n) {
        "use strict";
        n(102);
        var r = n(14), o = n(8), i = n(6), u = n(25), c = n(0), _ = n(42), f = c("species"), a = !i(function() {
            var t = /./;
            return t.exec = function() {
                var t = [];
                return t.groups = {
                    a: "7"
                }, t;
            }, "7" !== "".replace(t, "$<a>");
        }), l = function() {
            var t = /(?:)/, e = t.exec;
            t.exec = function() {
                return e.apply(this, arguments);
            };
            var n = "ab".split(t);
            return 2 === n.length && "a" === n[0] && "b" === n[1];
        }();
        t.exports = function(t, e, n) {
            var s = c(t), p = !i(function() {
                var e = {};
                return e[s] = function() {
                    return 7;
                }, 7 != ""[t](e);
            }), y = p ? !i(function() {
                var e = !1, n = /a/;
                return n.exec = function() {
                    return e = !0, null;
                }, "split" === t && (n.constructor = {}, n.constructor[f] = function() {
                    return n;
                }), n[s](""), !e;
            }) : void 0;
            if (!p || !y || "replace" === t && !a || "split" === t && !l) {
                var h = /./[s], v = n(u, s, ""[t], function(t, e, n, r, o) {
                    return e.exec === _ ? p && !o ? {
                        done: !0,
                        value: h.call(e, n, r)
                    } : {
                        done: !0,
                        value: t.call(n, e, r)
                    } : {
                        done: !1
                    };
                }), d = v[0], b = v[1];
                r(String.prototype, t, d), o(RegExp.prototype, s, 2 == e ? function(t, e) {
                    return b.call(t, this, e);
                } : function(t) {
                    return b.call(t, this);
                });
            }
        };
    },
    function(t, e, n) {
        "use strict";
        var r = n(42);
        n(7)({
            target: "RegExp",
            proto: !0,
            forced: r !== /./.exec
        }, {
            exec: r
        });
    }
]);


const $df5bef30413a053b$export$f4644083ce95e7e3 = Math.PI * 2;
function $df5bef30413a053b$export$a4d69fb5f2026c35(number, bottom, top) {
    return number >= bottom && number <= top;
}
function $df5bef30413a053b$export$e5f2a2ab65fdebdc(ctx, str, maxWidth) {
    let width = ctx.measureText(str).width;
    const ellipsis = "...";
    const ellipsisWidth = ctx.measureText(ellipsis).width;
    if (width <= maxWidth || width <= ellipsisWidth) return str;
    else {
        let length = str.length;
        while(width >= maxWidth - ellipsisWidth && length-- > 0){
            str = str.substring(0, length);
            width = ctx.measureText(str).width;
        }
        return str + ellipsis;
    }
}
function $df5bef30413a053b$export$974bdb95b91e2282(node) {
    document.body.appendChild(node.content.cloneNode(true));
}
function $df5bef30413a053b$export$a7a64595f9a52d4() {
    (0, $4ffa2ba0c2b40bcc$export$2e2bcd8739ae039)("[data-zoomable]", {
        background: "rgba(0, 0, 0, .5)"
    });
    // GistEmbed doesn't play nice and pollutes globals.
    // On the other hand, it helps to overcome document.write after
    // the document was closed for writing, which is in all Gists, by default.
    window.GistEmbed.init();
}
function $df5bef30413a053b$export$d7e8d4d4450c819c(id, options = {}) {
    const modalId = `#modal-${id}`;
    const modalTemplateId = `#modal-${id}-template`;
    if (!$df5bef30413a053b$export$ee27c052bca048fb(modalId)) $df5bef30413a053b$export$974bdb95b91e2282($df5bef30413a053b$export$836aee6bce45247(modalTemplateId));
    (0, $adcf363a09f534a1$export$2e2bcd8739ae039).show(`modal-${id}`, {
        onShow: ()=>{
            $df5bef30413a053b$export$5759aba79a56bf23("modal", id);
            $df5bef30413a053b$export$3382666c429aff83();
            options.onShow?.();
        },
        onClose: ()=>{
            $df5bef30413a053b$export$e1ea1fbf111a14fe("modal");
            $df5bef30413a053b$export$d0d36b98481c622d();
            options.onClose?.();
        },
        awaitOpenAnimation: true,
        awaitCloseAnimation: true
    });
    // As modal may contain gists, or pictures,
    // re-initialising the generated content
    $df5bef30413a053b$export$a7a64595f9a52d4();
}
function $df5bef30413a053b$export$3382666c429aff83() {
    document.body.classList.add("no-scroll");
}
function $df5bef30413a053b$export$d0d36b98481c622d() {
    document.body.classList.remove("no-scroll");
}
function $df5bef30413a053b$export$836aee6bce45247(selector) {
    return document.querySelector(selector);
}
function $df5bef30413a053b$export$9ca9051b92b5a6d2(selector) {
    return Array.from(document.querySelectorAll(selector));
}
function $df5bef30413a053b$export$de363e709c412c8a(fn, delay) {
    let last = 0;
    let timeout;
    return function() {
        const now = Date.now();
        const sinceLast = now - last;
        clearTimeout(timeout);
        if (sinceLast > delay) {
            last = now;
            fn(...arguments);
        } else timeout = setTimeout(()=>{
            last = Date.now();
            fn(...arguments);
        }, delay - sinceLast);
    };
}
function $df5bef30413a053b$export$629b0a497aa65267(date) {
    return date.toDateString() === new Date().toDateString();
}
function $df5bef30413a053b$export$2e9241a0bdf6c8b8(start, end) {
    return `${start.toLocaleDateString()} - ${$df5bef30413a053b$export$629b0a497aa65267(end) ? "present" : end.toLocaleDateString()}`;
}
function $df5bef30413a053b$export$5759aba79a56bf23(name, value) {
    const qs = new URLSearchParams(window.location.search);
    qs.set(name, value);
    $df5bef30413a053b$export$796b81a51be0b38a(qs);
}
function $df5bef30413a053b$export$e1ea1fbf111a14fe(name) {
    const qs = new URLSearchParams(window.location.search);
    qs.delete(name);
    $df5bef30413a053b$export$796b81a51be0b38a(qs);
}
function $df5bef30413a053b$export$796b81a51be0b38a(qs) {
    window.history.replaceState({}, document.title, `${window.location.pathname}?${qs.toString()}`);
}
function $df5bef30413a053b$export$7d15b64cf5a3a4c4(value, min, max) {
    return Math.max(min, Math.min(value, max));
}
function $df5bef30413a053b$export$871de8747c9eaa88(value, [from, to], [min, max]) {
    return $df5bef30413a053b$export$7d15b64cf5a3a4c4(min + (max - min) * (value - from) / (to - from), min, max);
}
function $df5bef30413a053b$export$ee27c052bca048fb(selector) {
    return $df5bef30413a053b$export$836aee6bce45247(selector) !== null;
}
function $df5bef30413a053b$export$3f99968195accfaf(selector) {
    const target = $df5bef30413a053b$export$836aee6bce45247(selector);
    if (target) target.scrollIntoView();
}
function $df5bef30413a053b$export$4154a199d7d90455(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}
function $df5bef30413a053b$export$62b74373436a24c(el, onVisibilityChanged) {
    const observer = new IntersectionObserver(([change])=>{
        onVisibilityChanged(change.isIntersecting);
    }, {
        root: null,
        threshold: 0
    });
    observer.observe(el);
}
function $df5bef30413a053b$export$f0e9d14ede4c01bd(els, isVisible) {
    if (!Array.isArray(els)) els = [
        els
    ];
    for (const el of els)el.style.display = isVisible ? null : "none";
}
function $df5bef30413a053b$export$2dc6f8ad0f55f4d8(csv) {
    const rows = csv.split("\n").splice(1);
    return rows.filter((row)=>!!row.trim()).map((row)=>(row.match(/(".*?"|[^",]+)(?=\s*,|\s*$)/g) ?? []).map((cell)=>{
            const hasQuotes = cell.startsWith('"') && cell.endsWith('"');
            return (hasQuotes ? cell.slice(1, -1) : cell).trim();
        }));
}
function $df5bef30413a053b$export$6b862160d295c8e(date) {
    if (date === "now") return new Date();
    return new Date(date);
}
function $df5bef30413a053b$export$8b4981022bd80a4e(name) {
    return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
}


var $9b96906b1a4ddc1c$export$3830f593b4946569;
(function(EventTag) {
    EventTag["career"] = "career";
    EventTag["education"] = "education";
    EventTag["project"] = "project";
    EventTag["deliverable"] = "deliverable";
    EventTag["cool"] = "cool";
    EventTag["hobby"] = "hobby";
    EventTag["general"] = "general";
})($9b96906b1a4ddc1c$export$3830f593b4946569 || ($9b96906b1a4ddc1c$export$3830f593b4946569 = {}));
const $9b96906b1a4ddc1c$export$3af2a3e7710b9882 = {
    ["career"]: (0, (/*@__PURE__*/$parcel$interopDefault($3662ed097e2b5ad0$exports)))((0, $df5bef30413a053b$export$8b4981022bd80a4e)("--color-tag-career")).alpha(1),
    ["project"]: (0, (/*@__PURE__*/$parcel$interopDefault($3662ed097e2b5ad0$exports)))((0, $df5bef30413a053b$export$8b4981022bd80a4e)("--color-tag-project")).alpha(0.5),
    ["cool"]: (0, (/*@__PURE__*/$parcel$interopDefault($3662ed097e2b5ad0$exports)))((0, $df5bef30413a053b$export$8b4981022bd80a4e)("--color-tag-cool")).alpha(0.8),
    ["hobby"]: (0, (/*@__PURE__*/$parcel$interopDefault($3662ed097e2b5ad0$exports)))((0, $df5bef30413a053b$export$8b4981022bd80a4e)("--color-tag-hobby")).alpha(0.5),
    ["deliverable"]: (0, (/*@__PURE__*/$parcel$interopDefault($3662ed097e2b5ad0$exports)))((0, $df5bef30413a053b$export$8b4981022bd80a4e)("--color-tag-deliverable")),
    ["education"]: (0, (/*@__PURE__*/$parcel$interopDefault($3662ed097e2b5ad0$exports)))((0, $df5bef30413a053b$export$8b4981022bd80a4e)("--color-tag-education")).alpha(1),
    ["general"]: (0, (/*@__PURE__*/$parcel$interopDefault($3662ed097e2b5ad0$exports)))((0, $df5bef30413a053b$export$8b4981022bd80a4e)("--color-tag-general")).alpha(0.5)
};




var $2YFJl = parcelRequire("2YFJl");
class $745f816836c85b06$export$2e2bcd8739ae039 {
    constructor(value, elasticity = 0.2, damping = 1){
        this.value = value;
        this.target = value;
        this.elasticity = elasticity;
        this.damping = damping;
        this.velocity = Array.isArray(value) ? new Array(value.length).fill(0) : [
            0
        ];
    }
    /**
   * Advance the spring simulation by `dt` normalised frames.
   * `dt` should be `elapsed / (1000 / 60)` so that 1.0 equals one
   * 60 fps frame; values above or below scale force and damping
   * accordingly, making the simulation frame-rate independent.
   */ tick(dt = 1) {
        if (this.damping < 1) {
            // Frame-rate-independent spring:
            //   force  = (target − value) × stiffness × dt
            //   damping is applied as an exponential decay: damping^dt
            const vals = Array.isArray(this.value) ? this.value : [
                this.value
            ];
            const targets = Array.isArray(this.target) ? this.target : [
                this.target
            ];
            const dampingDt = Math.pow(this.damping, dt);
            const next = vals.map((v, i)=>{
                const force = (targets[i] - v) * this.elasticity * dt;
                this.velocity[i] = (this.velocity[i] + force) * dampingDt;
                return v + this.velocity[i];
            });
            this.value = Array.isArray(this.value) ? next : next[0];
        } else {
            // For LERP mode, scale the interpolation factor by dt so speed
            // stays constant regardless of frame rate.
            const alpha = 1 - Math.pow(1 - this.elasticity, dt);
            this.value = $2YFJl.interpolate(this.value, this.target)(alpha);
        }
    }
    setValue(value) {
        this.target = value;
    }
}


class $cfc6059e7597f0db$export$2e2bcd8739ae039 {
    static{
        /**
   * Defines the rendered height of an event
   */ this.lineHeight = 50;
    }
    static{
        /**
   * Defines how to render event names.
   */ this.fontConfig = {
            font: '24px "Plus Jakarta Sans"',
            fill: (0, $df5bef30413a053b$export$8b4981022bd80a4e)("--color-timeline-label") || "#ffffffda"
        };
    }
    constructor(config){
        this.startX = 0;
        this.endX = 0;
        this.startY = 0;
        this.endY = 0;
        this.config = config;
        this.color = new (0, $745f816836c85b06$export$2e2bcd8739ae039)(this.config.color);
    }
    /**
   * Renders the event to the given canvas context.
   *
   * @param ctx - canvas context
   */ draw(ctx) {
        // Advance the color transition
        // if necessary.
        this.color.tick();
        // Detect actual position of the event
        // based on the current transform of the viewport
        const startX = this.transform.currentTransform.applyX(this.startX);
        const endX = this.transform.currentTransform.applyX(this.endX);
        const length = endX - startX;
        // Render event body.
        ctx.beginPath();
        ctx.fillStyle = this.color.value;
        ctx.strokeStyle = this.color.value;
        ctx.save();
        ctx.rect(startX, this.startY, length, $cfc6059e7597f0db$export$2e2bcd8739ae039.lineHeight);
        // Clip the drawn rect, so that event
        // name doesn't overflow the boundary
        ctx.clip();
        ctx.fill();
        ctx.stroke();
        ctx.closePath();
        // Render event name.
        ctx.fillStyle = $cfc6059e7597f0db$export$2e2bcd8739ae039.fontConfig.fill;
        ctx.font = $cfc6059e7597f0db$export$2e2bcd8739ae039.fontConfig.font;
        ctx.fillText(this.config.name, startX + 10, this.startY + 38);
        ctx.restore();
    }
    /**
   * Rescales the desired event position in the unit
   * viewport, based on the given time scale instance.
   *
   * @param scale - scale holding the viewport domain
   *   and chronological range of the visualisation.
   */ applyScale(scale) {
        this.startX = scale(this.config.start);
        this.endX = scale(this.config.end);
        this.startY = this.config.depth * $cfc6059e7597f0db$export$2e2bcd8739ae039.lineHeight;
        this.endY = this.startY + $cfc6059e7597f0db$export$2e2bcd8739ae039.lineHeight;
    }
    /**
   * Returns the current bounding rect for the event,
   * with current scale applied.
   *
   * Used for hit testing.
   */ get boundingRect() {
        const startX = this.transform.currentTransform.applyX(this.startX);
        const endX = this.transform.currentTransform.applyX(this.endX);
        return [
            startX,
            endX,
            this.startY,
            this.endY
        ];
    }
}



var $5025a58a5323b280$exports = {};
$5025a58a5323b280$exports = "id,\" start\",\" end\",\" name\",\" depth\",\" tags\"\nlife,\"August 19, 1993\",\"now\",\"Life\",\"0\",\"general\"\nschool,\"September 1, 1999\",\"May 25, 2010\",\"School\",\"!1\",\"general, education\"\nuniversity,\"September 1, 2010\",\"May 25, 2014\",\"University\",\"!1\",\"general, education\"\ncareer,\"February 20, 2014\",\"now\",\"Software Engineer\",\"!1\",\"general, career\"\n-junior,\"February 20, 2014\",\"April 4, 2015\",\"Junior\",\"2\",\"general, career\"\n-middle,\"April 4, 2015\",\"October 16, 2015\",\"Middle\",\"2\",\"general, career\"\n-middle-continued,\"October 26, 2015\",\"October 26, 2016\",\"Middle\",\"2\",\"general, career\"\n-senior,\"October 26, 2016\",\"now\",\"Senior\",\"2\",\"general, career\"\nlarge-crm,\"February 20, 2014\",\"August 1, 2015\",\"Large CRM\",\"2\",\"career, project\"\nspreadsheets-app,\"August 1, 2014\",\"October 1, 2014\",\"Web spreadsheets app\",\"3\",\"career, project\"\niot-asset-management,\"June 15, 2015\",\"October 10, 2015\",\"IoT Asset Management\",\"3\",\"career, project\"\niot-platform,\"November 1, 2015\",\"August 31, 2019\",\"IoT Platform\",\"2\",\"career, project\"\npolymer-app,\"November 1, 2015\",\"December 20, 2015\",\"Polymer App\",\"3\",\"career, deliverable\"\nemail-templates,\"January 5, 2016\",\"January 20, 2016\",\"Email templates system\",\"3\",\"career, deliverable\"\nleaflet-maps,\"February 5 2016\",\"February 15, 2016\",\"Abstract Map Component with Leaflet\",\"3\",\"career, deliverable\"\ncrud-pages,\"February 20, 2016\",\"March 20, 2016\",\"CRUD for one of the resources\",\"3\",\"career, deliverable\"\napi-testing-tool,\"March 25, 2016\",\"April 5, 2016\",\"API Testing Tool\",\"3\",\"career, deliverable\"\nanalytics-dashboard,\"April 6, 2016\",\"April 10, 2016\",\"Analytics Dashboard\",\"3\",\"career, deliverable\"\nxbac,\"April 15, 2016\",\"April 25, 2016\",\"RBAC/ABAC for application\",\"3\",\"career, deliverable\"\nsession-timeouts,\"June 6, 2016\",\"June 28, 2016\",\"Active Session timeouts\",\"3\",\"career, deliverable\"\npassword-complexity,\"July 5, 2016\",\"July 15, 2016\",\"Password Complexity Indicator\",\"3\",\"career, deliverable\"\ndropping-compass,\"August 10, 2016\",\"September 15, 2016\",\"Migrated from Compass to libsass\",\"3\",\"career, deliverable\"\nbackend-testing,\"September 20, 2016\",\"October 5, 2016\",\"Microframework for Backend unit testing\",\"3\",\"career, deliverable\"\ncustom-dashboards,\"October 20, 2016\",\"December 25, 2016\",\"Application Customization Framework\",\"3\",\"career, deliverable, cool\"\niot-gateway,\"March 20, 2017\",\"September 25, 2017\",\"IoT Gateway on AWS Lambda\",\"3\",\"career, deliverable\"\ndart-sdk,\"June 10, 2017\",\"June 20, 2017\",\"Dart SDK for Platform APIs\",\"5\",\"career, deliverable, cool\"\niot-dashboard,\"May 15, 2017\",\"August 25, 2017\",\"Administration Dashboard for IoT Devices\",\"4\",\"career, deliverable\"\nlambda-tracing,\"June 23, 2017\",\"August 10, 2017\",\"Distributed tracing for AWS Lambda\",\"5\",\"career, deliverable, cool\"\nchapter-lead,\"August 30, 2017\",\"August 31, 2019\",\"Chapter Lead\",\"!3\",\"career, general\"\ndrop-bower,\"September 5, 2017\",\"September 15, 2017\",\"Migration from Bower/RequireJS\",\"4\",\"career, deliverable\"\ntraceability-search,\"February 7, 2016\",\"August 24, 2016\",\"Traceability Solution on AWS Lambda\",\"4\",\"career, project\"\nexperiences-service,\"August 10, 2018\",\"August 30, 2018\",\"WYSIWYG Experiences Service\",\"4\",\"career, deliverable, cool\"\ntraceability-solution,\"September 4, 2018\",\"April 3, 2020\",\"Traceability Solution\",\"4\",\"career, project\"\nsatellite-applications,\"November 20, 2018\",\"December 10, 2018\",\"Microfrontends\",\"6\",\"career, deliverable\"\ntraceability-dashboards,\"November 23, 2018\",\"April 23, 2019\",\"Traceability Dashboards\",\"5\",\"career, deliverable\"\ne2e-testcafe,\"January 23, 2018\",\"May 30, 2018\",\"E2E With TestCafe\",\"4\",\"career, deliverable\"\ndocker-optimisation,\"March 19, 2018\",\"March 30, 2018\",\"Docker Builds Optmisation\",\"5\",\"career, deliverable\"\nsupply-chain-traceability,\"September 1, 2019\",\"March 21, 2020\",\"Supply Chain Traceability\",\"2\",\"career, project\"\nar-demo,\"February 27, 2019\",\"March 19, 2019\",\"AR App Demo\",\"6\",\"career, deliverable, cool\"\nplatform-quickstart,\"October 10, 2017\",\"November 20, 2017\",\"Platform Quickstart\",\"4\",\"career, deliverable, cool\"\npallet-tracking,\"October 15, 2019\",\"April 2, 2020\",\"Pallet Tracking\",\"3\",\"career, project\"\nlambda-service,\"June 20, 2019\",\"July 10, 2019\",\"Service for serverless scripts\",\"5\",\"career, deliverable, cool\"\nsingularity,\"August 1, 2019\",\"September 20, 2019\",\"Singularity\",\"5\",\"career, project, cool\"\nmlls,\"September 25, 2019\",\"April 20, 2020\",\"My Long Locking Story\",\"5\",\"career, project, cool\"\nlisp-interpreter,\"February 1, 2020\",\"March 31, 2020\",\"LISP in Dart\",\"6\",\"career, deliverable, cool\"\nwutch,\"April 1, 2020\",\"October 1, 2020\",\"wutch.net\",\"2\",\"career, project, cool\"\nelectronic-music,\"August 9, 2011\",\"October 18, 2014\",\"Electronic music\",\"2\",\"general, hobby\"\ngraphic-design,\"February 9, 2012\",\"January 5, 2014\",\"Graphic Design\",\"3\",\"general, hobby\"\nhtml-taste,\"February 7, 2007\",\"May 26, 2007\",\"First taste of HTML\",\"!3\",\"general, career\"\nphotoshop-tutorials,\"May 12, 2004\",\"June 26, 2007\",\"Adobe Photoshop Tutorials\",\"!2\",\"general, hobby\"\nflutter-articles,\"September 1, 2019\",\"January 19, 2020\",\"Writing articles on Flutter\",\"6\",\"career, cool\"\noss-contribution,\"November 1, 2019\",\"December 1, 2019\",\"Contributing to Flame Engine\",\"7\",\"career, cool\"\nflutter-clock,\"January 10, 2020\",\"January 30, 2020\",\"Flutter Clock Challenge\",\"7\",\"career, cool\"\nredscript,\"October 1, 2015\",\"October 5, 2015\",\"RedScript\",\"5\",\"career, cool\"\ndtg,\"April 1, 2016\",\"April 10, 2016\",\"DTG\",\"5\",\"career, cool\"\neuler-rust,\"December 1, 2016\",\"December 31, 2016\",\"Project Euler in Rust\",\"4\",\"career, cool\"\nyson,\"September 20, 2015\",\"October 10, 2015\",\"YSON\",\"4\",\"career, cool\"\nthng-query,\"February 5, 2018\",\"February 30, 2018\",\"Thng Query\",\"5\",\"career, cool\"\ntohu,\"April 1, 2018\",\"April 20, 2018\",\"Tohu\",\"5\",\"career, cool\"\nbip,\"October 8, 2020\",\"July 12, 2024\",\"Business Intelligence Platform\",\"2\",\"career, project\"\nchapter-lead-2,\"August 26, 2021\",\"July 12, 2024\",\"Chapter Lead\",\"!3\",\"career,general\"\nharbor,\"July 28, 2024\",\"now\",\"Harbor\",\"2\",\"career, project, cool\"\nbip-alerts,\"January 1, 2021\",\"March 1, 2023\",\"Alerts System\",\"3\",\"career, project\"\nbip-alerts-email,\"February 1, 2021\",\"June 7, 2023\",\"Email Alerts\",\"4\",\"career, deliverable, cool\"\nbip-alerts-topics,\"December 1, 2022\",\"February 6, 2023\",\"Alert Topic Subscriptions\",\"!8\",\"career, deliverable\"\nbip-ntier,\"June 15, 2022\",\"September 5, 2022\",\"N-Tier Supply Chain Map\",\"3\",\"career, project, cool\"\nbip-portfomance,\"October 1, 2022\",\"December 6, 2022\",\"Portfomance\",\"!8\",\"career, deliverable, cool\"\nbip-risk-hub,\"March 21, 2022\",\"July 12, 2024\",\"Risk Hub\",\"3\",\"career, project\"\nbip-dashboards,\"July 15, 2021\",\"March 4, 2024\",\"Dashboards\",\"4\",\"career, project, cool\"\nbip-backend-tests,\"November 1, 2022\",\"December 6, 2022\",\"Backend Integration Tests\",\"5\",\"career, deliverable, cool\"\njitera,\"October 1, 2024\",\"January 24, 2026\",\"Jitera\",\"2\",\"career, project\"\njitera-boost,\"October 1, 2024\",\"January 24, 2026\",\"Jitera Boost\",\"3\",\"career, project, cool\"\njitera-context,\"June 12, 2025\",\"January 24, 2026\",\"Context / Tribal Knowledge\",\"4\",\"career, project, cool\"\njitera-erd,\"October 1, 2024\",\"November 1, 2024\",\"ERD Investigation\",\"4\",\"career, deliverable\"\njitera-desktop,\"November 7, 2025\",\"December 1, 2025\",\"Jitera Desktop App\",\"5\",\"career, deliverable, cool\"\njitera-long-running,\"August 18, 2025\",\"September 29, 2025\",\"Long-Running Agent Tasks\",\"4\",\"career, deliverable\"\n";


function $22958491098738c1$var$assignDepths(events) {
    const rowIntervals = [];
    const result = new Array(events.length).fill(0);
    const overlaps = (row, s, e)=>(rowIntervals[row] ?? []).some(([rs, re])=>s < re && e > rs);
    const addInterval = (row, s, e)=>{
        (rowIntervals[row] ??= []).push([
            s,
            e
        ]);
    };
    // Pinned items: placed at authored depth unconditionally.
    events.forEach((event, i)=>{
        if (!event.pinned) return;
        result[i] = event.depth;
        addInterval(event.depth, event.start.getTime(), event.end.getTime());
    });
    // Non-pinned items: greedy row packing, checking real interval overlap.
    const sorted = events.map((e, i)=>({
            ...e,
            i: i
        })).filter((e)=>!e.pinned).sort((a, b)=>a.start.getTime() - b.start.getTime());
    for (const event of sorted){
        const s = event.start.getTime();
        const e = event.end.getTime();
        let row = event.depth;
        while(overlaps(row, s, e))row++;
        result[event.i] = row;
        addInterval(row, s, e);
    }
    return result;
}
function $22958491098738c1$var$parseTimelineCsv(csv) {
    const rows = (0, $df5bef30413a053b$export$2dc6f8ad0f55f4d8)(csv).filter(([id])=>!id.startsWith("-"));
    const raw = rows.map(([id, start, end, name, depth, tagsList])=>{
        const depthStr = depth.trim();
        const pinned = depthStr.startsWith("!");
        return {
            id: id,
            start: (0, $df5bef30413a053b$export$6b862160d295c8e)(start),
            end: (0, $df5bef30413a053b$export$6b862160d295c8e)(end),
            name: name,
            pinned: pinned,
            depth: parseInt(pinned ? depthStr.slice(1) : depthStr),
            tags: tagsList.split(",").map((tag)=>tag.trim())
        };
    });
    const displayDepths = $22958491098738c1$var$assignDepths(raw);
    return raw.map((event, i)=>new (0, $cfc6059e7597f0db$export$2e2bcd8739ae039)({
            id: event.id,
            start: event.start,
            end: event.end,
            name: event.name,
            color: (0, (/*@__PURE__*/$parcel$interopDefault($3662ed097e2b5ad0$exports))).average(event.tags.map((tag)=>(0, $9b96906b1a4ddc1c$export$3af2a3e7710b9882)[tag])).css(),
            depth: displayDepths[i],
            tags: event.tags
        }));
}
var $22958491098738c1$export$2e2bcd8739ae039 = $22958491098738c1$var$parseTimelineCsv((0, (/*@__PURE__*/$parcel$interopDefault($5025a58a5323b280$exports))));
const $22958491098738c1$export$8b7a896ae75accbf = Object.keys((0, $9b96906b1a4ddc1c$export$3af2a3e7710b9882));



var $2YFJl = parcelRequire("2YFJl");
class $36efd4f347162bb2$export$2e2bcd8739ae039 {
    constructor(config){
        this.selected = null;
        this.config = config;
        // Render given pills to the DOM and assign
        this.pills = $2YFJl.select(this.config.container).selectAll(".pill.tag").data(this.config.pills).enter().append("div").on("click", (e, pill)=>{
            this.toggle(pill);
        }).attr("class", "pill tag");
        // Postprocess the pills, adding ability for
        // an outside
        if (config.content) config.content(this.pills);
        else this.pills.text((d)=>d);
    }
    /**
   * Toggles given pill selection.
   *
   * @param pill - one of the ids passed in the {SelectablePillsConfig}
   */ toggle(pill) {
        if (this.selected === pill) this.selected = null;
        else this.selected = pill;
        const otherPills = this.pills.filter((otherPill)=>otherPill !== pill);
        const targetPill = this.pills.filter((otherPill)=>otherPill === pill);
        otherPills.classed("selected", false);
        targetPill.classed("selected", !targetPill.classed("selected"));
        this.config.onChange(this.selected);
    }
}



var $2YFJl = parcelRequire("2YFJl");
class $987d104ff30b12c0$export$2e2bcd8739ae039 {
    /**
   * Adds the component to the scene, making
   * it renderable as soon as scene renders.
   *
   * @param component - instance to add to the scene
   */ add(component) {
        this.components.push(component);
    }
    /**
   * For a given context, renders all the
   * stored drawable components to the canvas
   *
   * @param ctx - context to render to
   */ draw(ctx) {
        this.components.forEach((component)=>{
            component.draw(ctx);
        });
    }
    constructor(){
        this.components = [];
    }
}




class $d47536d498e7040b$export$2e2bcd8739ae039 {
    static{
        /**
   * Size of the cursor area when hidden.
   */ this.hiddenSize = 0;
    }
    static{
        /**
   * Size of the cursor area when visible.
   */ this.visibleSize = 35;
    }
    static{
        /**
   * Cursor fill style when rendered.
   */ this.fillStyle = (0, $df5bef30413a053b$export$8b4981022bd80a4e)("--color-canvas-cursor") || "rgba(0, 0, 0, .05)";
    }
    /**
   * Sets the cursor target position to a given offset.
   *
   * @param position - desired cursor position
   */ moveTo(position) {
        this.position.setValue(position);
        this.size.setValue($d47536d498e7040b$export$2e2bcd8739ae039.visibleSize);
    }
    /**
   * Hides the cursor by gradually decreasing its
   * size to 0.
   */ hide() {
        this.size.setValue($d47536d498e7040b$export$2e2bcd8739ae039.hiddenSize);
    }
    /**
   * Performs the hit testing of actual cursor
   * position (not interpolated) and the given rect.
   *
   * @param rect - rectangle to hit test
   */ isOver(rect) {
        const position = this.position.target;
        return (0, $df5bef30413a053b$export$a4d69fb5f2026c35)(position[0], rect[0], rect[1]) && (0, $df5bef30413a053b$export$a4d69fb5f2026c35)(position[1], rect[2], rect[3]);
    }
    /**
   * Renders the cursor to given canvas context.
   *
   * @param ctx - context for rendering
   */ draw(ctx) {
        // Update interpolated values
        this.size.tick();
        this.position.tick();
        // Position where cursor will be rendered.
        const [x, y] = this.position.value;
        ctx.beginPath();
        ctx.fillStyle = $d47536d498e7040b$export$2e2bcd8739ae039.fillStyle;
        ctx.moveTo(x, y);
        ctx.arc(x, y, this.size.value, 0, (0, $df5bef30413a053b$export$f4644083ce95e7e3));
        ctx.fill();
        ctx.closePath();
    }
    constructor(){
        /**
   * Holds the interpolated cursor position, which tries to reach
   * preset target value.
   */ this.position = new (0, $745f816836c85b06$export$2e2bcd8739ae039)([
            0,
            0
        ]);
        /**
   * Holds the interpolated cursor size, which tries to reach
   * preset target value.
   */ this.size = new (0, $745f816836c85b06$export$2e2bcd8739ae039)(0);
        /**
   * Defines if the cursor currently active
   * and performs hit-testing in the next frame.
   */ this.isDown = false;
    }
}




var $2YFJl = parcelRequire("2YFJl");
class $b176ac46e520dd04$export$2e2bcd8739ae039 {
    /**
   * Recalculates current transform
   * towards the target transform, by interpolating
   * the scale, and translations.
   */ tick() {
        const targetZoom = [
            this.targetTransform.x,
            this.targetTransform.y,
            this.targetTransform.k
        ];
        const currentZoom = [
            this.currentTransform.x,
            this.currentTransform.y,
            this.currentTransform.k
        ];
        const interpolatedZoom = $2YFJl.interpolate(currentZoom, targetZoom)(this.elasticity);
        this.currentTransform = $2YFJl.zoomIdentity.translate(interpolatedZoom[0], interpolatedZoom[1]).scale(interpolatedZoom[2]);
    }
    /**
   * Applies the transform to given canvas context.
   *
   * @param ctx - canvas context
   */ transformCtx(ctx) {
        ctx.setTransform(new DOMMatrix().scale(this.currentTransform.k).translate(this.currentTransform.x, this.currentTransform.y, 0));
    }
    constructor(){
        /**
   * Holds the current transform which should be used
   * for all the dependent computations to be smooth
   */ this.currentTransform = $2YFJl.zoomIdentity;
        /**
   * Holds the target transform which the component
   * will advance towards on each tick.
   */ this.targetTransform = $2YFJl.zoomIdentity;
        /**
   * Elasticity of the transform.
   * 0 - won't move towards target at all
   * 1 - will rigidly stick to the target
   */ this.elasticity = 0.2;
    }
}


class $aeade6fdfde40453$export$49c612ea8911158d {
    static{
        this.idDetector = [
            [
                $aeade6fdfde40453$export$49c612ea8911158d.isMouseEvent,
                ()=>"mouse"
            ],
            [
                $aeade6fdfde40453$export$49c612ea8911158d.isPointerEvent,
                (event)=>`pointer:${event.pointerId}`
            ],
            [
                $aeade6fdfde40453$export$49c612ea8911158d.isTouchEvent,
                (event)=>`touch:${event.changedTouches[0].identifier}`
            ]
        ];
    }
    static{
        /**
   * Detects and returns a position of a
   */ this.positionDetector = [
            [
                $aeade6fdfde40453$export$49c612ea8911158d.isMouseEvent,
                (event)=>[
                        event.layerX,
                        event.layerY
                    ]
            ],
            [
                $aeade6fdfde40453$export$49c612ea8911158d.isPointerEvent,
                (event)=>[
                        event.layerX,
                        event.layerY
                    ]
            ],
            [
                $aeade6fdfde40453$export$49c612ea8911158d.isTouchEvent,
                (event)=>[
                        event.changedTouches[0].clientX,
                        event.changedTouches[0].clientY
                    ]
            ]
        ];
    }
    /**
   * Returns true if given event is sourced from mouse
   * @param e - event to process
   */ static isMouseEvent(e) {
        return e.type.includes("mouse");
    }
    /**
   * Returns true if given event is sourced from pointer interface
   * @param e - event to process
   */ static isPointerEvent(e) {
        return e.type.includes("pointer");
    }
    /**
   * Returns true if given event is sourced from touch device
   * @param e - event to process
   */ static isTouchEvent(e) {
        return e.type.includes("touch");
    }
    /**
   * Determines a unique id of incoming pointer event,
   * regardless of event source and type.
   *
   * @param event - event to track
   */ static getEventId(event) {
        for (const [detector, assigner] of $aeade6fdfde40453$export$49c612ea8911158d.idDetector){
            if (detector(event)) return assigner(event);
        }
        return "unknown";
    }
    static getEventPosition(event) {
        for (const [tester, assigner] of $aeade6fdfde40453$export$49c612ea8911158d.positionDetector){
            if (tester(event)) return assigner(event);
        }
    }
    constructor(position){
        /**
   * Current X position
   */ this.x = 0;
        /**
   * Current Y position
   */ this.y = 0;
        /**
   * Horizontal displacement from the
   * initial recorded position
   */ this.dx = 0;
        /**
   * Horizontal displacement from the
   * initial recorded position
   */ this.dy = 0;
        /**
   * Count of events recorded with this tracker
   */ this.tracked = 0;
        this.x = position[0];
        this.y = position[1];
    }
    /**
   * Records the given position of pointer
   * and detects the global offset relative to the initial
   * capturing point.
   *
   * @param position - new recorded position
   */ track(position) {
        this.dx += position[0] - this.x;
        this.dy += position[1] - this.y;
        this.x = position[0];
        this.y = position[1];
        this.tracked++;
    }
    /**
   * Returns true if this pointer moves
   * vertically more than horizontally
   */ get isVertical() {
        return Math.abs(this.dy) > Math.abs(this.dx);
    }
}
class $aeade6fdfde40453$export$2e2bcd8739ae039 {
    constructor(){
        /**
   * Flags if the tracker detected a scrolling attempt
   * by capturing a pointer with vertical movement.
   */ this.isScrolling = false;
        /**
   * Holds references to the captured pointers.
   */ this.pointers = new Map();
        this.attach = this.attach.bind(this);
    }
    /**
   * Attaches this tracker to a given d3 selection,
   * starts listening and recording events and attempts to detect
   * vertical drags, considering them as a scrolling state.
   *
   * @param selection - d3 selection to bind events to
   */ attach(selection) {
        // Listeners have reassigned scope,
        // so capturing it in a closure.
        let scope = this;
        selection.on("pointerdown mousedown touchstart", (e)=>{
            // Start tracking given pointer
            scope.pointers.set($aeade6fdfde40453$export$49c612ea8911158d.getEventId(e), new $aeade6fdfde40453$export$49c612ea8911158d($aeade6fdfde40453$export$49c612ea8911158d.getEventPosition(e)));
        }).on("pointermove mousemove touchmove", (e)=>{
            const pointer = scope.pointers.get($aeade6fdfde40453$export$49c612ea8911158d.getEventId(e));
            if (pointer) {
                // If we're aware of this pointer, track it
                pointer.track($aeade6fdfde40453$export$49c612ea8911158d.getEventPosition(e));
                if (pointer.isVertical && pointer.tracked > 5) {
                    scope.isScrolling = true;
                    // Prevents the event from
                    // bubbling over to parent element
                    e.stopPropagation();
                } else if (pointer.tracked > 5) scope.isScrolling = false;
            }
        }).on("pointerup mouseup touchend", (e)=>{
            // Release the pointer
            scope.pointers.delete($aeade6fdfde40453$export$49c612ea8911158d.getEventId(e));
            // Releasing last pointer would mean
            // we definitely not in a scrolling state anymore
            if (scope.pointers.size === 0) this.isScrolling = false;
        });
    }
}





class $7f01728bb8600805$export$2e2bcd8739ae039 {
    static{
        /**
   * Defines how to render event names.
   */ this.fontConfig = {
            font: '12px "Plus Jakarta Sans"',
            fill: (0, $df5bef30413a053b$export$8b4981022bd80a4e)("--color-tick-label") || "rgba(0, 0, 0, .1)"
        };
    }
    static{
        /**
   * Line stroke style
   */ this.strokeStyle = (0, $df5bef30413a053b$export$8b4981022bd80a4e)("--color-tick-stroke") || "rgba(0, 0, 0, .1)";
    }
    static{
        /**
   * Width of the line stroke
   */ this.lineWidth = 2;
    }
    static{
        /**
   * Height of the tick, year will be
   * rendered on top of this height.
   */ this.height = 8;
    }
    /**
   * Convenience helper to construct a Tick from
   * a given date
   *
   * @param date - date to use for the tick
   */ static fromDate(date) {
        return new $7f01728bb8600805$export$2e2bcd8739ae039(date);
    }
    constructor(date){
        /**
   * Represents tick X position in a unit viewport
   */ this.x = 0;
        /**
   * Represents tick Y position in a unit viewport
   */ this.y = 0;
        this.date = date;
    }
    /**
   * Renders this component to the given canbas context
   *
   * @param ctx - canvas context to use for render
   */ draw(ctx) {
        ctx.strokeStyle = $7f01728bb8600805$export$2e2bcd8739ae039.strokeStyle;
        ctx.lineWidth = $7f01728bb8600805$export$2e2bcd8739ae039.lineWidth;
        const x = this.transform.currentTransform.applyX(this.x);
        const y = this.y;
        ctx.beginPath();
        ctx.moveTo(x, y);
        ctx.lineTo(x, y - $7f01728bb8600805$export$2e2bcd8739ae039.height);
        ctx.closePath();
        ctx.stroke();
        ctx.fillStyle = $7f01728bb8600805$export$2e2bcd8739ae039.fontConfig.fill;
        ctx.font = $7f01728bb8600805$export$2e2bcd8739ae039.fontConfig.font;
        ctx.fillText(this.date.getFullYear().toString(), x - 15, y - $7f01728bb8600805$export$2e2bcd8739ae039.height - 5);
    }
    /**
   * Applies given time scale to the component,
   * helping to determine correct viewport position.
   *
   * @param scale - d3 scale representing the viewport
   */ applyScale(scale) {
        this.x = scale(this.date);
    }
}


class $9afee88ad2491711$export$27c7467594ef87bd {
    /**
   * Builds yearly ticks for a given date range
   *
   * @param range - date range to build ticks from
   */ static forRange(range) {
        const [start, end] = range;
        const startYear = start.getFullYear();
        const endYear = end.getFullYear();
        const ticks = Array(endYear - startYear + 1).fill(0).map((_, i)=>{
            return new Date(startYear + i, 1, 1);
        }).map((0, $7f01728bb8600805$export$2e2bcd8739ae039).fromDate);
        return new $9afee88ad2491711$export$27c7467594ef87bd(ticks);
    }
    constructor(ticks){
        this.ticks = ticks;
    }
    /**
   * Applies given scale to the component and all
   * its children to determine the viewport coordinates.
   *
   * @param scale
   */ scale(scale) {
        this.width = scale.range()[1];
        for (const tick of this.ticks)tick.applyScale(scale);
        return this;
    }
    /**
   * Applies given transform to the component and
   * all its children
   *
   * @param transform - transform to apply
   */ applyTransform(transform) {
        this.transform = transform;
        for (const tick of this.ticks)tick.transform = transform;
        return this;
    }
    /**
   * Applies the baseline for ticks to be rendered at.
   *
   * @param baseline - bottom line to render updwards from
   */ baseline(baseline) {
        for (const tick of this.ticks)tick.y = baseline;
        return this;
    }
    /**
   * Renders ticks on a given canvas context.
   *
   * @param ctx - canvas context to render on
   */ draw(ctx) {
        const skipFactor = this.getSkipFactor();
        this.ticks.forEach((tick, i)=>{
            if (i % skipFactor === 0) tick.draw(ctx);
        });
    }
    /**
   * Determines how many ticks need to be skipped to keep
   * them from clashing with each other,
   * depending on a current transform and viewport.
   */ getSkipFactor() {
        const currentTransform = this.transform.currentTransform;
        const domain = [
            currentTransform.invertX(0),
            currentTransform.invertX(this.width)
        ];
        const currentTicks = this.ticks.filter((tick)=>(0, $df5bef30413a053b$export$a4d69fb5f2026c35)(tick.x, domain[0], domain[1])).length;
        const possibleTicks = this.width / 32;
        return Math.ceil(currentTicks / possibleTicks);
    }
}


class $df3aa4ae4883b80e$export$2e2bcd8739ae039 {
    static{
        /**
   * Desired visualisation height,
   * kept static for simplicity.
   */ this.height = 500;
    }
    static{
        /**
   * Desired scale extent, minimal
   * and maximum levels of zoom allowed.
   */ this.scaleExtent = [
            1,
            100
        ];
    }
    constructor(config){
        /**
   * Flags whether rendering cycle is paused or running.
   */ this.paused = true;
        /**
   * Width of the available viewport in logical pixels.
   */ this.width = 0;
        /**
   * Height of the available viewport in logical pixels.
   */ this.height = 500;
        this.config = config;
        this.scene = new (0, $987d104ff30b12c0$export$2e2bcd8739ae039)();
        this.cursor = new (0, $d47536d498e7040b$export$2e2bcd8739ae039)();
        this.smoothTransform = new (0, $b176ac46e520dd04$export$2e2bcd8739ae039)();
        this.tracker = new (0, $aeade6fdfde40453$export$2e2bcd8739ae039)();
    }
    /**
   * Initialises all the components required
   * for the visualisation to run.
   */ start() {
        this.container = $2YFJl.select(this.config.container);
        this.width = this.config.container.getBoundingClientRect().width;
        this.height = (Math.max(...this.config.events.map((e)=>e.config.depth)) + 1) * (0, $cfc6059e7597f0db$export$2e2bcd8739ae039).lineHeight;
        const domain = [
            this.firstEvent.config.start,
            new Date()
        ];
        // Range from the earliest event till now
        // mapped to the visualisation viewport.
        this.timeScale = $2YFJl.scaleTime().domain(domain).range([
            0,
            this.width
        ]);
        this.zoom = $2YFJl.zoom().scaleExtent($df3aa4ae4883b80e$export$2e2bcd8739ae039.scaleExtent).translateExtent(this.translateExtent).on("zoom", this.onZoom.bind(this));
        // Adding events to the scene
        this.config.events.forEach((event)=>{
            event.applyScale(this.timeScale);
            event.transform = this.smoothTransform;
            this.scene.add(event);
        });
        // Generate date scale ticks
        this.ticks = (0, $9afee88ad2491711$export$27c7467594ef87bd).forRange(domain).scale(this.timeScale).applyTransform(this.smoothTransform).baseline(this.height);
        this.scene.add(this.ticks);
        this.canvas = $2YFJl.select(this.config.container).append("canvas").lower().attr("width", this.width * this.dpr).attr("height", this.height * this.dpr).style("width", `${this.width}px`).style("height", `${this.height}px`);
        this.container.on("pointermove", (e)=>{
            this.cursor.moveTo([
                e.layerX,
                e.layerY
            ]);
        }).on("click", (e)=>{
            this.cursor.moveTo([
                e.layerX,
                e.layerY
            ]);
            this.cursor.isDown = true;
        }).on("mouseout touchend", ()=>{
            this.cursor.hide();
        }).call(this.zoom).style("touch-action", "auto").style("height", `${this.height}px`).select(".scroller").call(this.tracker.attach);
        this.ctx = this.canvas.node().getContext("2d");
        this.ctx.scale(this.dpr, this.dpr);
        this.scene.add(this.cursor);
        this.draw();
        // Pause the visualistaion when off-screen.
        (0, $df5bef30413a053b$export$62b74373436a24c)(this.container.node(), this.onVisibilityChanged.bind(this));
        window.addEventListener("resize", (0, $df5bef30413a053b$export$de363e709c412c8a)(this.onResize.bind(this), 500));
    }
    /**
   * Renders current state of the visualisation to the canvas.
   */ draw() {
        if (!this.paused) {
            this.smoothTransform.tick();
            this.clear();
            this.scene.draw(this.ctx);
            this.processInteractions();
        }
        window.requestAnimationFrame(this.draw.bind(this));
    }
    /**
   * Clears the canvas by rendering the clear rect.
   */ clear() {
        this.ctx.clearRect(0, 0, this.width, this.height);
    }
    /**
   * Performs hit testing of the events
   * and currently captured cursor position.
   */ processInteractions() {
        for (const event of this.config.events){
            const isHovered = this.cursor.isOver(event.boundingRect);
            const isTriggered = isHovered && this.cursor.isDown;
            if (isTriggered) {
                this.onEventTriggered(event);
                break;
            }
        }
        // Reset cursor regardless its current status
        // to avoid triggering events the next frame.
        this.cursor.isDown = false;
    }
    /**
   * Highlights event nodes with given tag,
   * by 'muting' the rest of the events.
   *
   * @param tag - Tag to highlight.
   */ highlight(tag) {
        for (const event of this.config.events){
            const hasTag = event.config.tags.includes(tag) || tag === null;
            // Initial/mute based on the selection
            const color = hasTag ? event.config.color : (0, $df5bef30413a053b$export$8b4981022bd80a4e)("--color-timeline-muted") || "rgba(0, 0, 0, .05)";
            event.color.setValue(color);
        }
    }
    /**
   * Handles {this.zoom} events by propagating
   * desired new transform to the interpolated transform container.
   */ onZoom(e) {
        this.smoothTransform.targetTransform = e.transform;
    }
    /**
   * Performs a zoom in to the boundaries of a gieven event.
   *
   * @param event - one of the events passed to visualisation.
   */ zoomIn(event) {
        // The scale of event in the unit coordinate system.
        const scale = (event.endX - event.startX) / this.width;
        this.container.call(this.zoom.transform, // Applying translate in the unit coords and then reversed scale
        // for an event to take the whole viewport.
        $2YFJl.zoomIdentity.scale(1 / scale).translate(-event.startX, 0));
    }
    /**
   * Handles visualisation visibility change
   * by pausing/unpausing when necessary.
   *
   * @param isVisible - whether the visualisation is currently visible on screen.
   */ onVisibilityChanged(isVisible) {
        this.paused = !isVisible;
    }
    /**
   * Handles trigger of the given event
   * by opening a modal with event contents and
   * pausing the render cycle whilst it's open.
   *
   * @param event - event which was triggered.
   */ onEventTriggered(event) {
        this.paused = true;
        (0, $df5bef30413a053b$export$d7e8d4d4450c819c)(event.config.id, {
            onClose: ()=>this.paused = false
        });
    }
    onResize() {
        this.width = this.config.container.getBoundingClientRect().width;
        this.canvas.attr("width", this.width * this.dpr).attr("height", this.height * this.dpr).style("width", `${this.width}px`).style("height", `${this.height}px`);
        this.ctx.scale(this.dpr, this.dpr);
        this.zoom.translateExtent(this.translateExtent);
        this.timeScale.range([
            0,
            this.width
        ]);
        this.ticks.scale(this.timeScale).baseline(this.height);
        this.config.events.forEach((event)=>event.applyScale(this.timeScale));
        this.container.call(this.zoom.transform, $2YFJl.zoomIdentity);
    }
    /**
   * Returns the first event to be rendered.
   * Used as the chronological boundary for the time scale.
   */ get firstEvent() {
        return this.config.events[0];
    }
    /**
   * Current device pixel ratio,
   * to be used for determining the proper Canvas scaling factor.
   */ get dpr() {
        return window.devicePixelRatio || 1;
    }
    /**
   * Current viewport size.
   */ get viewport() {
        return [
            this.width,
            this.height
        ];
    }
    /**
   * Returns current possible translation
   * boundaries as allowed by current viewport dimensions.
   */ get translateExtent() {
        return [
            [
                0,
                0
            ],
            this.viewport
        ];
    }
}



var $2YFJl = parcelRequire("2YFJl");

class $8b32f89f093a8bae$export$2e2bcd8739ae039 {
    static{
        /**
   * Locators for the DOM nodes of the component
   */ this.selectors = {
            modalTitle: ".modal-title",
            modalContent: ".modal-content",
            timelineEvent: ".timeline-event"
        };
    }
    constructor(config){
        /**
   * Flags that this component was initialised and
   * ready for use.
   */ this.ready = false;
        this.config = config;
    }
    /**
   * Intialises the component and renders
   * all the necessary elements to the DOM.
   */ init() {
        const { container: container, events: events } = this.config;
        const ids = events.map((e)=>e.config.id);
        const content = new Map();
        for (const id of ids){
            const template = (0, $df5bef30413a053b$export$836aee6bce45247)(`#modal-${id}-template`).content;
            content.set(id, {
                header: template.querySelector($8b32f89f093a8bae$export$2e2bcd8739ae039.selectors.modalTitle).cloneNode(true),
                content: template.querySelector($8b32f89f093a8bae$export$2e2bcd8739ae039.selectors.modalContent).cloneNode(true)
            });
        }
        this.list = $2YFJl.select(container).selectAll($8b32f89f093a8bae$export$2e2bcd8739ae039.selectors.timelineEvent).data(events.sort((a, b)=>a.config.start.valueOf() - b.config.start.valueOf())).enter().append("div").attr("class", "timeline-event collapsed").style("border-left", (d)=>{
            return `0.5rem solid ${d.config.color}`;
        });
        const header = this.list.append((d)=>content.get(d.config.id).header).on("click", (e, d)=>{
            const node = this.list.filter((item)=>item.config.id === d.config.id).node();
            const currentHeight = node.getBoundingClientRect().height;
            node.style.height = "auto";
            node.classList.add("no-transition");
            node.classList.toggle("collapsed");
            const newHeight = node.getBoundingClientRect().height;
            node.style.height = `${currentHeight}px`;
            node.classList.remove("no-transition");
            requestAnimationFrame(()=>{
                node.style.height = `${newHeight}px`;
            });
        });
        header.append("span").attr("class", "event-dates").text((d)=>`(${(0, $df5bef30413a053b$export$2e9241a0bdf6c8b8)(d.config.start, d.config.end)})`);
        header.append("div").attr("class", "chevron").text("<");
        this.list.append((d)=>content.get(d.config.id).content);
        // Ensure that new content in DOM
        // is properly initialized
        (0, $df5bef30413a053b$export$a7a64595f9a52d4)();
        // Done and done.
        this.ready = true;
    }
    /**
   * Toggles given list item closed state.
   *
   * @param d - D3 Selection Datum
   */ toggleItem(d) {
        const node = this.list.filter((item)=>item.config.id === d.config.id).node();
        // Otain elements current height, to start transition
        const currentHeight = node.getBoundingClientRect().height;
        node.style.height = "auto";
        node.classList.add("no-transition");
        node.classList.toggle("collapsed");
        // Prepare element for accepting new height
        const newHeight = node.getBoundingClientRect().height;
        node.style.height = `${currentHeight}px`;
        node.classList.remove("no-transition");
        // Will not work without rAF
        requestAnimationFrame(()=>{
            // Kick off the transition
            node.style.height = `${newHeight}px`;
        });
    }
    highlight(type) {
        this.list.classed("hidden", (d)=>type === null ? false : !d.config.tags.includes(type));
    }
}





class $87368a4797cae261$export$9086365ce732c74c {
    constructor(config){
        this.elements = {};
        this.config = config;
        this.container = (0, $df5bef30413a053b$export$836aee6bce45247)(config.container);
        for(const key in config.elements)this.elements[key] = this.qs(config.elements[key]);
    }
    qs(selector) {
        return this.container.querySelector(selector);
    }
    actions(actions) {
        for (const [selector, listener] of Object.entries(actions))this.qs(selector).addEventListener("click", listener);
    }
}


class $a1a98d7d3aaecbf6$export$2e2bcd8739ae039 extends (0, $87368a4797cae261$export$9086365ce732c74c) {
    static{
        this.config = {
            container: "section.career",
            elements: {
                timeline: ".canvas-container",
                zoomCareer: ".zoom-pill.career",
                zoomLife: ".zoom-pill.life",
                listView: ".list-pill",
                timelineContainer: ".timeline-container",
                listContainer: ".list-container",
                pills: ".pills",
                lifePill: ".pill.life",
                careerPill: ".pill.career",
                listPill: ".list-pill",
                timelinePill: ".timeline-pill"
            }
        };
    }
    constructor(){
        super($a1a98d7d3aaecbf6$export$2e2bcd8739ae039.config);
        this.timeline = new (0, $df3aa4ae4883b80e$export$2e2bcd8739ae039)({
            container: this.elements.timeline,
            events: $22958491098738c1$export$2e2bcd8739ae039
        });
        this.list = new (0, $8b32f89f093a8bae$export$2e2bcd8739ae039)({
            container: this.elements.listContainer,
            events: $22958491098738c1$export$2e2bcd8739ae039
        });
        this.pills = new (0, $36efd4f347162bb2$export$2e2bcd8739ae039)({
            container: this.elements.pills,
            pills: (0, $22958491098738c1$export$8b7a896ae75accbf),
            onChange: this.onPillsChanged.bind(this)
        });
    }
    /**
   * Kicks off the visualisation and connects
   * controls with the viewport.
   */ init() {
        this.timeline.start();
        const careerEvent = (0, $22958491098738c1$export$2e2bcd8739ae039).find((e)=>e.config.id === "career");
        const lifeEvent = (0, $22958491098738c1$export$2e2bcd8739ae039).find((e)=>e.config.id === "life");
        this.actions({
            [$a1a98d7d3aaecbf6$export$2e2bcd8739ae039.config.elements.careerPill]: ()=>{
                this.timeline.zoomIn(careerEvent);
            },
            [$a1a98d7d3aaecbf6$export$2e2bcd8739ae039.config.elements.lifePill]: ()=>{
                this.timeline.zoomIn(lifeEvent);
            },
            [$a1a98d7d3aaecbf6$export$2e2bcd8739ae039.config.elements.listPill]: ()=>{
                this.showList();
            },
            [$a1a98d7d3aaecbf6$export$2e2bcd8739ae039.config.elements.timelinePill]: ()=>{
                this.showTimeline();
            }
        });
        this.showTimeline();
        this.timeline.zoomIn(careerEvent);
        this.processQueryParams();
    }
    /**
   * Brings the timeline container to the view
   */ showTimeline() {
        (0, $df5bef30413a053b$export$f0e9d14ede4c01bd)([
            this.elements.listContainer,
            this.elements.timelinePill
        ], false);
        (0, $df5bef30413a053b$export$f0e9d14ede4c01bd)([
            this.elements.timelineContainer,
            this.elements.listPill,
            this.elements.lifePill,
            this.elements.careerPill
        ], true);
        this.timeline.onResize();
    }
    /**
   * Brings the list container to the view,
   * initializes the list lazily, if needed
   */ showList() {
        if (!this.list.ready) this.list.init();
        (0, $df5bef30413a053b$export$f0e9d14ede4c01bd)([
            this.elements.listContainer,
            this.elements.timelinePill
        ], true);
        (0, $df5bef30413a053b$export$f0e9d14ede4c01bd)([
            this.elements.timelineContainer,
            this.elements.listPill,
            this.elements.lifePill,
            this.elements.careerPill
        ], false);
        this.pills.toggle((0, $9b96906b1a4ddc1c$export$3830f593b4946569).career);
    }
    /**
   * Detects if the page was opened with the
   * intention to visit a particular content modal
   */ processQueryParams() {
        const qs = new URLSearchParams(window.location.search);
        if (qs.has("modal")) (0, $df5bef30413a053b$export$d7e8d4d4450c819c)(qs.get("modal"));
    }
    /**
   * Handles the change of selected event
   * group from the control palette
   */ onPillsChanged(selected) {
        this.timeline.highlight(selected);
        this.list.highlight(selected);
    }
}



var $2YFJl = parcelRequire("2YFJl");
var $e373d49e19ab6b58$exports = {};
$e373d49e19ab6b58$exports = "type, name, level, interest, importance,\nlang, JavaScript, 0.95, 0.95, 1,\nlang, TypeScript, 1.0, 0.98, 1,\nlang, Dart, 0.7, 0.63, 0.8,\nlang, Rust, 0.05, 0.74, 0.4,\nlang, Java, 0.1, 0.15, 0.3,\nlang, Python, 0.65, 0.9, 0.9,\nlang, SCSS, 0.75, 0.55, 0.3,\nlang, CSS, 0.9, 0.7, 0.6,\nlang, HTML, 0.8, 0.4, 0.6,\nlang, Pug, 0.8, 0.82, 0.2,\nlang, Bash, 0.6, 0.75, 0.8,\nlang, GLSL, 0.05, 0.8, 0.2,\nlang, SQL, 0.87, 0.8, 0.8,\nlang, Lisp, 0.4, 0.65, 0.2,\nlang, GraphQL, 0.9, 0.85, 0.9,\nlang, Less, 0.63, 0.21, 0.1,\nlang, Markdown, 0.9, 0.75, 0.1,\nlang, PlantUML, 0.8, 0.54, 0.56,\nlang, Mermaid, 0.8, 0.6, 0.62,\nruntime, Node.js, 0.92, 0.96, 1,\nruntime, Bun, 0.52, 0.75, 0.2,\nruntime, Deno, 0.45, 0.7, 0.2,\nruntime, Duktape, 0.15, 0.58, 0.3,\nframework, AngularJS, 0.9, 0.2, 0.3,\nframework, Angular, 0.14, 0.28, 0.3,\nframework, Ext JS, 0.4, 0.1, 0.3,\nframework, Bootstrap, 0.7, 0.3, 0.7,\nframework, Tailwind, 0.75, 0.8, 0.5,\nframework, MUI, 0.65, 0.7, 0.5,\nframework, Mantine, 0.3, 0.7, 0.5,\nframework, Flutter, 0.63, 0.82, 0.6,\nframework, Next.js, 0.8, 0.68, 0.8,\nframework, Express, 0.8, 0.5, 0.8,\nframework, micro, 0.65, 0.52, 0.2,\nframework, Electron, 0.17, 0.6, 0.3,\nframework, NW.js, 0.22, 0.6, 0.3,\nframework, Serverless, 0.14, 0.32, 0.1,\nframework, Svelte, 0.1, 0.75, 0.1,\nframework, Jest, 0.75, 0.71, 0.2,\nframework, Leaflet, 0.43, 0.64, 0.2,\nframework, PostCSS, 0.23, 0.4, 0.1,\nframework, Polymer, 0.55, 0.38, 0.2,\nframework, Mocha, 0.8, 0.23, 0.2,\nframework, Karma, 0.61, 0.31, 0.1,\nframework, TestCafe, 0.7, 0.56, 0.1,\nframework, Apollo, 0.86, 0.65, 0.8,\nframework, PyTorch, 0.23, 0.8, 0.2,\nframework, react-admin, 0.94, 0.65, 0.2,\nlib, React, 0.98, 0.9, 1,\nlib, Hyperapp, 0.6, 0.4, 0.2,\nlib, d3, 0.9, 0.92, 0.8,\nlib, jQuery, 0.6, 0.05, 0.2,\nlib, Puppeteer, 0.82, 0.62, 0.4,\nlib, Playwright, 0.82, 0.67, 0.4,\nlib, Axios, 0.54, 0.6, 0.1,\nlib, Three.js, 0.22, 0.74, 0.1,\nlib, Redux, 0.3, 0.42, 0.1,\nlib, Impress.js, 0.6, 0.53, 0.1,\nlib, Storybook, 0.65, 0.57, 0.1,\nlib, Socket.io, 0.32, 0.63, 0.1,\nlib, Highcharts, 0.53, 0.43, 0.1,\nlib, ECharts, 0.54, 0.47, 0.1,\nlib, Lodash, 0.72, 0.33, 0.1,\nlib, Request, 0.5, 0.22, 0.1,\nlib, Formik, 0.38, 0.56, 0.1,\nlib, RxJS, 0.12, 0.71, 0.1,\nlib, Sequelize, 0.13, 0.41, 0.1,\nlib, Mongoose, 0.65, 0.24, 0.1,\nlib, Framer Motion, 0.7, 0.85, 0.2,\nlib, Styled Components, 0.73, 0.45, 0.2,\nlib, @graphql-tools, 0.8, 0.69, 0.2,\nlib, TypeORM, 0.9, 0.43, 0.2,\nlib, txtai, 0.38, 0.8, 0.2,\nlib, graphrag, 0.6, 0.8, 0.2,\nlib, k6, 0.84, 0.7, 0.7,\ntool, NPM, 0.82, 0.85, 0.2,\ntool, Yarn, 0.8, 0.63, 0.2,\ntool, Grunt, 0.82, 0.13, 0.2,\ntool, Gulp, 0.8, 0.10, 0.2,\ntool, Parcel, 0.8, 0.65, 0.4,\ntool, Webpack, 0.88, 0.66, 0.4,\ntool, Snowpack, 0.23, 0.28, 0.4,\ntool, Rome, 0.1, 0.24, 0.4,\ntool, SWC, 0.5, 0.72, 0.4,\ntool, Pulumi, 0.64, 0.97, 0.2,\ntool, Terraform, 0.68, 0.72, 0.2,\ntool, Docker, 0.97, 0.85, 0.7,\ntool, Gradle, 0.23, 0.13, 0.3,\ntool, Ant, 0.17, 0.1, 0.2,\ntool, Jenkins, 0.53, 0.27, 0.2,\ntool, Lerna, 0.14, 0.6, 0.1,\ntool, Hasura, 0.95, 0.92, 0.6,\ntool, danger, 0.7, 0.82, 0.2,\ntool, Retool, 0.56, 0.45, 0.2,\ncloud, AWS, 0.88, 0.82, 0.9,\ncloud, GCP, 0.44, 0.86, 0.9,\ncloud, Digital Ocean, 0.3, 0.45, 0.2,\ncloud, Heroku, 0.46, 0.45, 0.2,\ncloud, Vercel, 0.84, 0.84, 0.4,\ncloud, Render, 0.22, 0.48, 0.2,\ncloud, Fly.io, 0.44, 0.65, 0.2,\ndatabase, PostgreSQL, 1.0, 0.88, 0.9,\ndatabase, MongoDB, 0.42, 0.77, 0.6,\ndatabase, FaunaDB, 0.45, 0.67, 0.2,\ndatabase, Redis, 0.3, 0.55, 0.6,\ndatabase, ElasticSearch, 0.12, 0.43, 0.3,\ndatabase, DynamoDB, 0.12, 0.47, 0.3,\nframework,PyTorch,0.13,0.93,0.5,\n";



var $6830b58269461a9a$var$SkillType;
(function(SkillType) {
    SkillType["lang"] = "lang";
    SkillType["runtime"] = "runtime";
    SkillType["framework"] = "framework";
    SkillType["lib"] = "lib";
    SkillType["tool"] = "tool";
    SkillType["cloud"] = "cloud";
    SkillType["database"] = "database";
})($6830b58269461a9a$var$SkillType || ($6830b58269461a9a$var$SkillType = {}));
function $6830b58269461a9a$var$parseSkills(skillsCsv) {
    const skills = skillsCsv.split("\n").splice(1).map((line)=>{
        let [type, name, level, interest, importance] = line.split(",");
        return {
            name: name,
            level: parseFloat(level),
            interest: parseFloat(interest),
            importance: parseFloat(importance),
            type: type
        };
    });
    return skills;
}
const $6830b58269461a9a$var$skills = (0, $df5bef30413a053b$export$2dc6f8ad0f55f4d8)((0, (/*@__PURE__*/$parcel$interopDefault($e373d49e19ab6b58$exports)))).map(([type, name, level, interest, importance])=>{
    const parsedImportance = parseFloat(importance);
    const opacity = parsedImportance > 0.5 ? 1 : 0.2;
    return {
        name: name,
        level: parseFloat(level),
        interest: parseFloat(interest),
        importance: parseFloat(importance),
        type: type,
        opacity: opacity,
        targetOpacity: opacity
    };
});
var $6830b58269461a9a$export$2e2bcd8739ae039 = $6830b58269461a9a$var$skills;
const $6830b58269461a9a$export$6bae0025fd4c3b10 = Object.values($6830b58269461a9a$var$SkillType);





class $3f0bb8abbf50d958$export$2e2bcd8739ae039 extends (0, $87368a4797cae261$export$9086365ce732c74c) {
    static{
        this.config = {
            container: "section.skills",
            elements: {
                skillsMap: ".skills-container",
                pills: ".pills",
                mapPill: ".map-pill",
                listPill: ".list-pill"
            }
        };
    }
    constructor(){
        super($3f0bb8abbf50d958$export$2e2bcd8739ae039.config);
    }
    init() {
        this.updateViewport();
        this.color = $2YFJl.scaleOrdinal((0, $6830b58269461a9a$export$6bae0025fd4c3b10).map((type)=>(0, $df5bef30413a053b$export$8b4981022bd80a4e)(`--color-skill-${type}`) || $2YFJl.interpolateCool((0, $6830b58269461a9a$export$6bae0025fd4c3b10).indexOf(type) / (0, $6830b58269461a9a$export$6bae0025fd4c3b10).length)));
        this.x = $2YFJl.scaleLinear().domain([
            0,
            1
        ]).range([
            this.padding,
            this.width - this.padding
        ]);
        this.y = $2YFJl.scaleLinear().domain([
            0,
            1
        ]).range([
            this.height - this.padding,
            this.padding
        ]);
        this.z = $2YFJl.scaleLinear().domain([
            0,
            1
        ]).range([
            5,
            10
        ]);
        this.zoom = $2YFJl.zoom().scaleExtent([
            1,
            5
        ]).translateExtent([
            [
                0,
                0
            ],
            [
                this.width,
                this.height
            ]
        ]).on("zoom", (e)=>{
            this.mapContainer.attr("transform", e.transform.toString());
            this.skills.attr("transform", `scale(${1 / e.transform.k})`);
        });
        this.svg = $2YFJl.select(this.elements.skillsMap).append("svg").attr("viewBox", [
            0,
            0,
            this.width,
            this.height
        ].join(", ")).attr("width", this.width).attr("height", this.height).call(this.zoom);
        this.mapContainer = this.svg.append("g");
        this.skills = this.mapContainer.append("g").selectAll(".skill-node").data((0, $6830b58269461a9a$export$2e2bcd8739ae039)).enter().append("g").attr("class", "skill-node").attr("transform", (d)=>{
            return `translate(${this.x(d.interest)}, ${this.y(d.level) + this.z(d.importance) + 2})`;
        }).append("g").attr("class", "skill-scaler").style("opacity", (d)=>d.opacity);
        this.skills.append("g").attr("transform", (d)=>`translate(0, ${this.z(d.importance) + 4})`).append("text").attr("class", "skill-name").attr("text-anchor", "middle").attr("alignment-baseline", "hanging").style("pointer-events", "none").text((d)=>d.name);
        this.skills.append("circle").on("mouseover", (e, d)=>{
            this.skills.filter((skill)=>skill.name !== d.name).style("opacity", 0.1);
            this.skills.filter((skill)=>skill.name === d.name).style("opacity", 1.0).raise();
        }).on("mouseout", (e, d)=>{
            this.skills.style("opacity", (d)=>d.targetOpacity);
        }).attr("data-type", (d)=>d.type).style("fill", (d)=>this.color(d.type)).transition().duration(600).delay((_, i)=>i * 10).attr("r", (d)=>this.z(d.importance));
        this.pills = new (0, $36efd4f347162bb2$export$2e2bcd8739ae039)({
            container: this.elements.pills,
            pills: (0, $6830b58269461a9a$export$6bae0025fd4c3b10),
            onChange: (type)=>{
                if (type) this.skills.style("opacity", (d)=>{
                    d.targetOpacity = d.type === type ? 1.0 : 0.1;
                    return d.targetOpacity;
                });
                else this.skills.style("opacity", (d)=>{
                    d.targetOpacity = d.opacity;
                    return d.targetOpacity;
                });
            },
            content: (pills)=>{
                pills.append("div").attr("class", "color").attr("style", (d)=>`background: ${this.color(d)};`);
                pills.append("span").attr("class", "name").text((d)=>d);
            }
        });
        this.showMap();
    }
    updateViewport() {
        this.width = this.elements.skillsMap.getBoundingClientRect().width;
        this.height = window.innerHeight * 0.5;
        this.padding = 50;
    }
    showMap() {
        (0, $df5bef30413a053b$export$f0e9d14ede4c01bd)(this.elements.mapPill, false);
        (0, $df5bef30413a053b$export$f0e9d14ede4c01bd)(this.elements.listPill, true);
    }
    showList() {
        (0, $df5bef30413a053b$export$f0e9d14ede4c01bd)(this.elements.mapPill, true);
        (0, $df5bef30413a053b$export$f0e9d14ede4c01bd)(this.elements.listPill, false);
    }
}




const $ddaabac5efedbd45$export$e1252723db1c541 = {
    container: "section.intro",
    decorations: "section.intro .decorations-layer .decoration",
    pills: "section.intro .pill[data-target]"
};
function $ddaabac5efedbd45$export$2cd8252107eb640b(selectors) {
    const container = (0, $df5bef30413a053b$export$836aee6bce45247)(selectors.container);
    const decorations = (0, $df5bef30413a053b$export$9ca9051b92b5a6d2)(selectors.decorations);
    const pills = (0, $df5bef30413a053b$export$9ca9051b92b5a6d2)(selectors.pills);
    // Mouse: very slow, dreamy glide
    const mousePosition = new (0, $745f816836c85b06$export$2e2bcd8739ae039)([
        0,
        0
    ], 0.01);
    // Scroll: snappier — reacts faster but still smoothed
    const scrollPosition = new (0, $745f816836c85b06$export$2e2bcd8739ae039)([
        0
    ], 0.08);
    window.addEventListener("pointermove", (e)=>{
        mousePosition.setValue([
            e.clientX,
            e.clientY
        ]);
    });
    pills.forEach((pill)=>{
        pill.addEventListener("click", ()=>{
            (0, $df5bef30413a053b$export$3f99968195accfaf)(pill.dataset.target);
        });
    });
    const TARGET_FRAME_MS = 1000 / 60;
    let lastTimestamp = null;
    update(performance.now());
    function update(timestamp) {
        const elapsed = lastTimestamp !== null ? timestamp - lastTimestamp : TARGET_FRAME_MS;
        lastTimestamp = timestamp;
        const dt = Math.min(elapsed / TARGET_FRAME_MS, 4);
        mousePosition.tick(dt);
        const containerRect = container.getBoundingClientRect();
        // Feed scroll from containerRect.top — works regardless of which
        // element is the scroll container (safe with overflow-x:hidden on html).
        scrollPosition.setValue([
            -containerRect.top
        ]);
        scrollPosition.tick(dt);
        const cx = containerRect.left + containerRect.width / 2;
        const cy = containerRect.top + containerRect.height / 2;
        const mouseOffset = [
            (mousePosition.value[0] - cx) / containerRect.width,
            (mousePosition.value[1] - cy) / containerRect.height
        ];
        const scrollOffset = scrollPosition.value[0] / containerRect.height;
        const scale = containerRect.width;
        const isPortrait = window.innerHeight > window.innerWidth;
        const scrollMultiplier = isPortrait ? 0.3 : 0.02;
        for (const decoration of decorations){
            const force = parseInt(decoration.dataset.force) / 1000;
            const tx = mouseOffset[0] * force * scale;
            const ty = mouseOffset[1] * force * scale + scrollOffset * force * scale * scrollMultiplier;
            decoration.style.transform = `translate(${tx.toFixed(1)}px, ${ty.toFixed(1)}px)`;
        }
        window.requestAnimationFrame(update);
    }
}



var $5c802cafad583260$exports = {};
!function(e, t) {
    $5c802cafad583260$exports = t();
}($5c802cafad583260$exports, function() {
    return function(e) {
        function t(o) {
            if (n[o]) return n[o].exports;
            var i = n[o] = {
                exports: {},
                id: o,
                loaded: !1
            };
            return e[o].call(i.exports, i, i.exports, t), i.loaded = !0, i.exports;
        }
        var n = {};
        return t.m = e, t.c = n, t.p = "dist/", t(0);
    }([
        function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var i = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var o in n)Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
                }
                return e;
            }, r = n(1), a = (o(r), n(6)), u = o(a), c = n(7), s = o(c), f = n(8), d = o(f), l = n(9), p = o(l), m = n(10), b = o(m), v = n(11), y = o(v), g = n(14), h = o(g), w = [], k = !1, x = {
                offset: 120,
                delay: 0,
                easing: "ease",
                duration: 400,
                disable: !1,
                once: !1,
                startEvent: "DOMContentLoaded",
                throttleDelay: 99,
                debounceDelay: 50,
                disableMutationObserver: !1
            }, j = function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (e && (k = !0), k) return w = (0, y.default)(w, x), (0, b.default)(w, x.once), w;
            }, O = function() {
                w = (0, h.default)(), j();
            }, M = function() {
                w.forEach(function(e, t) {
                    e.node.removeAttribute("data-aos"), e.node.removeAttribute("data-aos-easing"), e.node.removeAttribute("data-aos-duration"), e.node.removeAttribute("data-aos-delay");
                });
            }, S = function(e) {
                return e === !0 || "mobile" === e && p.default.mobile() || "phone" === e && p.default.phone() || "tablet" === e && p.default.tablet() || "function" == typeof e && e() === !0;
            }, _ = function(e) {
                x = i(x, e), w = (0, h.default)();
                var t = document.all && !window.atob;
                return S(x.disable) || t ? M() : (x.disableMutationObserver || d.default.isSupported() || (console.info('\n      aos: MutationObserver is not supported on this browser,\n      code mutations observing has been disabled.\n      You may have to call "refreshHard()" by yourself.\n    '), x.disableMutationObserver = !0), document.querySelector("body").setAttribute("data-aos-easing", x.easing), document.querySelector("body").setAttribute("data-aos-duration", x.duration), document.querySelector("body").setAttribute("data-aos-delay", x.delay), "DOMContentLoaded" === x.startEvent && [
                    "complete",
                    "interactive"
                ].indexOf(document.readyState) > -1 ? j(!0) : "load" === x.startEvent ? window.addEventListener(x.startEvent, function() {
                    j(!0);
                }) : document.addEventListener(x.startEvent, function() {
                    j(!0);
                }), window.addEventListener("resize", (0, s.default)(j, x.debounceDelay, !0)), window.addEventListener("orientationchange", (0, s.default)(j, x.debounceDelay, !0)), window.addEventListener("scroll", (0, u.default)(function() {
                    (0, b.default)(w, x.once);
                }, x.throttleDelay)), x.disableMutationObserver || d.default.ready("[data-aos]", O), w);
            };
            e.exports = {
                init: _,
                refresh: j,
                refreshHard: O
            };
        },
        function(e, t) {},
        ,
        ,
        ,
        ,
        function(e, t) {
            (function(t) {
                "use strict";
                function n(e, t, n) {
                    function o(t) {
                        var n = b, o = v;
                        return b = v = void 0, k = t, g = e.apply(o, n);
                    }
                    function r(e) {
                        return k = e, h = setTimeout(f, t), M ? o(e) : g;
                    }
                    function a(e) {
                        var n = e - w, o = e - k, i = t - n;
                        return S ? j(i, y - o) : i;
                    }
                    function c(e) {
                        var n = e - w, o = e - k;
                        return void 0 === w || n >= t || n < 0 || S && o >= y;
                    }
                    function f() {
                        var e = O();
                        return c(e) ? d(e) : void (h = setTimeout(f, a(e)));
                    }
                    function d(e) {
                        return h = void 0, _ && b ? o(e) : (b = v = void 0, g);
                    }
                    function l() {
                        void 0 !== h && clearTimeout(h), k = 0, b = w = v = h = void 0;
                    }
                    function p() {
                        return void 0 === h ? g : d(O());
                    }
                    function m() {
                        var e = O(), n = c(e);
                        if (b = arguments, v = this, w = e, n) {
                            if (void 0 === h) return r(w);
                            if (S) return h = setTimeout(f, t), o(w);
                        }
                        return void 0 === h && (h = setTimeout(f, t)), g;
                    }
                    var b, v, y, g, h, w, k = 0, M = !1, S = !1, _ = !0;
                    if ("function" != typeof e) throw new TypeError(s);
                    return t = u(t) || 0, i(n) && (M = !!n.leading, S = "maxWait" in n, y = S ? x(u(n.maxWait) || 0, t) : y, _ = "trailing" in n ? !!n.trailing : _), m.cancel = l, m.flush = p, m;
                }
                function o(e, t, o) {
                    var r = !0, a = !0;
                    if ("function" != typeof e) throw new TypeError(s);
                    return i(o) && (r = "leading" in o ? !!o.leading : r, a = "trailing" in o ? !!o.trailing : a), n(e, t, {
                        leading: r,
                        maxWait: t,
                        trailing: a
                    });
                }
                function i(e) {
                    var t = "undefined" == typeof e ? "undefined" : c(e);
                    return !!e && ("object" == t || "function" == t);
                }
                function r(e) {
                    return !!e && "object" == ("undefined" == typeof e ? "undefined" : c(e));
                }
                function a(e) {
                    return "symbol" == ("undefined" == typeof e ? "undefined" : c(e)) || r(e) && k.call(e) == d;
                }
                function u(e) {
                    if ("number" == typeof e) return e;
                    if (a(e)) return f;
                    if (i(e)) {
                        var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                        e = i(t) ? t + "" : t;
                    }
                    if ("string" != typeof e) return 0 === e ? e : +e;
                    e = e.replace(l, "");
                    var n = m.test(e);
                    return n || b.test(e) ? v(e.slice(2), n ? 2 : 8) : p.test(e) ? f : +e;
                }
                var c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, s = "Expected a function", f = NaN, d = "[object Symbol]", l = /^\s+|\s+$/g, p = /^[-+]0x[0-9a-f]+$/i, m = /^0b[01]+$/i, b = /^0o[0-7]+$/i, v = parseInt, y = "object" == ("undefined" == typeof t ? "undefined" : c(t)) && t && t.Object === Object && t, g = "object" == ("undefined" == typeof self ? "undefined" : c(self)) && self && self.Object === Object && self, h = y || g || Function("return this")(), w = Object.prototype, k = w.toString, x = Math.max, j = Math.min, O = function() {
                    return h.Date.now();
                };
                e.exports = o;
            }).call(t, function() {
                return this;
            }());
        },
        function(e, t) {
            (function(t) {
                "use strict";
                function n(e, t, n) {
                    function i(t) {
                        var n = b, o = v;
                        return b = v = void 0, O = t, g = e.apply(o, n);
                    }
                    function r(e) {
                        return O = e, h = setTimeout(f, t), M ? i(e) : g;
                    }
                    function u(e) {
                        var n = e - w, o = e - O, i = t - n;
                        return S ? x(i, y - o) : i;
                    }
                    function s(e) {
                        var n = e - w, o = e - O;
                        return void 0 === w || n >= t || n < 0 || S && o >= y;
                    }
                    function f() {
                        var e = j();
                        return s(e) ? d(e) : void (h = setTimeout(f, u(e)));
                    }
                    function d(e) {
                        return h = void 0, _ && b ? i(e) : (b = v = void 0, g);
                    }
                    function l() {
                        void 0 !== h && clearTimeout(h), O = 0, b = w = v = h = void 0;
                    }
                    function p() {
                        return void 0 === h ? g : d(j());
                    }
                    function m() {
                        var e = j(), n = s(e);
                        if (b = arguments, v = this, w = e, n) {
                            if (void 0 === h) return r(w);
                            if (S) return h = setTimeout(f, t), i(w);
                        }
                        return void 0 === h && (h = setTimeout(f, t)), g;
                    }
                    var b, v, y, g, h, w, O = 0, M = !1, S = !1, _ = !0;
                    if ("function" != typeof e) throw new TypeError(c);
                    return t = a(t) || 0, o(n) && (M = !!n.leading, S = "maxWait" in n, y = S ? k(a(n.maxWait) || 0, t) : y, _ = "trailing" in n ? !!n.trailing : _), m.cancel = l, m.flush = p, m;
                }
                function o(e) {
                    var t = "undefined" == typeof e ? "undefined" : u(e);
                    return !!e && ("object" == t || "function" == t);
                }
                function i(e) {
                    return !!e && "object" == ("undefined" == typeof e ? "undefined" : u(e));
                }
                function r(e) {
                    return "symbol" == ("undefined" == typeof e ? "undefined" : u(e)) || i(e) && w.call(e) == f;
                }
                function a(e) {
                    if ("number" == typeof e) return e;
                    if (r(e)) return s;
                    if (o(e)) {
                        var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                        e = o(t) ? t + "" : t;
                    }
                    if ("string" != typeof e) return 0 === e ? e : +e;
                    e = e.replace(d, "");
                    var n = p.test(e);
                    return n || m.test(e) ? b(e.slice(2), n ? 2 : 8) : l.test(e) ? s : +e;
                }
                var u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, c = "Expected a function", s = NaN, f = "[object Symbol]", d = /^\s+|\s+$/g, l = /^[-+]0x[0-9a-f]+$/i, p = /^0b[01]+$/i, m = /^0o[0-7]+$/i, b = parseInt, v = "object" == ("undefined" == typeof t ? "undefined" : u(t)) && t && t.Object === Object && t, y = "object" == ("undefined" == typeof self ? "undefined" : u(self)) && self && self.Object === Object && self, g = v || y || Function("return this")(), h = Object.prototype, w = h.toString, k = Math.max, x = Math.min, j = function() {
                    return g.Date.now();
                };
                e.exports = n;
            }).call(t, function() {
                return this;
            }());
        },
        function(e, t) {
            "use strict";
            function n(e) {
                var t = void 0, o = void 0, i = void 0;
                for(t = 0; t < e.length; t += 1){
                    if (o = e[t], o.dataset && o.dataset.aos) return !0;
                    if (i = o.children && n(o.children)) return !0;
                }
                return !1;
            }
            function o() {
                return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
            }
            function i() {
                return !!o();
            }
            function r(e, t) {
                var n = window.document, i = o(), r = new i(a);
                u = t, r.observe(n.documentElement, {
                    childList: !0,
                    subtree: !0,
                    removedNodes: !0
                });
            }
            function a(e) {
                e && e.forEach(function(e) {
                    var t = Array.prototype.slice.call(e.addedNodes), o = Array.prototype.slice.call(e.removedNodes), i = t.concat(o);
                    if (n(i)) return u();
                });
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var u = function() {};
            t.default = {
                isSupported: i,
                ready: r
            };
        },
        function(e, t) {
            "use strict";
            function n(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }
            function o() {
                return navigator.userAgent || navigator.vendor || window.opera || "";
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = function() {
                function e(e, t) {
                    for(var n = 0; n < t.length; n++){
                        var o = t[n];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
                    }
                }
                return function(t, n, o) {
                    return n && e(t.prototype, n), o && e(t, o), t;
                };
            }(), r = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i, a = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i, u = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i, c = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i, s = function() {
                function e() {
                    n(this, e);
                }
                return i(e, [
                    {
                        key: "phone",
                        value: function() {
                            var e = o();
                            return !(!r.test(e) && !a.test(e.substr(0, 4)));
                        }
                    },
                    {
                        key: "mobile",
                        value: function() {
                            var e = o();
                            return !(!u.test(e) && !c.test(e.substr(0, 4)));
                        }
                    },
                    {
                        key: "tablet",
                        value: function() {
                            return this.mobile() && !this.phone();
                        }
                    }
                ]), e;
            }();
            t.default = new s;
        },
        function(e, t) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = function(e, t, n) {
                var o = e.node.getAttribute("data-aos-once");
                t > e.position ? e.node.classList.add("aos-animate") : "undefined" != typeof o && ("false" === o || !n && "true" !== o) && e.node.classList.remove("aos-animate");
            }, o = function(e, t) {
                var o = window.pageYOffset, i = window.innerHeight;
                e.forEach(function(e, r) {
                    n(e, i + o, t);
                });
            };
            t.default = o;
        },
        function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(12), r = o(i), a = function(e, t) {
                return e.forEach(function(e, n) {
                    e.node.classList.add("aos-init"), e.position = (0, r.default)(e.node, t.offset);
                }), e;
            };
            t.default = a;
        },
        function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(13), r = o(i), a = function(e, t) {
                var n = 0, o = 0, i = window.innerHeight, a = {
                    offset: e.getAttribute("data-aos-offset"),
                    anchor: e.getAttribute("data-aos-anchor"),
                    anchorPlacement: e.getAttribute("data-aos-anchor-placement")
                };
                switch(a.offset && !isNaN(a.offset) && (o = parseInt(a.offset)), a.anchor && document.querySelectorAll(a.anchor) && (e = document.querySelectorAll(a.anchor)[0]), n = (0, r.default)(e).top, a.anchorPlacement){
                    case "top-bottom":
                        break;
                    case "center-bottom":
                        n += e.offsetHeight / 2;
                        break;
                    case "bottom-bottom":
                        n += e.offsetHeight;
                        break;
                    case "top-center":
                        n += i / 2;
                        break;
                    case "bottom-center":
                        n += i / 2 + e.offsetHeight;
                        break;
                    case "center-center":
                        n += i / 2 + e.offsetHeight / 2;
                        break;
                    case "top-top":
                        n += i;
                        break;
                    case "bottom-top":
                        n += e.offsetHeight + i;
                        break;
                    case "center-top":
                        n += e.offsetHeight / 2 + i;
                }
                return a.anchorPlacement || a.offset || isNaN(t) || (o = t), n + o;
            };
            t.default = a;
        },
        function(e, t) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = function(e) {
                for(var t = 0, n = 0; e && !isNaN(e.offsetLeft) && !isNaN(e.offsetTop);)t += e.offsetLeft - ("BODY" != e.tagName ? e.scrollLeft : 0), n += e.offsetTop - ("BODY" != e.tagName ? e.scrollTop : 0), e = e.offsetParent;
                return {
                    top: n,
                    left: t
                };
            };
            t.default = n;
        },
        function(e, t) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = function(e) {
                return e = e || document.querySelectorAll("[data-aos]"), Array.prototype.map.call(e, function(e) {
                    return {
                        node: e
                    };
                });
            };
            t.default = n;
        }
    ]);
});




var $jFoOd = parcelRequire("jFoOd");
function $0ef3985d1d14e7fe$export$889ea624f2cb2c57() {
    window.addEventListener("DOMContentLoaded", ()=>{
        $0ef3985d1d14e7fe$var$reduceSplitterContents();
        (0, $jFoOd.initGrainClipping)();
        $0ef3985d1d14e7fe$var$redrawSVGViewBoxes();
        (0, (/*@__PURE__*/$parcel$interopDefault($5c802cafad583260$exports))).init({
            duration: 400,
            easing: "ease-out-sine"
        });
    });
}
/**
 * For smaller devices, reduces the amount of nodes
 * used in section splitters to reduce the rasterisation load.
 */ function $0ef3985d1d14e7fe$var$reduceSplitterContents() {
    const splitters = Array.from(document.querySelectorAll("section.splitter"));
    for (const splitter of splitters){
        const circles = Array.from(splitter.querySelectorAll(".circle"));
        const desiredCount = Math.floor((0, $df5bef30413a053b$export$871de8747c9eaa88)(window.innerWidth, [
            400,
            1000
        ], [
            10,
            30
        ]));
        let difference = circles.length - desiredCount;
        while(difference > 0){
            const circle = (0, $df5bef30413a053b$export$4154a199d7d90455)(circles);
            circle.parentNode.removeChild(circle);
            circles.splice(circles.indexOf(circle), 1);
            difference--;
        }
    }
}
/**
 * Shrinks the viewboxes of contact icons replacing built-in values.
 */ function $0ef3985d1d14e7fe$var$redrawSVGViewBoxes() {
    const icons = Array.from(document.querySelectorAll("section.contacts ul.links svg"));
    icons.map((svg)=>svg.setAttribute("viewBox", "-6 -6 36 36"));
}


// Run post-processing of DOM
$0ef3985d1d14e7fe$export$889ea624f2cb2c57();
// Modules are written in procedural style
$ddaabac5efedbd45$export$2cd8252107eb640b($ddaabac5efedbd45$export$e1252723db1c541);
// Module is written in 'classical' style,
// hence slightly different init procedure
new (0, $a1a98d7d3aaecbf6$export$2e2bcd8739ae039)().init();
new (0, $3f0bb8abbf50d958$export$2e2bcd8739ae039)().init();


//# sourceMappingURL=index.0e3467d6.js.map
